{
  "STORE_PRICING_SETTINGS": {
    "SHOW_COST_DETAILS": "Afficher le détail des coûts au survol du forfait",
    "ALLOW_CODE_ADJUSTMENT": "Afficher le champ de modification du forfait par code"
  },
  "repairFileWorkflow": {
    "steps": {
      "availability": "Client informé de la disponibilité",
      "customerReturn": "Transport retour chez le client"
    },
    "declaration": {
      "option": "Décision déclarée (facultatif)",
      "recipient": "Destinataire de l’envoi déclaré",
      "optionalDecision": "Sans décision renseignée, l’étape sera enregistrée sans preuve de transmission. La date sélectionnée est la date déclarée."
    },
    "title": "Vos prochaines actions",
    "nextAction": "VOTRE PROCHAINE ACTION : {action}",
    "pastAction": "ACTION À CETTE ÉTAPE : {action}",
    "noValue": "Non renseigné",
    "remindersActive": "Relances automatiques activées.",
    "remindersActiveSince": "Relances automatiques activées depuis le {date}.",
    "options": {
      "OPTION_1": "Forfait de réparation",
      "OPTION_2": "Diagnostic et devis",
      "OPTION_3": "Recyclage",
      "CREDIT_OR_REFUND": "Avoir / remboursement",
      "PRODUCT_REPLACEMENT": "Échange par un produit neuf",
      "PRODUCT_REPAIR_WITHOUT_GUARANTEE": "Demande de retour du produit pour diagnostic",
      "PRODUCT_REPAIR_WITH_GUARANTEE": "Réparation sous garantie",
      "TECHNICIAN_ON_SITE_INTERVENTION": "Intervention d’un technicien sur site",
      "REJECT_PROSPECT": "Refus de prise en charge",
      "OTHER": "Autre",
      "DIAGNOSIS": "Diagnostic et devis",
      "ON_SITE": "Intervention d’un technicien sur site"
    },
    "events": {
      "PRELIMINARY_INFORMATION_RECEIVED": "INFORMATIONS COMPLÉMENTAIRES SUR LA RÉPONSE RÉPARATEUR. N° de demande : {request_number}. Commentaire : {comment}",
      "FILE_CLOSED_DECLARED": "12. DOSSIER CLÔTURÉ MANUELLEMENT par {actor} le {date}. Aucune confirmation de réception du client n’est déduite de cette clôture.",
      "CUSTOMER_AVAILABILITY_DECLARED": "11a. INFORMATION CLIENT SUR LA DISPONIBILITÉ DÉCLARÉE par {actor}. Produit disponible au dépôt {depot}.",
      "CUSTOMER_DECISION_FORWARDED_TO_STORE": "7. DÉCISION TRANSMISE PAR LE SYSTÈME AU MAGASIN à {recipient} : {option}. L’envoi au réparateur reste à déclarer.",
      "BREAKDOWN_REPORTED": "PROBLÈME SIGNALÉ par {actor} : {description}.",
      "FILE_CREATION_STARTED": "1. DOSSIER EN COURS DE CRÉATION chez {depot}.",
      "PACKAGE_PROPOSAL_SENT": "PROPOSITION DE FORFAIT ENVOYÉE à {recipient}. EN ATTENTE — CLIENT : choix de la suite de la prise en charge.",
      "PACKAGE_DECISION_RECEIVED": "DÉCISION CLIENT REÇUE PAR EMAIL : {option}.",
      "PRELIMINARY_REQUEST_SENT": "DEMANDE PRÉALABLE ENVOYÉE à {recipient}. N° de demande : {request_number}. EN ATTENTE — RÉPARATEUR : réponse sur la prise en charge.",
      "PRELIMINARY_RESPONSE_RECEIVED": "RÉPONSE RÉPARATEUR REÇUE PAR EMAIL : {option}. N° de demande : {request_number}.",
      "PRELIMINARY_RESPONSE_DECLARED": "RÉPONSE RÉPARATEUR DÉCLARÉE par {actor} : {option}. N° de demande : {request_number}.",
      "TRANSPORT_LABELS_REQUESTED": "DEMANDE D’ÉTIQUETTES ENVOYÉE à {recipient}. EN ATTENTE — PARTENAIRE : émission des étiquettes.",
      "OUTBOUND_TRANSPORT_STARTED": "2. TRANSPORT ALLER DÉCLENCHÉ : {departure} vers {repairer} depuis le {date}. EN ATTENTE : enlèvement et confirmation de réception chez le réparateur.",
      "REPAIRER_RECEIPT_RECORDED": "3. PRODUIT REÇU CHEZ {repairer} depuis le {date}. EN ATTENTE — RÉPARATEUR : diagnostic et proposition de prise en charge.",
      "REPAIRER_ESTIMATE_REPORTED_SENT": "4. DEVIS RÉPARATEUR ENVOYÉ à {recipient} depuis le {date}.",
      "REPAIRER_ESTIMATE_INTEGRATED": "5. DEVIS RÉPARATEUR INTÉGRÉ AU DOSSIER.",
      "CUSTOMER_ESTIMATE_SENT": "6. DEVIS ENVOYÉ AU CLIENT à {recipient} PAR LE SYSTÈME. EN ATTENTE — CLIENT : décision sur le devis.",
      "CUSTOMER_ESTIMATE_SEND_DECLARED": "6. ENVOI DU DEVIS AU CLIENT DÉCLARÉ par {actor} le {date}. Destinataire : {recipient}. Aucun envoi ni relance automatique par la plateforme. EN ATTENTE — CLIENT : décision sur le devis.",
      "CUSTOMER_DECISION_SENT_TO_REPAIRER": "7. DÉCISION CLIENT REÇUE ET ENVOYÉE AU RÉPARATEUR PAR LE SYSTÈME : {option}. EN ATTENTE — RÉPARATEUR : traitement de la décision.",
      "CUSTOMER_DECISION_SEND_DECLARED": "7. ENVOI DE LA DÉCISION AU RÉPARATEUR DÉCLARÉ par {actor} : {option}. Aucune validation client par email enregistrée dans la plateforme.",
      "CUSTOMER_DECISION_TRANSMISSION_UNVERIFIED": "7. TRANSMISSION DE LA DÉCISION DÉCLARÉE SANS ENVOI PAR LA PLATEFORME.",
      "REPAIR_STARTED": "8. RÉPARATION EN COURS chez {repairer} depuis le {date}. EN ATTENTE — RÉPARATEUR : fin de l’intervention.",
      "REPAIR_PARTS_ORDERED": "8. PIÈCES COMMANDÉES par {repairer} depuis le {date}. EN ATTENTE : réception des pièces pour poursuivre la réparation.",
      "REPAIRER_RETURN_STARTED": "9. TRANSPORT RETOUR DÉCLENCHÉ PAR {repairer} vers {destination}. EN ATTENTE — DESTINATAIRE : confirmation de réception.",
      "NO_RETURN_TREATMENT_FINALIZED": "9. TRAITEMENT FINALISÉ PAR {repairer} : {option}.",
      "DEPOT_RECEIPT_RECORDED": "10. PRODUIT REÇU AU DÉPÔT {depot}.",
      "CUSTOMER_AVAILABILITY_NOTIFIED": "11a. CLIENT INFORMÉ DE LA DISPONIBILITÉ DU PRODUIT AU DÉPÔT {depot}. EN ATTENTE — CLIENT : récupération du produit.",
      "CUSTOMER_RETURN_DISPATCHED": "11b. TRANSPORT RETOUR VERS {customer_site} DÉCLENCHÉ. EN ATTENTE — CLIENT : confirmation de réception après livraison.",
      "FILE_CLOSED_WITH_RETURN": "12. REMISE / RÉCEPTION DÉCLARÉE PAR {actor} le {date}. DOSSIER CLÔTURÉ. Solution : {option}.",
      "FILE_CLOSED_WITHOUT_RETURN": "12. TRAITEMENT SANS RESTITUTION FINALISÉ : {option}. DOSSIER CLÔTURÉ.",
      "BILLING_STAGE_ENTERED": "13. FACTURATION.",
      "FILE_FINISHED": "14. DOSSIER TERMINÉ. Intervention clôturée et traitement du dossier finalisé.",
      "PACKAGE_PROPOSAL_QUEUED": "Proposition de forfait préparée. Envoi au client en attente.",
      "PRELIMINARY_REQUEST_QUEUED": "Demande préalable préparée. Envoi au réparateur en attente.",
      "CUSTOMER_ESTIMATE_QUEUED": "Devis préparé. Envoi au client en attente.",
      "CUSTOMER_DECISION_QUEUED": "Décision enregistrée : {option}. Transmission par la plateforme en attente.",
      "CUSTOMER_RETURN_DELIVERED": "Le transporteur signale la livraison au client le {date}. La clôture reste manuelle.",
      "CUSTOMER_RECEIPT_SMS_SENT": "SMS envoyé au {phone} pour confirmation de réception du produit, le {date}.",
      "CUSTOMER_RECEIPT_CONFIRMED": "Le client confirme avoir réceptionné le produit le {date}. Photo ci-jointe : Photo client du produit retourné. Commentaire du client : {comment}",
      "FILE_ABANDONED": "Dossier abandonné par le client.",
      "FILE_DELETED": "Dossier supprimé."
    },
    "actionOverrides": {
      "PACKAGE_DECISION_RECEIVED": {
        "CONTINUE_FILE_AND_FINALIZE_TRANSPORT": "poursuivre le dossier et organiser le transport si nécessaire."
      }
    },
    "actions": {
      "COMPLETE_REPAIR_FILE": "compléter le dossier et finaliser la prise en charge.",
      "CONTINUE_FILE_AND_FINALIZE_TRANSPORT": "poursuivre le dossier et finaliser le transport si nécessaire.",
      "CONTINUE_FILE_FROM_REPAIRER_RESPONSE": "poursuivre le dossier selon cette réponse.",
      "INTEGRATE_AND_SEND_CUSTOMER_ESTIMATE": "intégrer le devis et le transmettre au client.",
      "ENTER_ERP_BILLING": "saisir la facturation dans l’ERP.",
      "DESCRIBE_DECISION_TRANSMISSION": "préciser la décision, le destinataire et la date de transmission dans un commentaire.",
      "FINALIZE_FILE_FOR_OUTCOME": "finaliser le dossier selon la solution retenue.",
      "INFORM_CUSTOMER_OR_ARRANGE_RETURN": "informer le client de la disponibilité ou organiser le retour vers son site.",
      "FINALIZE_BILLING_AND_FINISH_FILE": "finaliser le traitement de la facturation, puis terminer le dossier."
    }
  },
  "CUSTOMER_RECEIPT": {
    "TITLE": "Confirmez la réception de votre produit",
    "INSTRUCTIONS": "Afin de déclencher votre extension de garantie, merci de bien vouloir prendre en photo la plaque signalétique du produit réceptionné.",
    "PHOTO_LABEL": "Photo de la plaque signalétique (obligatoire)",
    "DROPZONE_TITLE": "Ajoutez une photo de la plaque signalétique",
    "PHOTO_HINT": "Formats JPG ou PNG · 10 Mo maximum",
    "TAKE_PHOTO": "Prendre une photo",
    "INVALID_PHOTO": "Veuillez sélectionner une photo au format JPG ou PNG.",
    "PHOTO_SIZE": "La photo doit être non vide et ne pas dépasser 10 Mo.",
    "COMMENT_LABEL": "Commentaire (facultatif)",
    "COMMENT_PLACEHOLDER": "Une précision sur la réception de votre produit ?",
    "CONFIRM": "Confirmer la réception de mon produit",
    "SUCCESS_TITLE": "Réception confirmée",
    "SUCCESS_MESSAGE": "Merci ! La réception de votre produit et votre photo ont bien été enregistrées."
  },
  "ATTACHMENT_UPLOAD": {
    "FROM_COMPUTER": "Depuis l'ordinateur",
    "VIA_MOBILE": "Via mobile",
    "LOAD_FAILED": "Impossible de charger le lien d’envoi mobile.",
    "RETRY": "Réessayer",
    "MISSING": "Le fichier n’a pas encore été envoyé.",
    "CONFIRM": "Confirmer l’envoi"
  },
  "LOGIN_PAGE": {
    "TITLE": {
      "HEADER": "Connectez-vous",
      "EMAIL": "Email",
      "PASSWORD": "Mot de passe",
      "LOGIN_2FA": "Vérification 2FA",
      "FIRSTNAME": "Prénom",
      "LASTNAME": "Nom"
    },
    "BUTTON": {
      "ADD_NEW_COLLABORATOR": "Ajouter un collaborateur",
      "ADD_COLLABORATOR": "Ajouter un collaborateur",
      "SUBMIT": "Me connecter",
      "SUBMIT_2FA": "Vérifier le code",
      "RESEND_2FA": "Renvoyer le code",
      "SUBMIT_COLLABORATOR": "S’identifier",
      "FORGOT_PASSWORD": "Mot de passe oublié ?"
    },
    "FORGOT_PASSWORD": {
      "TEXT": "Mot de passe oublié ?",
      "CTA": "Réinitialiser"
    },
    "INPUT": {
      "SELECT_COLLABORATOR": "Sélectionnez un collaborateur",
      "LOGIN_2FA_CODE": "Code de vérification reçu par email"
    },
    "MESSAGE": {
      "SUCCESS": "Connexion réussie",
      "ERROR": "Identifiant incorrect",
      "LOGIN_2FA_SENT": "Un code de vérification vous a été envoyé par email"
    },
    "PLACEHOLDER": {
      "EMAIL": "Ex : contact{'@'}boomerang.com",
      "PASSWORD": "Saisir votre mot de passe",
      "SELECT_COLLABORATOR": "Sélectionner un collaborateur",
      "FIRSTNAME": "Ex : Marie",
      "LASTNAME": "Ex : Dupont"
    }
  },
  "LOGIN_ADD_COLLABORATOR": {
    "MESSAGE": {
      "SUCCESS": "Le collaborateur a été ajouté avec succès",
      "ERROR": "Impossible d'ajouter le collaborateur"
    }
  },
  "LOGIN_FORGOT_PASSWORD": {
    "TITLE": {
      "HEADER": "Modifier votre mot de passe",
      "EMAIL": "Email"
    },
    "BUTTON": {
      "SUBMIT": "Envoyer ma demande",
      "RETURN": "Retour"
    },
    "MESSAGE": {
      "SUCCESS": "Une demande de réinitialisation de mot de passe a été envoyé à l'email saisie si le mail est rattaché à un compte Boomerang.",
      "ERROR": {
        "CAPTCHA_TOKEN": "Captcha invalide"
      }
    },
    "PLACEHOLDER": {
      "EMAIL": "Ex : contact{'@'}exemple.fr"
    }
  },
  "RESET_PASSWORD": {
    "TITLE": "Renseignez votre mot de passe",
    "PASSWORD": "Nouveau mot de passe",
    "CONFIRM_PASSWORD": "Confirmez votre mot de passe",
    "SUCCESS": "Mot de passe changée avec succès",
    "ERROR": "Nous n'avons pas pu valider votre demande, car elle a dépassé les 60 minutes. Merci de refaire une demande de réinitialisation de mot de passe.",
    "BUTTON": {
      "SUBMIT": "Réinitialiser mon mot de passe",
      "RETURN": "Retour"
    },
    "PLACEHOLDER": {
      "PASSWORD": "Saisir votre mot de passe",
      "CONFIRM_PASSWORD": "Confirmer votre mot de passe"
    }
  },
  "INIT_PASSWORD": {
    "TITLE": "Renseignez votre mot de passe",
    "PASSWORD": "Nouveau mot de passe",
    "CONFIRM_PASSWORD": "Confirmez votre mot de passe",
    "SUCCESS": "Mot de passe crée avec succès",
    "ERROR": "Nous n'avons pas pu valider votre demande, car elle a dépassé les 7 jours. Merci de refaire une demande de réinitialisation de mot de passe.",
    "BUTTON": {
      "SUBMIT": "Modifier",
      "RETURN": "Retour"
    },
    "PLACEHOLDER": {
      "PASSWORD": "Saisir votre mot de passe",
      "CONFIRM_PASSWORD": "Confirmer votre mot de passe"
    }
  },
  "ERROR_INPUT": {
    "SMS_MOBILE_NUMBER": "Ce N° de téléphone n'est pas valable pour l'envoi du SMS prevenant votre client. Rentrez à la place un numero commencant par 06 ou 07 ou Selectionnez l'option \"APPEL\"",
    "EMAIL": {
      "EMPTY": "L'email ne peut pas être vide",
      "INVALID": "Entrez un email valide"
    },
    "SIRET": {
      "INVALID": "Entrez un numéro de SIRET valide"
    },
    "PHONE": "Le champ du téléphone n'est pas dans le bon format",
    "MOBILE_PHONE": "Le numéro de téléphone doit commencer par 06 ou 07",
    "PASSWORD": {
      "EMPTY": "Le mot de passe ne peut pas être vide",
      "ERROR_LENGTH": "Longueur minimum 12 caractères",
      "ERROR_UPPERCASE": "Doit contenir au moins une lettre majuscule",
      "ERROR_LOWERCASE": "Doit contenir au moins une lettre minuscule",
      "ERROR_DIGIT": "Doit contenir au moins un chiffre",
      "ERROR_SPECIAL_CHAR": "Doit contenir au moins un des caractères spéciaux suivant : {'!@#$%^&*(),.?\":{}|<>'}",
      "DIFFERENT_PASSWORD": "Les mots de passe doivent être identiques"
    },
    "PHONE_NUMBER": "Le champ n'est pas un numéro de téléphone valide (exemple : 01 23 45 67 89).",
    "EMPTY": "Le champ ne peut pas être vide",
    "MAX_LENGTH": "Le nombre de caractères maximum a été dépassé",
    "NOT_A_NUMBER": "Le champ doit être un nombre.",
    "MARGIN_MAX_VALUE": "La valeur doit être inférieure ou égale à 60",
    "SERIAL_NUMBER_NOT_FOUND": "Numéro de série inconnu",
    "SERIAL_NUMBER_NOT_GOOD_FORMAT": "Le numéro doit comporter {value} caractères",
    "FILE": {
      "HEAVY": "Taille du fichier trop grande"
    },
    "POSITIVE_VALUE": "Valeur positive ou égal à 0.",
    "RATING": "La valeur doit être comprise en 0 et 10"
  },
  "MANAGEMENT_PAGE": {
    "TITLE": {
      "HEADER_USER": "Utilisateurs",
      "HEADER_ROLE": "Rôles"
    },
    "SUBTITLE": {
      "HEADER_USER": "Liste des comptes utilisateurs",
      "HEADER_ROLE": "Liste des rôles"
    },
    "BUTTON": {
      "NEW_ROLE": "Nouveau rôle",
      "NEW_ACCOUNT": "Nouvel utilisateur",
      "ROLE": "Rôles",
      "ACCOUNT": "Utilisateurs",
      "ACTION_HISTORY": "Historique d'actions",
      "BILLINGS": "Facturations"
    }
  },
  "ACCOUNT_PAGE": {
    "PLACEHOLDER": {
      "NETWORK": "Sélectionner le réseau",
      "ROLE": "Sélectionner le rôle",
      "STATUS": "Sélectionner le statut"
    },
    "TABLE": {
      "PHOTO": "Photo",
      "ID": "ID",
      "USER": "Utilisateur",
      "APPLICANT": "Demandeur",
      "NETWORK": "Réseau",
      "ROLE": "Rôle",
      "FILE": "Nombre de dossier",
      "GROUPS": "Groupement",
      "STATUS": "Statut",
      "INFO_QUALITY": "Formation",
      "DESCRIPTION": "Description",
      "SUB_STATUS": "Sous-statut",
      "ACTIVATED_DATE": "Date d'activation"
    },
    "MODAL": {
      "TITLE": "Supprimer un compte",
      "MESSAGE": "Voulez-vous vraiment supprimer le compte {accountEmail}?",
      "WARNING": "Cette action est irréversible."
    },
    "MESSAGE": {
      "SUCCESS_DELETED": "Le compte a été supprimé avec succès"
    }
  },
  "ACCOUNT_TYPES": {
    "ADMIN": "Administrateur",
    "DISTRIBUTOR": "Distributeur",
    "KEY_ACCOUNT": "Grand compte",
    "GLOBAL": "Global"
  },
  "NETWORK_PAGE": {
    "TITLE": {
      "HEADER": "Réseaux distributeurs"
    },
    "TABLE": {
      "ID": "ID",
      "NETWORK": "Réseau",
      "PRIMARY_COLOR": "Couleur principale",
      "SECONDARY_COLOR": "Couleur secondaire",
      "STATUS": "Statut",
      "NAMEPLATE_LOGIN_ID": "Identifiant plaque signalétique"
    },
    "MODAL": {
      "DEACTIVATION": {
        "TITLE": "Désactiver un réseau",
        "MESSAGE": "Cette action va bloquer tous les groupes, magasins et comptes lié à ce réseau",
        "WARNING": "Voulez-vous vraiment désactiver le réseau {network}?",
        "VALIDATION_BUTTON": "Désactiver"
      },
      "REACTIVATION": {
        "TITLE": "Réactiver un réseau",
        "MESSAGE": "Voulez-vous vraiment réactiver le réseau {network}?",
        "VALIDATION_BUTTON": "Réactiver"
      }
    },
    "BUTTON": {
      "NEW_NETWORK": "Nouveau réseau",
      "DEACTIVATION": "Désactiver",
      "REACTIVATION": "Réactiver"
    },
    "MESSAGE": {
      "SUCCESS_DEACTIVATION": "Le réseau a été désactivé avec succès",
      "SUCCESS_REACTIVATION": "Le réseau a été réactivé avec succès"
    },
    "EXPORT_SUCCESS": "L'export des réseaux a été effectué et sera envoyé par mail"
  },
  "CREATE_ACCOUNT_PAGE": {
    "TITLE": {
      "HEADER": "Nouvel utilisateur",
      "SUBTITLE": "Formulaire d'ajout d'un utilisateur",
      "STORE_GROUP_USAGE_DETAIL": "Renseignez soit le groupement, soit le magasin.\nÀ la sélection du groupement, tous les magasins rattachés à ce groupement seront automatiquement sélectionnés.",
      "KEY_ACCOUNT_GROUP_USAGE_DETAIL": "Renseignez soit le groupement, soit le centre d'exploitation.\nÀ la sélection du groupement, tous les centres d'exploitation rattachés à ce groupement seront automatiquement sélectionnés."
    },
    "FORM": {
      "ACCOUNT_INFO": "Information demandeur",
      "USER_SCOPE": "Périmètre utilisateur",
      "ADDITIONAL_INFO": "Information complémentaire",
      "LABEL_ACCOUNT_TYPE": "Type de compte",
      "LABEL_FIRSTNAME": "Prénom",
      "LABEL_LASTNAME": "Nom",
      "LABEL_PHONE": "Téléphone",
      "LABEL_EMAIL": "Login / Email",
      "LABEL_APPLICANT_EMAIL": "Email demandeur",
      "LABEL_FORMATION_ONE": "Formation 1",
      "LABEL_FORMATION_TWO": "Formation 2",
      "LABEL_FORMATION_THREE": "Formation 3",
      "LABEL_DESCRIPTION": "Description",
      "LABEL_SUB_STATUS": "Sous-statut",
      "LABEL_ROLE": "Rôle",
      "LABEL_NETWORK": "Réseau",
      "LABEL_GROUPS": "Groupements",
      "LABEL_STORES": "Magasins",
      "LABEL_OPERATING_CENTERS": "Centres d'exploitation",
      "LABEL_REGION_CODE": "Zone",
      "LABEL_BILLING": "Facturation",
      "LABEL_COLLABORATION_MODE": "Structure du compte",
      "SOLO": "Compte simple",
      "MULTIPLE": "Compte multiple"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'ajout de l'utilisateur"
    },
    "MESSAGE": {
      "SUCCESS": "Le compte a été ajouté avec succès"
    },
    "ERROR": {
      "NO_NETWORK": "Aucun réseau"
    },
    "PLACEHOLDER": {
      "ACCOUNT_TYPE": "Sélectionner un type de compte",
      "COLLABORATION_MODE": "Sélectionner une structure de compte",
      "LASTNAME": "Ex : Dupont",
      "FIRSTNAME": "Ex : Marie",
      "PHONE": "Ex : 01 23 45 67 89",
      "EMAIL": "Ex : contact{'@'}exemple.fr",
      "APPLICANT_EMAIL": "Ex : contact{'@'}exemple.fr",
      "FORMATION_ONE": "Décrire la première information de formation",
      "FORMATION_TWO": "Décrire la deuxième information de formation",
      "FORMATION_THREE": "Décrire la troisième information de formation",
      "DESCRIPTION": "Décrire les informations utiles",
      "SUB_STATUS": "Préciser le sous-statut du compte",
      "ROLE": "Sélectionner un rôle",
      "NETWORK": "Sélectionner un réseau",
      "BILLING": "Sélectionner une facturation",
      "REGION_CODE": "Sélectionner une zone",
      "GROUPS": "Sélectionner un ou plusieurs groupements",
      "STORES": "Sélectionner un ou plusieurs magasins",
      "OPERATING_CENTERS": "Sélectionner un ou plusieurs centres d'exploitation"
    }
  },
  "EDIT_ACCOUNT_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'un utilisateur",
      "SUBTITLE": "Formulaire d'édition d'un utilisateur"
    },
    "FORM": {
      "LABEL_ACCOUNT_TYPE": "Type de compte",
      "ACCOUNT_INFO": "Information demandeur",
      "ADDITIONAL_INFO": "Information complémentaire",
      "USER_SCOPE": "Périmètre utilisateur",
      "LABEL_ID": "ID",
      "LABEL_PHONE": "Téléphone",
      "LABEL_EMAIL": "Login / Email",
      "LABEL_APPLICANT_EMAIL": "Email demandeur",
      "LABEL_FORMATION_ONE": "Formation 1",
      "LABEL_FORMATION_TWO": "Formation 2",
      "LABEL_FORMATION_THREE": "Formation 3",
      "LABEL_DESCRIPTION": "Description",
      "LABEL_SUB_STATUS": "Sous-statut",
      "LABEL_STATUS": "Statut",
      "LABEL_ROLE": "Rôle",
      "LABEL_NETWORK": "Réseau",
      "LABEL_GROUPS": "Groupements",
      "LABEL_STORES": "Magasins",
      "LABEL_OPERATING_CENTERS": "Centres d'exploitation",
      "LABEL_BILLING": "Facturation",
      "LABEL_COLLABORATION_MODE": "Structure du compte",
      "SOLO": "Compte simple",
      "MULTIPLE": "Compte multiple"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'édition de l'utilisateur"
    },
    "MESSAGE": {
      "SUCCESS": "L'utilisateur a été modifié avec succès",
      "ERROR": "Impossible de modifier l'utilisateur"
    },
    "PLACEHOLDER": {
      "ACCOUNT_TYPE": "Sélectionner un type de compte",
      "COLLABORATION_MODE": "Sélectionner une structure de compte",
      "PHONE": "Ex : 01 23 45 67 89",
      "APPLICANT_EMAIL": "Ex : contact{'@'}exemple.fr",
      "FORMATION_ONE": "Décrire la première information de formation",
      "FORMATION_TWO": "Décrire la deuxième information de formation",
      "FORMATION_THREE": "Décrire la troisième information de formation",
      "DESCRIPTION": "Décrire les informations utiles",
      "SUB_STATUS": "Préciser le sous-statut du compte",
      "ROLE": "Sélectionner un rôle",
      "NETWORK": "Sélectionner un réseau",
      "BILLING": "Sélectionner une facturation",
      "GROUPS": "Sélectionner un ou plusieurs groupements",
      "STORES": "Sélectionner un ou plusieurs magasins",
      "OPERATING_CENTERS": "Sélectionner un ou plusieurs centres d'exploitation"
    }
  },
  "DETAIL_ACCOUNT_PAGE": {
    "TITLE": {
      "HEADER": "Détail d'un utilisateur",
      "SUB_HEADER": "Utilisateur",
      "GENERAL_INFO": "Informations générales",
      "USER_SCOPE": "Périmètre utilisateur",
      "COLLABORATOR": "Collaborateurs",
      "GROUPS": "Groupements",
      "STORES": "Magasins"
    },
    "LABEL": {
      "ACCOUNT_TYPE": "Type de compte",
      "COLLABORATION_MODE": "Structure du compte",
      "SOLO": "Compte simple",
      "MULTIPLE": "Compte multiple",
      "EMAIL": "Login / Email",
      "APPLICANT_EMAIL": "Email demandeur",
      "PHONE_NUMBER": "Numéro de téléphone",
      "STATUS": "Statut",
      "ROLE": "Rôle",
      "NETWORK": "Réseau",
      "REGION_CODE": "Zone",
      "LASTNAME": "Nom",
      "FIRSTNAME": "Prénom",
      "JOB_DESCRIPTION": "Métier",
      "NOT_SPECIFIED": "Non renseigné",
      "ACTIVATION_DATE": "Date d'activation",
      "FORMATION_ONE": "Formation 1",
      "FORMATION_TWO": "Formation 2",
      "FORMATION_THREE": "Formation 3",
      "DESCRIPTION": "Description",
      "SUB_STATUS": "Sous-statut"
    },
    "TABLE": {
      "LASTNAME": "Nom",
      "FIRSTNAME": "Prénom",
      "JOB_DESCRIPTION": "Métier",
      "STATUS": "Statut",
      "DATE": "Date",
      "GROUP_NAME": "Groupement",
      "STORE_NAME": "Magasin"
    },
    "BUTTON": {
      "NEW_COLLABORATOR": "Ajouter un collaborateur",
      "DEACTIVATE": "Désactiver"
    },
    "SUBTITLE": {
      "HEADER_COLLABORATOR": "Liste des collaborateurs rattachés à {accountEmail}",
      "HEADER_GROUP": "Liste des groupements rattachés à {accountEmail}",
      "HEADER_STORE": "Liste des magasins rattachés à {accountEmail}"
    },
    "MODAL": {
      "TITLE": "Désactiver un collaborateur",
      "MESSAGE": "Voulez-vous vraiment désactiver {collaborator}?",
      "WARNING": "Cette action est irréversible.",
      "VALIDATE": "Désactiver"
    }
  },
  "ROLE_PAGE": {
    "TABLE": {
      "TITLE": "Titre",
      "PERMISSION": "Permission",
      "DISTRIBUTOR": "Distributeur",
      "ADMIN": "Administrateur",
      "KEY_ACCOUNT": "Grand compte"
    },
    "CARD": {
      "ACCOUNTS": "comptes",
      "PERMISSIONS": "permissions"
    },
    "MESSAGE": {
      "SUCCESS": "Le rôle a été supprimé avec succès."
    },
    "MODAL": {
      "TITLE": "Suppression d’un rôle",
      "MESSAGE": "Voulez-vous vraiment supprimer {role}?",
      "WARNING": "Cette action est irréversible."
    }
  },
  "CREATE_ROLE_PAGE": {
    "TITLE": {
      "HEADER": "Nouveau rôle",
      "SUBTITLE": "Formulaire d'ajout d'un rôle"
    },
    "FORM": {
      "INFO_ROLE": "Information rôle",
      "LABEL_ID": "ID",
      "LABEL_TITLE": "Nom du rôle",
      "LABEL_TYPE": "Type du rôle",
      "ADMIN": "Admin",
      "DISTRIBUTOR": "Distributeur",
      "KEY_ACCOUNT": "Grand compte",
      "PERMISSION_LIST": "Liste des permissions",
      "MIN_PERMISSION_WARNING": "* Pour mettre à jour un rôle il faut a minima une permission."
    },
    "ACTIONS": {
      "ACTIVE_PERMISSIONS_COUNT": "{active}/{total} permissions actives",
      "ACTIVATE_ALL": "Tout activer",
      "DEACTIVATE_ALL": "Tout désactiver"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'ajout du rôle"
    },
    "MESSAGE": {
      "SUCCESS": "Le rôle a été ajouté avec succès",
      "ERROR": "Impossible d'ajouter le rôle"
    },
    "PLACEHOLDER": {
      "ID": "Ex : B123456",
      "TITLE": "Saisir un titre clair",
      "TYPE": "Sélectionner un type de rôle"
    }
  },
  "EDIT_ROLE_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'un rôle",
      "SUBTITLE": "Formulaire d'édition d'un rôle"
    },
    "FORM": {
      "INFO_ROLE": "Information rôle",
      "PERMISSION_LIST": "Liste des permissions",
      "MIN_PERMISSION_WARNING": "* Pour mettre à jour un rôle il faut a minima une permission."
    },
    "BUTTON": {
      "VALIDATE": "Valider l'édition du rôle"
    },
    "MESSAGE": {
      "SUCCESS": "Le rôle a été modifié avec succès",
      "ERROR": "Impossible de modifier le rôle"
    }
  },
  "PROFILE_PAGE": {
    "TITLE": {
      "HEADER": "Édition du profil",
      "SUBTITLE": "Formulaire d'édition du profil"
    },
    "TAB": {
      "PERSONAL_INFORMATION": "Informations personnelles",
      "PASSWORD": "Mot de passe",
      "COLLABORATORS": "Liste des collaborateurs"
    },
    "FORM": {
      "PERSONAL_INFO": "Informations personnelles",
      "LABEL_LASTNAME": "Nom",
      "LABEL_FIRSTNAME": "Prénom",
      "LABEL_PHONE": "Téléphone",
      "LABEL_EMAIL_LOGIN": "Email / Login",
      "CONNECTION_INFO": "Mot de passe",
      "LABEL_CURRENT_PASSWORD": "Mot de passe actuel",
      "LABEL_NEW_PASSWORD": "Nouveau mot de passe",
      "LABEL_CONFIRM_PASSWORD": "Confirmation mot de passe"
    },
    "TABLE": {
      "COLLABORATORS": "Collaborateurs",
      "LASTNAME": "Nom",
      "FIRSTNAME": "Prénom",
      "STATUS": "Statut"
    },
    "BUTTON": {
      "UPDATE_COLLABORATOR": "Mettre à jour",
      "VALIDATE": "Valider l'édition du profil",
      "VALIDATE_PASSWORD": "Valider l'édition du mot de passe"
    },
    "MESSAGE": {
      "SUCCESS": "Le profil a été modifié avec succès",
      "ERROR": "Impossible de modifier le profil"
    },
    "PLACEHOLDER": {
      "CURRENT_PASSWORD": "Saisir votre mot de passe",
      "NEW_PASSWORD": "Saisir votre mot de passe",
      "CONFIRM_PASSWORD": "Confirmer votre mot de passe",
      "PHONE": "Ex : 01 23 45 67 89"
    }
  },
  "PROFILE_COLLABORATOR_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'un collaborateur",
      "SUBTITLE": "Formulaire d'édition d'un collaborateur"
    },
    "FORM": {
      "PERSONAL_INFO": "Informations personnelles",
      "LABEL_LASTNAME": "Nom",
      "LABEL_FIRSTNAME": "Prénom"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'édition d'un collaborateur"
    },
    "MESSAGE": {
      "SUCCESS": "Le collaborateur a été modifié avec succès",
      "ERROR": "Impossible de modifier le collaborateur"
    },
    "PLACEHOLDER": {
      "LASTNAME": "Ex : Dupont",
      "FIRSTNAME": "Ex : Marie"
    }
  },
  "CREATE_COLLABORATOR_PAGE": {
    "TITLE": {
      "HEADER": "Ajouter un collaborateur",
      "SUBTITLE": "Formulaire d'ajout d'un collaborateur"
    },
    "FORM": {
      "PERSONAL_INFO": "Informations personnelles",
      "LABEL_LASTNAME": "Nom",
      "LABEL_FIRSTNAME": "Prénom",
      "LABEL_JOB_DESCRIPTION": "Métier"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'ajout d'un collaborateur"
    },
    "MESSAGE": {
      "SUCCESS": "Le collaborateur a été ajouté avec succès",
      "ERROR": "Impossible d'ajouter le collaborateur"
    },
    "PLACEHOLDER": {
      "LASTNAME": "Ex : Dupont",
      "FIRSTNAME": "Ex : Marie",
      "JOB_DESCRIPTION": "Décrire les informations utiles"
    }
  },
  "EDIT_COLLABORATOR_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'un collaborateur",
      "SUBTITLE": "Formulaire d'édition d'un collaborateur"
    },
    "FORM": {
      "PERSONAL_INFO": "Informations personnelles",
      "LABEL_LASTNAME": "Nom",
      "LABEL_FIRSTNAME": "Prénom",
      "LABEL_JOB_DESCRIPTION": "Métier",
      "LABEL_STATUS": "Statut"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'édition d'un collaborateur"
    },
    "MESSAGE": {
      "SUCCESS": "Le collaborateur a été modifié avec succès",
      "ERROR": "Impossible de modifier le collaborateur"
    },
    "PLACEHOLDER": {
      "LASTNAME": "Ex : Dupont",
      "FIRSTNAME": "Ex : Marie",
      "JOB_DESCRIPTION": "Décrire les informations utiles"
    }
  },
  "CREATE_DISTRIBUTOR_NETWORK_PAGE": {
    "TITLE": {
      "HEADER": "Nouveau réseau distributeur",
      "SUBTITLE": "Formulaire de création d'un réseau distributeur"
    },
    "FORM": {
      "PERSONAL_INFO": "Information sur le réseau",
      "PERSONALIZATION": "Personnalisation",
      "PREVIEW": "Aperçu",
      "LABEL_MANUFACTURER": "Fabricants",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom",
      "LABEL_PRIMARY_COLOR": "Couleur primaire",
      "LABEL_SECONDARY_COLOR": "Couleur secondaire",
      "CUSTOM_THEME_ENABLED": "Activer le thème personnalisé",
      "LABEL_INPUT": "Ajouter un logo",
      "LABEL_LOGO": "Logo",
      "NAMEPLATE_LOGIN_ID": "Identifiant plaque signalétique"
    },
    "PLACEHOLDER": {
      "MANUFACTURER": "Sélectionner le/les fabricant(s)",
      "ID": "Ex : B123456",
      "NAMEPLATE_LOGIN_ID": "Ex : B123456",
      "NAME": "Ex : VINAY GRENOBLE",
      "PRIMARY_COLOR": "Ex : #72AE4B",
      "SECONDARY_COLOR": "Ex : #72AE4B"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'ajout du réseau"
    },
    "MESSAGE": {
      "SUCCESS": "Le réseau a été ajouté avec succès"
    },
    "ERROR": {
      "FILE": "Le fichier est obligatoire"
    }
  },
  "EDIT_DISTRIBUTOR_NETWORK_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'un réseau distributeur",
      "SUBTITLE": "Formulaire d'édition d'un réseau distributeur"
    },
    "FORM": {
      "PERSONAL_INFO": "Information sur le réseau",
      "PERSONALIZATION": "Personnalisation",
      "PREVIEW": "Aperçu",
      "LABEL_MANUFACTURER": "Fabricants",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom",
      "LABEL_PRIMARY_COLOR": "Couleur primaire",
      "LABEL_SECONDARY_COLOR": "Couleur secondaire",
      "CUSTOM_THEME_ENABLED": "Activer le thème personnalisé",
      "LABEL_INPUT": "Logo",
      "NAMEPLATE_LOGIN_ID": "Identifiant plaque signalétique"
    },
    "PLACEHOLDER": {
      "MANUFACTURER": "Sélectionner le/les fabricant(s)",
      "NAMEPLATE_LOGIN_ID": "Ex : B123456",
      "NAME": "Ex : VINAY GRENOBLE"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'édition du réseau"
    },
    "MESSAGE": {
      "SUCCESS": "Le réseau a été ajouté avec succès",
      "UPDATE": "Le réseau a été modifié avec succès"
    },
    "ERROR": {
      "FILE_TO_HEAVY": "Le fichier est obligatoire"
    }
  },
  "KEY_ACCOUNT_NETWORK_PAGE": {
    "TITLE": {
      "HEADER": "Réseaux grand compte",
      "SUBTITLE": "Liste des réseaux grand compte"
    },
    "TABLE": {
      "ID": "ID",
      "NETWORK": "Réseau",
      "PRIMARY_COLOR": "Couleur principale",
      "SECONDARY_COLOR": "Couleur secondaire",
      "STATUS": "Statut",
      "NAMEPLATE_LOGIN_ID": "Identifiant plaque signalétique"
    },
    "MODAL": {
      "DEACTIVATION": {
        "TITLE": "Désactiver un réseau grand compte",
        "MESSAGE": "Cette action va bloquer tous les groupements, centres d'exploitation et magasins liés à ce réseau grand compte",
        "WARNING": "Voulez-vous vraiment désactiver le réseau grand compte {network}?",
        "VALIDATION_BUTTON": "Désactiver"
      },
      "REACTIVATION": {
        "TITLE": "Réactiver un réseau grand compte",
        "MESSAGE": "Voulez-vous vraiment réactiver le réseau grand compte {network}?",
        "VALIDATION_BUTTON": "Réactiver"
      }
    },
    "BUTTON": {
      "NEW_NETWORK": "Nouveau réseau grand compte",
      "DEACTIVATION": "Désactiver",
      "REACTIVATION": "Réactiver"
    },
    "MESSAGE": {
      "SUCCESS_DEACTIVATION": "Le réseau grand compte a été désactivé avec succès",
      "SUCCESS_REACTIVATION": "Le réseau grand compte a été réactivé avec succès"
    },
    "EXPORT_SUCCESS": "L'export des réseaux grand compte a été effectué et sera envoyé par mail"
  },
  "KEY_ACCOUNT_NETWORKS_PAGE": {
    "TITLE": {
      "HEADER_NETWORK": "Réseaux grand compte",
      "HEADER_GROUP": "Groupements grand compte",
      "HEADER_OPERATING_CENTER": "Centres d'exploitation",
      "HEADER_DISTRIBUTOR_NETWORK": "Réseaux distributeurs"
    },
    "SUBTITLE": {
      "HEADER_NETWORK": "Liste des réseaux grand compte",
      "HEADER_GROUP": "Liste des groupements grand compte",
      "HEADER_OPERATING_CENTER": "Liste des centres d'exploitation liés aux réseaux grand compte"
    },
    "BUTTON": {
      "NEW_NETWORK": "Nouveau réseau grand compte",
      "NEW_GROUP": "Nouveau groupement grand compte",
      "NEW_OPERATING_CENTER": "Nouveau centre d'exploitation",
      "NETWORK": "Réseaux",
      "GROUP": "Groupements",
      "OPERATING_CENTER": "Centres d'exploitation",
      "DISTRIBUTOR_NETWORK": "Réseaux distributeurs"
    }
  },
  "OPERATING_CENTERS_PAGE": {
    "TABLE": {
      "ID": "ID",
      "NETWORK": "Réseau",
      "GROUP": "Groupement",
      "NAME": "Nom",
      "EMAIL": "Email contact",
      "PHONE": "Téléphone",
      "ZONE": "Zone",
      "FOLDER_STATS": "Nombre de dossier"
    },
    "MODAL": {
      "TITLE": "Suppression d’un centre d'exploitation",
      "MESSAGE": "Voulez-vous vraiment supprimer {operatingCenter}?",
      "WARNING": "Cette action est irréversible."
    },
    "MESSAGE": {
      "SUCCESS": "Le centre d'exploitation a été supprimer avec succès",
      "ERROR": "Impossible de supprimer le centre d'exploitation"
    },
    "EXPORT_SUCCESS": "L'export des centres d'exploitation a été effectué et sera envoyé par mail"
  },
  "OPERATING_CENTER_PLANNING": {
    "TITLE": "Planning",
    "START_TIME": "Début",
    "END_TIME": "Fin",
    "ADD_SLOT": "Ajouter un créneau",
    "REMOVE_SLOT": "Supprimer le créneau",
    "HELP": "Glissez pour créer, déplacer ou ajuster les créneaux.",
    "DAY": {
      "MONDAY": "Lundi",
      "TUESDAY": "Mardi",
      "WEDNESDAY": "Mercredi",
      "THURSDAY": "Jeudi",
      "FRIDAY": "Vendredi"
    },
    "ERROR": {
      "INVALID_RANGE": "L'heure de début doit être avant l'heure de fin.",
      "OVERLAP": "Les créneaux ne doivent pas se chevaucher."
    }
  },
  "CREATE_OPERATING_CENTER_PAGE": {
    "TITLE": {
      "HEADER": "Nouveau centre d'exploitation",
      "SUBTITLE": "Formulaire d'ajout d'un centre d'exploitation",
      "GENERAL_INFO": "Informations du centre d'exploitation",
      "CONTEXT": "Contexte",
      "GENERAL_SECTION": "Informations générales",
      "CONTACTS": "Coordonnées",
      "ADDRESS": "Adresse",
      "SATISFACTION_QUESTIONNAIRE_CONFIGURATION": "Questionnaire de satisfaction",
      "STORE_CONFIGURATION": "Configuration centre d'exploitation"
    },
    "FORM": {
      "LABEL_BANNER": "Bannière de l'email",
      "LABEL_BILLING_CUSTOMER_ACCOUNT_NUMBER": "N° compte client facturation",
      "LABEL_NETWORK": "Réseau",
      "LABEL_GROUP": "Groupement",
      "LABEL_NAME": "Nom",
      "LABEL_BOOMERANG_ID": "ID",
      "LABEL_PHONE": "Téléphone",
      "LABEL_RESPONSIBLE_EMAIL": "Email responsable",
      "LABEL_CONTACT_EMAIL": "Email contact",
      "LABEL_BACKUP_EMAIL": "Email backup réception retours clients",
      "LABEL_INTERLOCUTOR_LAST_NAME": "Nom de l'interlocuteur",
      "LABEL_INTERLOCUTOR_FIRST_NAME": "Prénom de l'interlocuteur",
      "LABEL_SIRET": "Numéro de SIRET",
      "LABEL_LABEL_NAME": "Nom adresse postale pour étiquette",
      "LABEL_ADDRESS_NUMBER": "Numéro d'adresse postale",
      "LABEL_ADDRESS_STREET": "Rue",
      "LABEL_ADDRESS_COMPLEMENT_1": "Complément 1",
      "LABEL_ADDRESS_COMPLEMENT_2": "Complément 2",
      "LABEL_ADDRESS_ZIP_CODE": "Code postal",
      "LABEL_ADDRESS_CITY": "Ville",
      "LABEL_ADDRESS_COUNTRY": "Pays",
      "LABEL_REGION_CODE": "Zone",
      "LABEL_BILLING": "Facturation",
      "LABEL_MANUFACTURER": "Fabricant local",
      "LABEL_LOGO": "Logo",
      "LABEL_LOGO_INPUT": "Ajouter un logo",
      "LABEL_MIN_RANGE": "Note minimale",
      "LABEL_MAX_RANGE": "Note maximale",
      "LABEL_REDIRECT_URL": "Lien de redirection",
      "LABEL_SATISFACTION_QUESTIONNAIRE": "Gestion questionnaire satisfaction",
      "PREVIEW": "Aperçu"
    },
    "PLACEHOLDER": {
      "BANNER": "Importez la bannière du questionnaire satisfaction",
      "NETWORK": "Sélectionner un réseau grand compte",
      "BILLING": "Sélectionner une facturation",
      "MANUFACTURER": "Sélectionner un fabricant local",
      "REGION_CODE": "Sélectionner une zone",
      "GROUP": "Sélectionner un groupement grand compte",
      "NAME": "Ex : Bouygues Construction Paris",
      "BOOMERANG_ID": "Ex : B123456",
      "LABEL_NAME": "Ex : Bouygues Construction Paris",
      "SIRET": "Ex : 12345678901234",
      "PHONE": "Ex : 01 23 45 67 89",
      "RESPONSIBLE_EMAIL": "Ex : contact{'@'}exemple.fr",
      "CONTACT_EMAIL": "Ex : contact{'@'}exemple.fr",
      "BACKUP_EMAIL": "Ex : contact{'@'}exemple.fr",
      "INTERLOCUTOR_LAST_NAME": "Ex : Dupont",
      "INTERLOCUTOR_FIRST_NAME": "Ex : Jean",
      "ADDRESS_NUMBER": "Ex : 12",
      "ADDRESS_STREET": "Ex : Rue de la Paix",
      "ADDRESS_COMPLEMENT_1": "Ex : 12 rue de la Paix",
      "ADDRESS_COMPLEMENT_2": "Ex : 12 rue de la Paix",
      "ADDRESS_ZIP_CODE": "Ex : 75001",
      "ADDRESS_CITY": "Ex : Paris",
      "ADDRESS_COUNTRY": "Ex : France",
      "MIN_RANGE": "Ex : 1",
      "MAX_RANGE": "Ex : 10",
      "REDIRECT_URL": "Ex : https://www.exemple.fr",
      "BILLING_CUSTOMER_ACCOUNT_NUMBER": "Ex : FAC-123456",
      "SELECT_REPAIR_CENTER_ALTERNATIVE": "Sélectionner un ou plusieurs centres de réparation"
    },
    "SWITCH": {
      "REPAIR_STATUS": "Réparation dans le centre d'exploitation",
      "ALLOW_REPAIR_CENTER_ALTERNATIVE": "Réparateurs alternatifs",
      "SATISFACTION_QUESTIONNAIRE": "Gestion questionnaire satisfaction"
    },
    "SELECTOR": {
      "SELECT_REPAIR_CENTER_ALTERNATIVE": "Sélectionner un/des Centre de réparation"
    },
    "BUTTON": {
      "ADD_REDIRECT_URL": "Ajouter",
      "VALIDATE": "Valider l'ajout du centre d'exploitation"
    },
    "MESSAGE": {
      "SUCCESS": "Le centre d'exploitation a été ajouté avec succès",
      "ERROR": "Impossible d'ajouter le centre d'exploitation"
    }
  },
  "EDIT_OPERATING_CENTER_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'un centre d'exploitation",
      "GENERAL_INFO": "Informations du centre d'exploitation",
      "CONTEXT": "Contexte",
      "GENERAL_SECTION": "Informations générales",
      "CONTACTS": "Coordonnées",
      "ADDRESS": "Adresse",
      "SATISFACTION_QUESTIONNAIRE_CONFIGURATION": "Questionnaire de satisfaction",
      "STORE_CONFIGURATION": "Configuration centre d'exploitation",
      "SUBTITLE": "Formulaire d'édition d'un centre d'exploitation"
    },
    "FORM": {
      "LABEL_BANNER": "Bannière de l'email",
      "LABEL_BILLING_CUSTOMER_ACCOUNT_NUMBER": "N° compte client facturation",
      "LABEL_NETWORK": "Réseau",
      "LABEL_GROUP": "Groupement",
      "LABEL_NAME": "Nom",
      "LABEL_BOOMERANG_ID": "ID",
      "LABEL_PHONE": "Téléphone",
      "LABEL_RESPONSIBLE_EMAIL": "Email responsable",
      "LABEL_CONTACT_EMAIL": "Email contact",
      "LABEL_BACKUP_EMAIL": "Email backup réception retours clients",
      "LABEL_INTERLOCUTOR_LAST_NAME": "Nom de l'interlocuteur",
      "LABEL_INTERLOCUTOR_FIRST_NAME": "Prénom de l'interlocuteur",
      "LABEL_SIRET": "Numéro de SIRET",
      "LABEL_LABEL_NAME": "Nom adresse postale pour étiquette",
      "LABEL_ADDRESS_NUMBER": "Numéro d'adresse postale",
      "LABEL_ADDRESS_STREET": "Rue",
      "LABEL_ADDRESS_COMPLEMENT_1": "Complément 1",
      "LABEL_ADDRESS_COMPLEMENT_2": "Complément 2",
      "LABEL_ADDRESS_ZIP_CODE": "Code postal",
      "LABEL_ADDRESS_CITY": "Ville",
      "LABEL_ADDRESS_COUNTRY": "Pays",
      "LABEL_REGION_CODE": "Zone",
      "LABEL_BILLING": "Facturation",
      "LABEL_MANUFACTURER": "Fabricant local",
      "LABEL_LOGO": "Logo",
      "LABEL_MIN_RANGE": "Note minimale",
      "LABEL_MAX_RANGE": "Note maximale",
      "LABEL_REDIRECT_URL": "Lien de redirection",
      "LABEL_SATISFACTION_QUESTIONNAIRE": "Gestion questionnaire satisfaction",
      "PREVIEW": "Aperçu"
    },
    "PLACEHOLDER": {
      "BANNER": "Importez la bannière du questionnaire satisfaction",
      "NETWORK": "Sélectionner un réseau grand compte",
      "BILLING": "Sélectionner une facturation",
      "MANUFACTURER": "Sélectionner un fabricant local",
      "REGION_CODE": "Sélectionner une zone",
      "GROUP": "Sélectionner un groupement grand compte",
      "NAME": "Ex : Bouygues Construction Paris",
      "LABEL_NAME": "Ex : Bouygues Construction Paris",
      "SIRET": "Ex : 12345678901234",
      "PHONE": "Ex : 01 23 45 67 89",
      "RESPONSIBLE_EMAIL": "Ex : contact{'@'}exemple.fr",
      "CONTACT_EMAIL": "Ex : contact{'@'}exemple.fr",
      "BACKUP_EMAIL": "Ex : contact{'@'}exemple.fr",
      "INTERLOCUTOR_LAST_NAME": "Ex : Dupont",
      "INTERLOCUTOR_FIRST_NAME": "Ex : Jean",
      "ADDRESS_NUMBER": "Ex : 12",
      "ADDRESS_STREET": "Ex : Rue de la Paix",
      "ADDRESS_COMPLEMENT_1": "Ex : 12 rue de la Paix",
      "ADDRESS_COMPLEMENT_2": "Ex : 12 rue de la Paix",
      "ADDRESS_ZIP_CODE": "Ex : 75001",
      "ADDRESS_CITY": "Ex : Paris",
      "ADDRESS_COUNTRY": "Ex : France",
      "MIN_RANGE": "Ex : 1",
      "MAX_RANGE": "Ex : 10",
      "REDIRECT_URL": "Ex : https://www.exemple.fr",
      "BILLING_CUSTOMER_ACCOUNT_NUMBER": "Ex : FAC-123456",
      "SELECT_REPAIR_CENTER_ALTERNATIVE": "Sélectionner un ou plusieurs centres de réparation"
    },
    "SWITCH": {
      "REPAIR_STATUS": "Réparation dans le centre d'exploitation",
      "ALLOW_REPAIR_CENTER_ALTERNATIVE": "Réparateurs alternatifs",
      "SATISFACTION_QUESTIONNAIRE": "Gestion questionnaire satisfaction"
    },
    "SELECTOR": {
      "SELECT_REPAIR_CENTER_ALTERNATIVE": "Sélectionner un/des Centre de réparation"
    },
    "BUTTON": {
      "ADD_REDIRECT_URL": "Ajouter",
      "VALIDATE": "Valider l'édition du centre d'exploitation"
    },
    "MESSAGE": {
      "SUCCESS": "Le centre d'exploitation a été modifié avec succès",
      "ERROR": "Impossible de modifier le centre d'exploitation"
    }
  },
  "DETAIL_OPERATING_CENTER_PAGE": {
    "TITLE": {
      "HEADER": "Détail d'un centre d'exploitation",
      "SUB_HEADER": "Centre d'exploitation"
    },
    "SUBTITLE": {
      "HEADER_DETAIL": "Centre d'exploitation - {operatingCenterName}",
      "HEADER_TRANSPORT": "Liste des transporteurs expressistes du centre d'exploitation {operatingCenterName}",
      "HEADER_STORE": "Liste des distributeurs du centre d'exploitation {operatingCenterName}",
      "HEADER_REPAIR_MANUFACTURER": "Liste des fabricants actifs pour la réparation dans le centre d'exploitation {operatingCenterName}",
      "HEADER_REPAIR_CENTER_ALTERNATIVE": "Liste des centres de réparation alternatifs du centre d'exploitation {operatingCenterName}"
    },
    "MANAGEMENT": {
      "TRANSPORT_TAB_TITLE": "Transporteurs Expressistes",
      "STORE_TAB_TITLE": "Distributeurs",
      "REPAIR_MANUFACTURER_TAB_TITLE": "Réparation dans le centre d'exploitation",
      "REPAIR_CENTER_ALTERNATIVE_TAB_TITLE": "Centres de réparation alternatifs"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "CONTACT_INFO": "Contacts",
      "STORE_CONFIGURATION": "Configuration centre d'exploitation",
      "NETWORK": "Réseau grand compte",
      "GROUP": "Groupement grand compte",
      "BOOMERANG_ID": "ID",
      "STATUS": "Statut",
      "ADDRESS": "Adresse",
      "INTERLOCUTOR_LAST_NAME": "Nom de l'interlocuteur",
      "INTERLOCUTOR_FIRST_NAME": "Prénom de l'interlocuteur",
      "CONTACT_EMAIL": "Email contact",
      "PHONE_NUMBER": "Téléphone",
      "MANAGER": "Manager centre d'exploitation",
      "SIRET": "Siret",
      "BACKUP_EMAIL": "Backup email",
      "ZONE": "Zone",
      "REPAIR_STATUS": "Réparation dans le centre d'exploitation",
      "REPAIR_CENTER_ALTERNATIVE": "Réparateurs alternatifs",
      "SATISFACTION_QUESTIONNAIRE": "Gestion questionnaire satisfaction"
    },
    "TABLE": {
      "BOOMERANG_ID": "ID",
      "NAME": "Nom",
      "CITY": "Ville",
      "EMAIL_CONTACT": "Email contact",
      "REPAIR_CENTER_NAME": "Centre de réparation"
    }
  },
  "REPAIR_CENTER_LINK_TYPE": {
    "STORE": "Magasin",
    "OPERATING_CENTER": "Centre d'exploitation"
  },
  "OPERATING_CENTER_REPAIR_MANUFACTURER_LIST": {
    "TABLE": {
      "ACTIVE": "Actif",
      "ID": "ID",
      "NAME": "Nom",
      "CATEGORY_COUNT": "Catégories",
      "PRODUCT_COUNT": "Produits"
    }
  },
  "OPERATING_CENTER_STORE_LIST": {
    "FILTER": {
      "MISSING_KEY_ACCOUNT_CLIENT_NUMBER": "Nº client absent"
    },
    "TABLE": {
      "COUNTRY": "Pays",
      "REGION_CODE": "Département",
      "DISTRIBUTOR_NETWORK": "Réseau distributeur",
      "STORE_BOOMERANG_ID": "ID distributeur",
      "KEY_ACCOUNT_CLIENT_NUMBER": "Nº client grand compte",
      "PICKUP_QR_CODE": "QR Code enlèvement"
    },
    "PICKUP_QR_CODE": {
      "GENERATE": "Générer",
      "DOWNLOAD": "Télécharger",
      "REVOKE": "Révoquer",
      "GENERATE_SUCCESS": "Le QR Code d’enlèvement a été généré avec succès",
      "REVOKE_SUCCESS": "Le QR Code d’enlèvement a été révoqué avec succès",
      "GENERATE_MODAL": {
        "TITLE": "Génération du QR Code d’enlèvement",
        "MESSAGE": "Voulez-vous vraiment générer le QR Code d’enlèvement de ce magasin ?"
      },
      "REVOKE_MODAL": {
        "TITLE": "Révocation du QR Code d’enlèvement",
        "MESSAGE": "Voulez-vous vraiment révoquer le QR Code d’enlèvement de ce magasin ?"
      }
    }
  },
  "KEY_ACCOUNT_GROUP_PAGE": {
    "PLACEHOLDER": {
      "NETWORK": "Sélectionner le réseau",
      "REGION": "Sélectionner la zone",
      "STATUS": "Sélectionner le statut"
    },
    "TABLE": {
      "GROUP_NUMBER": "Numéros du groupement",
      "NETWORK": "Réseau",
      "GROUP": "Groupement",
      "AUTHORIZATION_EMAIL": "Email autorisation",
      "REGION": "Zone"
    },
    "MESSAGE": {
      "SUCCESS": "Le groupement a été supprimé avec succès."
    },
    "MODAL": {
      "TITLE": "Suppression d’un groupement",
      "MESSAGE": "Voulez-vous vraiment supprimer {group}?",
      "WARNING": "Cette action est irréversible."
    },
    "EXPORT_SUCCESS": "L'export des groupements a été effectué et sera envoyé par mail"
  },
  "CREATE_KEY_ACCOUNT_GROUP_PAGE": {
    "TITLE": {
      "HEADER": "Nouveau groupement grand compte",
      "SUBTITLE": "Formulaire d'ajout d'un groupement grand compte"
    },
    "FORM": {
      "GROUP_INFO": "Informations du groupement",
      "LABEL_NETWORK": "Réseau",
      "LABEL_REGION": "Zone",
      "LABEL_NAME": "Nom",
      "LABEL_AUTHORIZATION_EMAIL": "Email autorisation",
      "LABEL_NUMBER": "Numéro",
      "OTHER": "autre",
      "OTHERS": "autres"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'ajout du groupement"
    },
    "MESSAGE": {
      "SUCCESS": "Le groupement a été ajouté avec succès",
      "ERROR": "Impossible d'ajouter le groupement"
    },
    "PLACEHOLDER": {
      "NETWORK": "Sélectionner un réseau",
      "NAME": "Ex : Île-de-France",
      "REGION": "Sélectionner une zone",
      "AUTHORIZATION_EMAIL": "Ex : contact{'@'}exemple.fr"
    }
  },
  "EDIT_KEY_ACCOUNT_GROUP_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'un groupement grand compte",
      "SUBTITLE": "Formulaire d'édition d'un groupement grand compte"
    },
    "FORM": {
      "GROUP_INFO": "Informations du groupement",
      "LABEL_NETWORK": "Réseau",
      "LABEL_AUTHORIZATION_EMAIL": "Email autorisation",
      "LABEL_NAME": "Nom",
      "LABEL_NUMBER": "Numéro",
      "LABEL_REGION": "Zone",
      "OTHER": "autre",
      "OTHERS": "autres"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'édition du groupement"
    },
    "MESSAGE": {
      "SUCCESS": "Le groupement a été modifié avec succès",
      "ERROR": "Impossible de modifier le groupement"
    },
    "PLACEHOLDER": {
      "REGION": "Sélectionner une zone",
      "NETWORK": "Sélectionner un réseau",
      "NAME": "Ex : Île-de-France",
      "AUTHORIZATION_EMAIL": "Ex : contact{'@'}exemple.fr"
    }
  },
  "CREATE_KEY_ACCOUNT_NETWORK_PAGE": {
    "TITLE": {
      "HEADER": "Nouveau réseau grand compte",
      "SUBTITLE": "Formulaire de création d'un réseau grand compte"
    },
    "FORM": {
      "PERSONAL_INFO": "Information sur le réseau grand compte",
      "PERSONALIZATION": "Personnalisation",
      "PREVIEW": "Aperçu",
      "LABEL_DISTRIBUTOR_NETWORK": "Réseau distributeur",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom",
      "LABEL_PRIMARY_COLOR": "Couleur primaire",
      "LABEL_SECONDARY_COLOR": "Couleur secondaire",
      "CUSTOM_THEME_ENABLED": "Activer le thème personnalisé",
      "LABEL_INPUT": "Logo",
      "LABEL_LOGO": "Logo",
      "NAMEPLATE_LOGIN_ID": "Identifiant plaque signalétique"
    },
    "PLACEHOLDER": {
      "DISTRIBUTOR_NETWORK": "Sélectionner un/des réseau(x) distributeur(s)",
      "ID": "Ex : GC123456",
      "NAMEPLATE_LOGIN_ID": "Ex : GC123456",
      "NAME": "Ex : Grand compte national",
      "PRIMARY_COLOR": "Ex : #72AE4B",
      "SECONDARY_COLOR": "Ex : #72AE4B"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'ajout du réseau grand compte"
    },
    "MESSAGE": {
      "SUCCESS": "Le réseau grand compte a été ajouté avec succès"
    }
  },
  "EDIT_KEY_ACCOUNT_NETWORK_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'un réseau grand compte",
      "SUBTITLE": "Formulaire d'édition d'un réseau grand compte"
    },
    "FORM": {
      "PERSONAL_INFO": "Information sur le réseau grand compte",
      "PERSONALIZATION": "Personnalisation",
      "PREVIEW": "Aperçu",
      "LABEL_DISTRIBUTOR_NETWORK": "Réseau distributeur",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom",
      "LABEL_PRIMARY_COLOR": "Couleur primaire",
      "LABEL_SECONDARY_COLOR": "Couleur secondaire",
      "CUSTOM_THEME_ENABLED": "Activer le thème personnalisé",
      "LABEL_INPUT": "Logo",
      "LABEL_LOGO": "Logo",
      "NAMEPLATE_LOGIN_ID": "Identifiant plaque signalétique"
    },
    "PLACEHOLDER": {
      "DISTRIBUTOR_NETWORK": "Sélectionner un/des réseau(x) distributeur(s)",
      "ID": "Ex : GC123456",
      "NAMEPLATE_LOGIN_ID": "Ex : GC123456",
      "NAME": "Ex : Grand compte national",
      "PRIMARY_COLOR": "Ex : #72AE4B",
      "SECONDARY_COLOR": "Ex : #72AE4B"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'édition du réseau grand compte"
    },
    "MESSAGE": {
      "UPDATE": "Le réseau grand compte a été modifié avec succès"
    }
  },
  "DETAIL_KEY_ACCOUNT_NETWORK_PAGE": {
    "TITLE": {
      "HEADER": "Détail d'un réseau grand compte"
    },
    "SUBTITLE": {
      "HEADER_DETAIL": "Réseau grand compte - {networkName}",
      "HEADER_DISTRIBUTOR_NETWORK": "Liste des réseaux distributeurs rattachés à {networkName}",
      "HEADER_OPERATING_CENTER": "Liste des centres d'exploitation rattachés à {networkName}"
    },
    "LABEL": {
      "GENERAL_INFO": "Informations générales",
      "BOOMERANG_ID": "ID Boomerang",
      "NAMEPLATE_LOGIN_ID": "Identifiant plaque signalétique",
      "NAME": "Nom",
      "PRIMARY_COLOR": "Couleur primaire",
      "SECONDARY_COLOR": "Couleur secondaire",
      "CUSTOM_THEME_ENABLED": "Thème personnalisé",
      "STORE": "Magasin",
      "FOLDER": "Dossier",
      "USER": "Utilisateur",
      "ZONE_LINK": "Zones liées",
      "COLLABORATOR": "Collaborateur",
      "STATISTIC": "Statistiques"
    },
    "TABLE": {
      "ID": "ID",
      "NETWORK": "Réseau",
      "NAMEPLATE_LOGIN_ID": "Identifiant plaque signalétique",
      "PRIMARY_COLOR": "Couleur principale",
      "SECONDARY_COLOR": "Couleur secondaire",
      "STATUS": "Statut"
    }
  },
  "PERMISSION": {
    "ADMIN_ADD_COLLABORATOR": "Ajouter collaborateur",
    "ADMIN_UPDATE_COLLABORATOR": "Modifier collaborateur",
    "ADMIN_DELETE_COLLABORATOR": "Supprimer collaborateur",
    "ADMIN_ADD_REPAIR_FILE": "Créer un dossier de réparation",
    "ADMIN_UPDATE_REPAIR_FILE": "Modifier un dossier de réparation (hors clôture)",
    "ADMIN_CLOSE_REPAIR_FILE": "Modifier un dossier de réparation (clôture)",
    "ADMIN_DELETE_REPAIR_FILE": "Suppression des dossiers de réparation en MASSE",
    "ADMIN_COMMENT_REPAIR_FILE": "Rajouter un commentaire sur la synthèse",
    "ADMIN_REMOVE_ATTACHMENT_REPAIR_FILE": "Suppression document sur la fiche récap",
    "ADMIN_REMOVE_COMMENT_REPAIR_FILE": "Suppression commentaire sur la fiche récap",
    "ADMIN_VIEW_ALL_SUMMARY_REPAIR_FILE": "Visualiser la liste des dossiers en cours (sous périmètre)",
    "ADMIN_VIEW_ATTACHMENT_REPAIR_FILE": "Consulter les documents du dossier",
    "ADMIN_VIEW_REPAIR_FILE": "Consulter un dossier de réparation",
    "ADMIN_PRINT_ATTACHMENT_REPAIR_FILE": "Imprimer les documents du dossier",
    "ADMIN_ADD_ATTACHMENT_REPAIR_FILE": "Rajouter un document au dossier",
    "ADMIN_ACCOUNT_CREATE_PERMISSION": "Création des comptes utilisateurs",
    "ADMIN_ACCOUNT_READ_PERMISSION": "Visualisation des comptes utilisateurs",
    "ADMIN_ACCOUNT_UPDATE_PERMISSION": "Modification des comptes utilisateurs",
    "ADMIN_ACCOUNT_DELETE_PERMISSION": "Suppression des comptes utilisateurs",
    "ADMIN_ROLE_CREATE_PERMISSION": "Création des rôles",
    "ADMIN_ROLE_READ_PERMISSION": "Visualisation des rôles",
    "ADMIN_ROLE_UPDATE_PERMISSION": "Modification des rôles",
    "ADMIN_ROLE_DELETE_PERMISSION": "Suppression des rôles",
    "ADMIN_PRODUCT_CREATE_PERMISSION": "Création des fiches Produit",
    "ADMIN_PRODUCT_READ_PERMISSION": "Visualisation des fiches Produit",
    "ADMIN_PRODUCT_UPDATE_PERMISSION": "Modification des fiches Produit",
    "ADMIN_PRODUCT_DELETE_PERMISSION": "Suppression des fiches Produit",
    "ADMIN_DISTRIBUTOR_NETWORK_CREATE_PERMISSION": "Création des fiches Réseau distributeur",
    "ADMIN_DISTRIBUTOR_NETWORK_READ_PERMISSION": "Visualisation des fiches Réseau distributeur",
    "ADMIN_DISTRIBUTOR_NETWORK_UPDATE_PERMISSION": "Modification des fiches Réseau distributeur",
    "ADMIN_DISTRIBUTOR_NETWORK_DELETE_PERMISSION": "Suppression des fiches Réseau distributeur",
    "ADMIN_STORE_CREATE_PERMISSION": "Création des fiches Magasin",
    "ADMIN_STORE_READ_PERMISSION": "Visualisation des fiches Magasin",
    "ADMIN_STORE_UPDATE_PERMISSION": "Modification des fiches Magasin",
    "ADMIN_STORE_DELETE_PERMISSION": "Suppression des fiches Magasin",
    "ADMIN_KEY_ACCOUNT_NETWORK_CREATE_PERMISSION": "Création des fiches Réseau grand compte",
    "ADMIN_KEY_ACCOUNT_NETWORK_READ_PERMISSION": "Visualisation des fiches Réseau grand compte",
    "ADMIN_KEY_ACCOUNT_NETWORK_UPDATE_PERMISSION": "Modification des fiches Réseau grand compte",
    "ADMIN_KEY_ACCOUNT_NETWORK_DELETE_PERMISSION": "Suppression des fiches Réseau grand compte",
    "ADMIN_KEY_ACCOUNT_PRODUCT_CREATE_PERMISSION": "Création du parc produit grand compte",
    "ADMIN_KEY_ACCOUNT_PRODUCT_READ_PERMISSION": "Visualisation du parc produit grand compte",
    "ADMIN_KEY_ACCOUNT_PRODUCT_UPDATE_PERMISSION": "Modification du parc produit grand compte",
    "ADMIN_KEY_ACCOUNT_PRODUCT_REQUEST_DRAFT_REVIEW_PERMISSION": "Traitement des demandes de création de parc produit grand compte",
    "ADMIN_KEY_ACCOUNT_PRODUCT_IMPORT_PERMISSION": "Parc produit grand compte",
    "ADMIN_EXTRACT_KEY_ACCOUNT_PRODUCT_REFERENTIAL": "Parc produit grand compte",
    "ADMIN_KEY_ACCOUNT_GROUP_CREATE_PERMISSION": "Création des fiches Groupement grand compte",
    "ADMIN_KEY_ACCOUNT_GROUP_READ_PERMISSION": "Visualisation des fiches Groupement grand compte",
    "ADMIN_KEY_ACCOUNT_GROUP_UPDATE_PERMISSION": "Modification des fiches Groupement grand compte",
    "ADMIN_KEY_ACCOUNT_GROUP_DELETE_PERMISSION": "Suppression des fiches Groupement grand compte",
    "ADMIN_OPERATING_CENTER_CREATE_PERMISSION": "Création des fiches Centre d'exploitation",
    "ADMIN_OPERATING_CENTER_READ_PERMISSION": "Visualisation des fiches Centre d'exploitation",
    "ADMIN_OPERATING_CENTER_UPDATE_PERMISSION": "Modification des fiches Centre d'exploitation",
    "ADMIN_OPERATING_CENTER_DELETE_PERMISSION": "Suppression des fiches Centre d'exploitation",
    "ADMIN_TRANSPORTER_CREATE_PERMISSION": "Création des fiches Transporteur",
    "ADMIN_TRANSPORTER_READ_PERMISSION": "Visualisation des fiches Transporteur",
    "ADMIN_TRANSPORTER_UPDATE_PERMISSION": "Modification des fiches Transporteur",
    "ADMIN_TRANSPORTER_DELETE_PERMISSION": "Suppression des fiches Transporteur",
    "ADMIN_REPAIRER_CREATE_PERMISSION": "Création des fiches Réparateur",
    "ADMIN_REPAIRER_READ_PERMISSION": "Visualisation des fiches Réparateur",
    "ADMIN_REPAIRER_UPDATE_PERMISSION": "Modification des fiches Réparateur",
    "ADMIN_REPAIRER_DELETE_PERMISSION": "Suppression des fiches Réparateur",
    "ADMIN_BILLING_CREATE_PERMISSION": "Création de facture",
    "ADMIN_BILLING_READ_PERMISSION": "Visualisation des factures",
    "ADMIN_BILLING_UPDATE_PERMISSION": "Modification des factures",
    "ADMIN_CREATE_NOTIFICATION": "Création des notifications push",
    "ADMIN_CHECK_CLOUD_STORAGE_INTEGRITY": "Contrôle d'intégrité stockage distant",
    "ADMIN_EMAIL_OUTBOX_READ": "Visualisation des emails asynchrones",
    "ADMIN_EMAIL_OUTBOX_RESEND": "Renvoi des emails asynchrones en échec",
    "ADMIN_HISTORY_ACTION_READ": "Visualiser les actions utilisateurs",
    "ADMIN_ITECH_MANUAL_UPDATE": "Mettre à jour manuellement les données ITECH",
    "ADMIN_CHRONOPOST_MANUAL_UPDATE": "Mettre à jour manuellement le suivi Chronopost",
    "ADMIN_RENTAL_READ": "Voir le module",
    "ADMIN_RENTAL_CREATE": "Ajouter au module",
    "ADMIN_RENTAL_UPDATE": "Modifier dans le module",
    "ADMIN_RENTAL_DELETE": "Supprimer dans le module",
    "ADMIN_RECYCLING_READ": "Voir le module",
    "ADMIN_RECYCLING_CREATE": "Ajouter au module",
    "ADMIN_RECYCLING_UPDATE": "Modifier dans le module",
    "ADMIN_RECYCLING_DELETE": "Supprimer dans le module",
    "ADMIN_EXTRACT_REPAIR_FILE": "Dossiers de réparation",
    "ADMIN_EXTRACT_ACCOUNT": "Comptes utilisateurs",
    "ADMIN_EXTRACT_ROLE": "Rôles",
    "ADMIN_EXTRACT_DISTRIBUTOR_NETWORK_REFERENTIAL": "Base de données Réseau distributeur",
    "ADMIN_EXTRACT_DISTRIBUTOR_GROUP_REFERENTIAL": "Base de données Groupe distributeur",
    "ADMIN_EXTRACT_STORE_REFERENTIAL": "Magasins",
    "ADMIN_EXTRACT_OPERATING_CENTER_REFERENTIAL": "Centres d'exploitation",
    "ADMIN_EXTRACT_KEY_ACCOUNT_NETWORK_REFERENTIAL": "Base de données Réseau grand compte",
    "ADMIN_EXTRACT_KEY_ACCOUNT_GROUP_REFERENTIAL": "Base de données Groupement grand compte",
    "ADMIN_EXTRACT_CATEGORY_REFERENTIAL": "Catégories",
    "ADMIN_EXTRACT_PRODUCT_REFERENTIAL": "Produits",
    "ADMIN_EXTRACT_PACKAGE_REFERENTIAL": "Forfaits",
    "ADMIN_EXTRACT_SERIAL_NUMBER_REFERENTIAL": "Numéros de série",
    "ADMIN_EXTRACT_GUARANTEE_REFERENTIAL": "Garanties",
    "ADMIN_EXTRACT_GUARANTEE_EXTENSION_REFERENTIAL": "Extensions de garantie",
    "ADMIN_EXTRACT_PRODUCT_BREAKDOWN_REFERENTIAL": "Pannes produit",
    "ADMIN_EXTRACT_PRODUCT_DISTRIBUTOR_REF_REFERENTIAL": "Références produit distributeur",
    "ADMIN_EXTRACT_PRODUCT_STORE_PRICE_REFERENTIAL": "Prix de vente distributeur réels",
    "ADMIN_EXTRACT_REPAIRER_REFERENTIAL": "Réparateurs",
    "ADMIN_EXTRACT_ADDITIONAL_REPAIR_COST_REFERENTIAL": "Surcoûts de réparation",
    "ADMIN_EXTRACT_TRANSPORT_PACKAGE_REFERENTIAL": "Forfaits de transport",
    "ADMIN_EXTRACT_TRANSPORTER_REFERENTIAL": "Transporteurs",
    "ADMIN_EXTRACT_ESTIMATE_TRANSPORTER_COST_REFERENTIAL": "Coûts transporteur devis",
    "ADMIN_IMPORT_REPAIR_FILE_UPDATE_STATUS": "Mises à jour de statut des dossiers de réparation",
    "ADMIN_EXTRACT_RENTAL_PRODUCT_REFERENTIAL": "Produits location",
    "ADMIN_EXTRACT_RECYCLER_BAC_REFERENTIAL": "Bacs recycleur",
    "ADMIN_EXTRACT_RECYCLING_BUYBACK_REFERENTIAL": "Reprises recyclage",
    "ADMIN_EXTRACT_RECYCLING_CLIENT_LINK_REFERENTIAL": "Liens client recyclage",
    "ADMIN_IMPORT_PRODUCT_REFERENTIAL": "Produits",
    "ADMIN_IMPORT_PACKAGE_REFERENTIAL": "Forfaits",
    "ADMIN_IMPORT_SERIAL_NUMBER_REFERENTIAL": "Numéros de série",
    "ADMIN_IMPORT_GUARANTEE_REFERENTIAL": "Garanties",
    "ADMIN_IMPORT_GUARANTEE_EXTENSION_REFERENTIAL": "Extensions de garantie",
    "ADMIN_IMPORT_PRODUCT_BREAKDOWN_REFERENTIAL": "Pannes produit",
    "ADMIN_IMPORT_PRODUCT_DISTRIBUTOR_REF_REFERENTIAL": "Références produit distributeur",
    "ADMIN_IMPORT_PRODUCT_STORE_PRICE_REFERENTIAL": "Prix de vente distributeur réels",
    "ADMIN_IMPORT_REPAIRER_REFERENTIAL": "Réparateurs",
    "ADMIN_IMPORT_ADDITIONAL_REPAIR_COST_REFERENTIAL": "Surcoûts de réparation",
    "ADMIN_IMPORT_TRANSPORT_PACKAGE_REFERENTIAL": "Forfaits de transport",
    "ADMIN_IMPORT_TRANSPORTER_REFERENTIAL": "Transporteurs",
    "ADMIN_IMPORT_ESTIMATE_TRANSPORTER_COST_REFERENTIAL": "Coûts transporteur devis",
    "ADMIN_IMPORT_RENTAL_PRODUCT_REFERENTIAL": "Produits location",
    "ADMIN_IMPORT_RECYCLER_BAC_REFERENTIAL": "Bacs de recyclage",
    "ADMIN_IMPORT_RECYCLING_BUYBACK_REFERENTIAL": "Prix de rachat recyclage",
    "ADMIN_IMPORT_RECYCLING_CLIENT_LINK_REFERENTIAL": "Liaisons client recyclage",
    "DISTRIBUTOR_RENTAL_READ": "Voir le module",
    "DISTRIBUTOR_RENTAL_CREATE": "Ajouter au module",
    "DISTRIBUTOR_RENTAL_UPDATE": "Modifier dans le module",
    "DISTRIBUTOR_RENTAL_DELETE": "Supprimer dans le module",
    "DISTRIBUTOR_RECYCLING_READ": "Voir le module",
    "DISTRIBUTOR_RECYCLING_CREATE": "Ajouter au module",
    "DISTRIBUTOR_RECYCLING_UPDATE": "Modifier dans le module",
    "DISTRIBUTOR_RECYCLING_DELETE": "Supprimer dans le module",
    "DISTRIBUTOR_EXTRACT_REPAIR_FILE": "Dossiers",
    "DISTRIBUTOR_ADD_COLLABORATOR": "Ajouter collaborateur",
    "DISTRIBUTOR_UPDATE_COLLABORATOR": "Modifier collaborateur",
    "DISTRIBUTOR_DELETE_COLLABORATOR": "Supprimer collaborateur",
    "DISTRIBUTOR_ADD_REPAIR_FILE": "Créer un dossier de réparation",
    "DISTRIBUTOR_UPDATE_REPAIR_FILE": "Modifier un dossier de réparation (hors clôture)",
    "DISTRIBUTOR_CLOSE_REPAIR_FILE": "Modifier un dossier de réparation (clôture)",
    "DISTRIBUTOR_DELETE_REPAIR_FILE": "Supprimer un dossier de réparation",
    "DISTRIBUTOR_ESTIMATE_OVERRIDE_REPAIR_FILE": "Mettre à jour manuellement les étapes 5., 6. et 7. d'un dossier de réparation",
    "DISTRIBUTOR_VIEW_ALL_SUMMARY_REPAIR_FILE": "Visualiser la liste des dossiers en cours (sous périmètre)",
    "DISTRIBUTOR_VIEW_ATTACHMENT_REPAIR_FILE": "Consulter les documents du dossier",
    "DISTRIBUTOR_VIEW_REPAIR_FILE": "Consulter un dossier de réparation",
    "DISTRIBUTOR_PRINT_ATTACHMENT_REPAIR_FILE": "Imprimer les documents du dossier",
    "DISTRIBUTOR_ADD_ATTACHMENT_REPAIR_FILE": "Rajouter un document au dossier",
    "DISTRIBUTOR_ACCOUNT_READ_PERMISSION": "Visualisation des comptes utilisateurs",
    "DISTRIBUTOR_ACCOUNT_UPDATE_PERMISSION": "Modification des comptes utilisateurs",
    "DISTRIBUTOR_TRANSPORTER_READ_PERMISSION": "Visualisation des fiches Transporteur",
    "KEY_ACCOUNT_ACCOUNT_READ_PERMISSION": "Visualisation du compte grand compte",
    "KEY_ACCOUNT_PRODUCT_READ_PERMISSION": "Visualisation du parc produit grand compte",
    "KEY_ACCOUNT_PRODUCT_CREATE_REQUEST_PERMISSION": "Demande de création du parc produit grand compte",
    "KEY_ACCOUNT_PRODUCT_UPDATE_PERMISSION": "Modification du parc produit grand compte",
    "KEY_ACCOUNT_TRANSPORTER_CREATE_PERMISSION": "Création des connexions transporteur",
    "KEY_ACCOUNT_TRANSPORTER_READ_PERMISSION": "Visualisation des connexions transporteur",
    "KEY_ACCOUNT_TRANSPORTER_UPDATE_PERMISSION": "Modification des connexions transporteur",
    "KEY_ACCOUNT_TRANSPORTER_DELETE_PERMISSION": "Suppression des connexions transporteur",
    "KEY_ACCOUNT_ADD_REPAIR_FILE": "Créer un dossier de réparation",
    "KEY_ACCOUNT_UPDATE_REPAIR_FILE": "Modifier un dossier de réparation (hors clôture)",
    "KEY_ACCOUNT_CLOSE_REPAIR_FILE": "Clôturer un dossier de réparation",
    "KEY_ACCOUNT_DELETE_REPAIR_FILE": "Supprimer un dossier de réparation",
    "KEY_ACCOUNT_COMMENT_REPAIR_FILE": "Commenter un dossier de réparation",
    "KEY_ACCOUNT_VIEW_ALL_SUMMARY_REPAIR_FILE": "Visualiser la liste des dossiers en cours (sous périmètre)",
    "KEY_ACCOUNT_VIEW_ATTACHMENT_REPAIR_FILE": "Consulter les documents du dossier",
    "KEY_ACCOUNT_VIEW_REPAIR_FILE": "Consulter un dossier de réparation",
    "KEY_ACCOUNT_PRINT_ATTACHMENT_REPAIR_FILE": "Imprimer les documents du dossier",
    "KEY_ACCOUNT_ADD_ATTACHMENT_REPAIR_FILE": "Rajouter un document au dossier",
    "KEY_ACCOUNT_EXTRACT_REPAIR_FILE": "Exporter les dossiers de réparation"
  },
  "PERMISSION_CATEGORIES": {
    "ADMIN_COLLABORATOR_MANAGEMENT": "Collaborateurs",
    "DISTRIBUTOR_COLLABORATOR_MANAGEMENT": "Collaborateurs",
    "ADMIN_REPAIR_FILE_MANAGEMENT": "Dossiers de réparation",
    "DISTRIBUTOR_REPAIR_FILE_MANAGEMENT": "Dossiers de réparation",
    "ADMIN_REPAIR_FILE_VIEW": "Consultation des dossiers",
    "DISTRIBUTOR_REPAIR_FILE_VIEW": "Consultation des dossiers",
    "ADMIN_PLATFORM_MANAGEMENT": "Plateforme",
    "DISTRIBUTOR_PLATFORM_MANAGEMENT": "Plateforme",
    "ADMIN_RENTAL": "Location",
    "DISTRIBUTOR_RENTAL": "Location",
    "ADMIN_RECYCLING": "Recyclage",
    "DISTRIBUTOR_RECYCLING": "Recyclage",
    "ADMIN_EXTRACT_MANAGEMENT": "Exports",
    "ADMIN_IMPORT_MANAGEMENT": "Imports",
    "DISTRIBUTOR_EXTRACT_MANAGEMENT": "Exports",
    "KEY_ACCOUNT_EXTRACT_MANAGEMENT": "Exports",
    "KEY_ACCOUNT_PLATFORM_MANAGEMENT": "Plateforme",
    "KEY_ACCOUNT_REPAIR_FILE_MANAGEMENT": "Dossiers de réparation",
    "KEY_ACCOUNT_REPAIR_FILE_VIEW": "Consultation des dossiers"
  },
  "ERROR_STATUS_CODE_MESSAGE": {
    "200": "Requête réussie",
    "400": "Requête incorrecte",
    "401": "Votre session a expirée, veuillez vous identifier à nouveau",
    "403": "Action non autorisé",
    "404": "Page non trouvée",
    "405": "Requête inconnue",
    "413": "Fichier trop volumineux",
    "500": "Erreur interne du serveur",
    "502": "Erreur de réseau",
    "504": "Temps d'attente dépassé",
    "524": "Le traitement a pris trop de temps et a été interrompu. Vérifiez si vos données ont bien été importées.",
    "NOT_REDIRECT": "Redirection impossible",
    "UNKNOWN": "Une erreur inconnue est survenue"
  },
  "ERROR": {
    "ACCOUNT_NOT_FOUND_ERROR": "Compte introuvable.",
    "ADDITIONAL_REPAIR_COST_ERROR": "Surcoûts de réparation invalides.",
    "ALTERNATIVE_REPAIR_CENTER_NOT_FOUND_ERROR": "Centre de réparation alternatif introuvable.",
    "BILLING_NOT_FOUND_ERROR": "Facturation introuvable.",
    "BILLING_NUMBER_ERROR": "Numéro de facturation invalide.",
    "CANT_DEACTIVATED_COLLABORATOR_ERROR": "Impossible de désactiver ce collaborateur.",
    "CATEGORY_HAS_PRODUCTS_ERROR": "Catégorie contenant toujours des produits.",
    "CHRONOPOST_SHIPMENT_PARSING_ERROR": "Erreur lors de l'analyse des données retournées par Chronopost.",
    "CLOUD_STORAGE_INTEGRITY_PENDING_ERROR": "Un contrôle d'intégrité du stockage distant est déjà en cours.",
    "COLLABORATOR_NOT_FOUND_ERROR": "Collaborateur introuvable.",
    "DEPARTURE_ADDRESS_CITY_INVALID_ERROR": "Ville de départ invalide.",
    "DEPARTURE_ADDRESS_CONTACT_EMAIL_INVALID_ERROR": "Adresse email de contact de départ invalide.",
    "DEPARTURE_ADDRESS_CONTACT_NAME_INVALID_ERROR": "Nom de contact de départ invalide.",
    "DEPARTURE_ADDRESS_CONTACT_PHONE_INVALID_ERROR": "Numéro de téléphone de contact de départ invalide.",
    "DEPARTURE_ADDRESS_NAME_INVALID_ERROR": "Nom de l'adresse de départ invalide.",
    "DEPARTURE_ADDRESS_NOT_FOUND_ERROR": "Adresse de départ introuvable.",
    "DEPARTURE_ADDRESS_NUMBER_INVALID_ERROR": "Numéro de l'adresse de départ invalide.",
    "DEPARTURE_ADDRESS_STREET_INVALID_ERROR": "Rue de départ invalide.",
    "DEPARTURE_ADDRESS_ZIP_CODE_INVALID_ERROR": "Code postal de départ invalide.",
    "DUPLICATE_BOOMERANG_ID_ERROR": "L'identifiant Boomerang est déjà existant.",
    "DUPLICATE_NAME_ERROR": "Le nom est déjà existant.",
    "EMAIL_CLIENT_ERROR": "Adresse email du client invalide.",
    "EMAIL_COMMERCIAL_ERROR": "Adresse email de l'équipe commerciale invalide.",
    "EMAIL_PREPARER_ERROR": "Adresse email du préparateur logistique invalide.",
    "ESTIMATE_COST_ERROR": "Coût de réparation invalide.",
    "ESTIMATE_TRANSPORTER_COST_NOT_FOUND_ERROR": "Coût de transport estimatif invalide.",
    "EXPIRED_JWT_ERROR": "Token de connexion expiré. Veuillez vous reconnecter.",
    "EXPRESSIST_TRANSPORTER_CONNEXION_HAS_LINKS_ERROR": "Connexion transporteur expressiste possédant encore des liaisons actives.",
    "EXPRESSIST_TRANSPORTER_CONNEXION_DUPLICATE_SPECIAL_TYPE_ERROR": "Une connexion de ce type existe déjà pour ce transporteur expressiste.",
    "EXPRESSIST_TRANSPORTER_CONNEXION_INVALID_LOGIN_ERROR": "Identifiant de connexion transporteur expressiste invalide.",
    "EXPRESSIST_TRANSPORTER_CONNEXION_INVALID_PASSWORD_ERROR": "Mot de passe de connexion transporteur expressiste invalide.",
    "EXPRESSIST_TRANSPORTER_CONNEXION_INVALID_SERVICE_ERROR": "Service de connexion transporteur expressiste invalide.",
    "EXPRESSIST_TRANSPORTER_CONNEXION_LINK_ALREADY_EXISTS_ERROR": "Liaison de connexion transporteur expressiste déjà existante.",
    "EXPRESSIST_TRANSPORTER_CONNEXION_LINK_KEY_ACCOUNT_NETWORK_NOT_FOUND_ERROR": "Réseau grand compte lié à cette liaison de connexion transporteur expressiste introuvable.",
    "EXPRESSIST_TRANSPORTER_CONNEXION_LINK_NETWORK_NOT_FOUND_ERROR": "Réseau lié à cette liaison de connexion transporteur expressiste introuvable.",
    "EXPRESSIST_TRANSPORTER_CONNEXION_LINK_NOT_FOUND_ERROR": "Liaison de connexion transporteur expressiste introuvable.",
    "EXPRESSIST_TRANSPORTER_CONNEXION_LINK_OPERATING_CENTER_NOT_FOUND_ERROR": "Centre d'exploitation lié à cette liaison de connexion transporteur expressiste introuvable.",
    "EXPRESSIST_TRANSPORTER_CONNEXION_LINK_STORE_NOT_FOUND_ERROR": "Magasin lié à cette liaison de connexion transporteur expressiste introuvable.",
    "EXPRESSIST_TRANSPORTER_CONNEXION_NOT_FOUND_ERROR": "Connexion transporteur expressiste introuvable.",
    "EXPRESSIST_TRANSPORTER_HAS_CONNEXIONS_ERROR": "Suppression impossible, connexions encore attachées à ce transporteur expressiste.",
    "EXPRESSIST_TRANSPORTER_DUPLICATE_TYPE_ERROR": "Un transporteur expressiste de ce type existe déjà.",
    "EXPRESSIST_TRANSPORTER_NOT_FOUND_ERROR": "Transporteur expressiste introuvable.",
    "EXPRESSIST_TRANSPORTER_NETWORK_NOT_FOUND_ERROR": "Réseau introuvable pour ce transporteur expressiste.",
    "EXPRESSIST_TRANSPORTER_LINK_PRIORITY_ERROR": "Priorité de liaison transporteur expressiste invalide.",
    "EXPRESSIST_TRANSPORTER_STORE_NOT_FOUND_ERROR": "Magasin lié à ce transporteur expressiste introuvable.",
    "FAILED_UPLOAD_ERROR": "Échec de l'ajout des photos.",
    "FILE_NOT_FOUND_ERROR": "Fichier introuvable.",
    "GROUP_NOT_FOUND_ERROR": "Groupe introuvable.",
    "GROUP_NUMBER_ALREADY_USED_ERROR": "Numéro de groupe déjà utilisé pour ce réseau.",
    "GROUP_NUMBER_NOT_AVAILABLE_ERROR": "Numéro de groupe indisponible.",
    "GUARANTEE_DUPLICATE_TYPE_ERROR": "Garantie de ce type déjà existante pour cette sous-catégorie.",
    "GUARANTEE_EXTENSION_INVALID_PRODUCT_ERROR": "Produit inexistant.",
    "GUARANTEE_EXTENSION_INVALID_SERIAL_NUMBER_ERROR": "Numéro de série invalide.",
    "GUARANTEE_EXTENSION_NOT_FOUND_ERROR": "Extension de garantie introuvable.",
    "GUARANTEE_INVALID_NETWORK_ERROR": "Réseau inexistant.",
    "GUARANTEE_INVALID_PRODUCT_TYPE_ERROR": "Type de produit invalide.",
    "GUARANTEE_INVALID_SUB_CATEGORY_ERROR": "Sous-catégorie inexistante.",
    "GUARANTEE_NOT_FOUND_ERROR": "Garantie introuvable.",
    "INVALID_ACCOUNT_ERROR": "Compte invalide.",
    "INVALID_ADDITIONAL_REPAIR_COST_ERROR": "Surcoûts de réparation invalides.",
    "INVALID_ADDRESS_ERROR": "Adresse invalide.",
    "INVALID_BILLING_ID_ERROR": "ID de facturation invalide.",
    "INVALID_BODY_ERROR": "Données envoyées invalides.",
    "SMS_NOTIFICATION_FAILED_ERROR": "Le SMS n'a pas pu être envoyé. Veuillez réessayer.",
    "SMS_SERVICE_UNAVAILABLE_ERROR": "Les notifications SMS sont indisponibles. Veuillez réessayer plus tard ou choisir un autre moyen de notification.",
    "INVALID_BOOMERANG_ID_ERROR": "Identifiant Boomerang invalide.",
    "INVALID_BOOMERANG_NAME_ERROR": "Nom Boomerang invalide.",
    "INVALID_BREAKDOWN_DESCRIPTION_ERROR": "Description de panne invalide.",
    "INVALID_BREAKDOWN_QUESTION_ERROR": "Question de panne invalide.",
    "INVALID_CALLBACK_REF_ERROR": "Référence invalide.",
    "INVALID_CAPTCHA_TOKEN_ERROR": "Token reCAPTCHA invalide.",
    "INVALID_CATEGORY_ERROR": "Catégorie invalide.",
    "INVALID_CLIENT_NUMBER_ERROR": "Numéro client invalide.",
    "INVALID_CLIENT_PRICE_ERROR": "Prix client invalide.",
    "INVALID_COLLABORATOR_ERROR": "Collaborateur invalide.",
    "INVALID_COMMENT_ERROR": "Commentaire invalide.",
    "INVALID_COMMERCIAL_GUARANTEE_ERROR": "Garantie commerciale invalide.",
    "INVALID_COMPANY_ERROR": "Entreprise invalide.",
    "INVALID_COMPANY_NAME_ERROR": "Nom de l'entreprise invalide.",
    "INVALID_CONSTRAINTS_ERROR": "Collecte indisponible pour cette adresse. Veuillez modifier l'adresse ou réessayer plus tard.",
    "INVALID_CONTACT_EMAIL_ERROR": "Email de contact invalide.",
    "INVALID_CONTEXT_ERROR": "Accès non autorisé.",
    "INVALID_DELIVERY_UPDATE_ACTION_TYPE_ERROR": "Action non autorisée.",
    "INVALID_DEPOSIT_DATE_ERROR": "Date de dépôt invalide.",
    "INVALID_DESCRIPTION_ERROR": "Description invalide.",
    "INVALID_DOCUMENT_LIST_ERROR": "Document envoyé invalide.",
    "INVALID_DUPLICATE_EMAIL_ERROR": "Email déjà existant.",
    "INVALID_DUPLICATE_ROLE_TITLE_ERROR": "Titre du rôle déjà existant.",
    "INVALID_EMAIL_ERROR": "Email invalide.",
    "MISSING_EMAIL_ERROR": "Aucun email n'est renseigné sur votre compte.",
    "INVALID_EXPORT_TYPE_ERROR": "Type d'export demandé invalide.",
    "INVALID_FILE_ERROR": "Fichier invalide.",
    "INVALID_FILE_FORMAT_ERROR": "Fichier devant être au format PDF, JPG, JPEG ou PNG.",
    "INVALID_FILE_NAME_ERROR": "Nom de fichier invalide.",
    "INVALID_FILE_TO_HEAVY_ERROR": "Fichier trop lourd.",
    "INVALID_FIRSTNAME_ERROR": "Prénom invalide.",
    "INVALID_FORBIDDEN_PERMISSION_ERROR": "Action interdite.",
    "INVALID_FORMATION_ONE_ERROR": "Formation 1 invalide.",
    "INVALID_FORMATION_THREE_ERROR": "Formation 3 invalide.",
    "INVALID_FORMATION_TWO_ERROR": "Formation 2 invalide.",
    "INVALID_GUARANTEE_CONFIGURATION_ERROR": "Configuration de la garantie invalide.",
    "INVALID_GUARANTEE_ERROR": "Garantie introuvable.",
    "INVALID_GUARANTEE_TYPE_ERROR": "Type de garantie invalide.",
    "INVALID_ID_ERROR": "ID invalide.",
    "INVALID_INTERNAL_COMMAND_NUMBER_ERROR": "Numéro de commande invalide.",
    "INVALID_JOB_DESCRIPTION_ERROR": "Description du poste invalide.",
    "INVALID_JOB_TYPE_ERROR": "Type de poste invalide.",
    "INVALID_JWT_ERROR": "Token de connexion invalide. Veuillez vous reconnecter.",
    "INVALID_LASTNAME_ERROR": "Nom de famille invalide.",
    "INVALID_MANUFACTURER_ERROR": "Fabricant invalide.",
    "INVALID_MANUFACTURER_NUMBER_ERROR": "Numéro de fabricant invalide.",
    "INVALID_NETWORK_ERROR": "Réseau invalide.",
    "INVALID_NEW_CONFIRM_PASSWORD_ERROR": "Mots de passe non identiques.",
    "INVALID_PASSWORD_ERROR": "Mot de passe invalide.",
    "INVALID_PERMISSION_CONFIGURATION_ERROR": "Configuration des permissions invalide.",
    "INVALID_PERMISSION_TYPE_ERROR": "Type de permission invalide.",
    "INVALID_PHONE_NUMBER_ERROR": "Numéro de téléphone invalide.",
    "INVALID_PRODUCTS_GUARANTEE_ERROR": "Garantie produit invalide.",
    "INVALID_PRODUCT_BREAKDOWN_ERROR": "Panne produit invalide.",
    "INVALID_PRODUCT_ERROR": "Produit invalide.",
    "INVALID_PROSPECT_MANUFACTURER_INFO_COMMENT_ERROR": "Commentaire invalide.",
    "INVALID_PROSPECT_MANUFACTURER_INFO_OPTION_ERROR": "Option de demande préalable invalide.",
    "INVALID_PROSPECT_MANUFACTURER_INFO_SUPPORT_NUMBER_ERROR": "Numéro de support de demande préalable invalide.",
    "INVALID_PURCHASE_ORDER_NUMBER_ERROR": "Numéro de commande invalide.",
    "INVALID_QUERY_PARAM_ERROR": "Filtres invalides.",
    "INVALID_RATING_EMAIL_TOKEN_ERROR": "Token invalide. Email non envoyé.",
    "INVALID_REPAIRER_ESTIMATE_EMAIL_TOKEN_ERROR": "Ce lien de validation est invalide ou a déjà été utilisé.",
    "INVALID_REAL_DELIVERY_DATE_ERROR": "Date de remise invalide.",
    "INVALID_RECYCLING_FOLDER_BOOMERANG_ID_ERROR": "Identifiant Boomerang du dossier de recyclage invalide.",
    "INVALID_RECYCLING_FOLDER_QR_CODE_TOKEN_ERROR": "Token généré par le QR code expiré.",
    "INVALID_RENTAL_FILE_CLIENT_EMAIL_ERROR": "Email du client du dossier de location invalide.",
    "INVALID_RENTAL_FILE_CLIENT_FULLNAME_ERROR": "Nom complet du client du dossier de location invalide.",
    "INVALID_RENTAL_FILE_CLIENT_PHONE_ERROR": "Téléphone du client du dossier de location invalide.",
    "INVALID_RENTAL_FILE_COMPANY_ADDRESS_CITY_ERROR": "Ville de l'adresse de l'entreprise du dossier de location invalide.",
    "INVALID_RENTAL_FILE_COMPANY_ADDRESS_COUNTRY_ERROR": "Pays de l'adresse de l'entreprise du dossier de location invalide.",
    "INVALID_RENTAL_FILE_COMPANY_ADDRESS_NAME_ERROR": "Nom de l'adresse de l'entreprise du dossier de location invalide.",
    "INVALID_RENTAL_FILE_COMPANY_ADDRESS_NUMBER_ERROR": "Numéro de l'adresse de l'entreprise du dossier de location invalide.",
    "INVALID_RENTAL_FILE_COMPANY_ADDRESS_STREET_ERROR": "Rue de l'adresse de l'entreprise du dossier de location invalide.",
    "INVALID_RENTAL_FILE_COMPANY_ADDRESS_ZIP_CODE_ERROR": "Code postal de l'adresse de l'entreprise du dossier de location invalide.",
    "INVALID_RENTAL_FILE_COMPANY_NAME_ERROR": "Nom de l'entreprise du dossier de location invalide.",
    "INVALID_RENTAL_FILE_DELIVERY_ADDRESS_CITY_ERROR": "Ville de l'adresse de livraison du dossier de location invalide.",
    "INVALID_RENTAL_FILE_DELIVERY_ADDRESS_COUNTRY_ERROR": "Pays de l'adresse de livraison du dossier de location invalide.",
    "INVALID_RENTAL_FILE_DELIVERY_ADDRESS_NAME_ERROR": "Nom de l'adresse de livraison du dossier de location invalide.",
    "INVALID_RENTAL_FILE_DELIVERY_ADDRESS_NUMBER_ERROR": "Numéro de l'adresse de livraison du dossier de location invalide.",
    "INVALID_RENTAL_FILE_DELIVERY_ADDRESS_STREET_ERROR": "Rue de l'adresse de livraison du dossier de location invalide.",
    "INVALID_RENTAL_FILE_DELIVERY_ADDRESS_ZIP_CODE_ERROR": "Code postal de l'adresse de livraison du dossier de location invalide.",
    "INVALID_RENTAL_FILE_DESIRED_CUSTOMER_RECEIPT_DATE_ERROR": "Date de réception souhaitée du dossier de location invalide.",
    "INVALID_RENTAL_FILE_DESIRED_DEPOSIT_TYPE_ERROR": "Type de dépôt souhaité du dossier de location invalide.",
    "INVALID_RENTAL_FILE_FORCE_PASS_ERROR": "Passage forcé du dossier de location invalide.",
    "INVALID_RENTAL_FILE_PRODUCT_ID_ERROR": "Identifiant produit du dossier de location invalide.",
    "INVALID_RENTAL_FILE_PRODUCT_AVAILABILITY_ERROR": "Ce produit n'est plus disponible à la location. Veuillez sélectionner un autre produit.",
    "INVALID_RENTAL_FILE_QR_CODE_COLLABORATOR_ERROR": "Collaborateur du QR code du dossier de location invalide.",
    "INVALID_RENTAL_FILE_QR_CODE_TOKEN_ERROR": "Token du QR code du dossier de location invalide.",
    "INVALID_RENTAL_FILE_QR_CODE_TOKEN_NOT_USED_ERROR": "Token du QR code du dossier de location non utilisé.",
    "INVALID_RENTAL_FILE_RENTAL_REPAIR_FILE_ALREADY_EXISTS_ERROR": "Dossier de réparation déjà existant pour ce dossier de location.",
    "INVALID_RENTAL_FILE_REPAIR_FILE_ERROR": "Dossier de réparation du dossier de location invalide.",
    "INVALID_RENTAL_FILE_STATUS_ERROR": "Statut du dossier de location invalide.",
    "INVALID_RENTAL_FILE_STATUS_TRANSPORT_GO_TRACKING_NUMBER_ERROR": "Numéro de suivi du transport aller du dossier de location invalide.",
    "INVALID_RENTAL_FILE_STATUS_TRANSPORT_GO_TRANSPORT_TYPE_ERROR": "Type de transport aller du dossier de location invalide.",
    "INVALID_RENTAL_FILE_STATUS_UPDATE_DATE_ERROR": "Date de mise à jour du statut du dossier de location invalide.",
    "INVALID_REPAIRER_ERROR": "Réparateur invalide.",
    "INVALID_REPAIRER_EXPEDITION_DATE_ERROR": "Date d'expédition du réparateur invalide.",
    "INVALID_REPAIRER_REPAIR_FILE_NUMBER_ERROR": "Numéro de dossier de réparation invalide.",
    "INVALID_REPAIRER_SUPPORT_NUMBER_ERROR": "Numéro de dossier du réparateur invalide.",
    "INVALID_REPAIR_FILE_BOOMERANG_ID_ERROR": "Identifiant Boomerang du dossier de réparation invalide.",
    "INVALID_REPAIR_FILE_LIMIT_DATE_ERROR": "Date limite du dossier de réparation invalide.",
    "INVALID_REPAIR_FILE_MAIL_CONTENT_ERROR": "Contenu du mail du dossier de réparation invalide.",
    "INVALID_REPAIR_FILE_MANUAL_STATUS_UPDATE_ERROR": "Mise à jour manuelle du statut du dossier de réparation invalide.",
    "INVALID_REPAIR_FILE_QR_CODE_TOKEN_ERROR": "Token du QR code du dossier de réparation invalide.",
    "INVALID_REPAIR_FILE_QUESTIONNAIRE_REDIRECT_URL_ERROR": "URL de redirection du questionnaire invalide.",
    "INVALID_REPAIR_FILE_RATING_ERROR": "Note du dossier de réparation invalide.",
    "INVALID_REPAIR_FILE_STATUS_DETAIL_ERROR": "Détail du statut du dossier de réparation invalide.",
    "INVALID_REP_CODE_ERROR": "Code représentant invalide.",
    "INVALID_REP_NUMBER_ERROR": "Numéro de représentant invalide.",
    "INVALID_REQUEST_ERROR": "Requête invalide.",
    "INVALID_RETURN_ADDRESS_ERROR": "Adresse de retour invalide.",
    "INVALID_ROLE_TYPE_ERROR": "Type du rôle invalide. Valeurs attendues : Administrateur ou Distributeur.",
    "INVALID_SERIAL_NUMBER_ERROR": "Numéro de série invalide.",
    "INVALID_STORE_ERROR": "Magasin invalide.",
    "INVALID_SUB_CATEGORY_ERROR": "Sous-catégorie invalide.",
    "INVALID_SUB_STATUS_ERROR": "Sous-statut invalide.",
    "INVALID_TEMPORARY_MESSAGE_END_DATE_ERROR": "Date de fin du message temporaire invalide.",
    "INVALID_TEMPORARY_MESSAGE_FOOTER_ERROR": "Pied de page du message temporaire invalide.",
    "INVALID_TEMPORARY_MESSAGE_MAIN_CONTENT_ERROR": "Contenu principal du message temporaire invalide.",
    "INVALID_TEMPORARY_MESSAGE_START_DATE_ERROR": "Date de début du message temporaire invalide.",
    "INVALID_TEMPORARY_MESSAGE_SUBTITLE_ERROR": "Sous-titre du message temporaire invalide.",
    "INVALID_TEMPORARY_MESSAGE_SUB_CONTENT_ERROR": "Sous-contenu du message temporaire invalide.",
    "INVALID_TEMPORARY_MESSAGE_TITLE_ERROR": "Titre du message temporaire invalide.",
    "INVALID_TITLE_ERROR": "Titre invalide.",
    "INVALID_TOKEN_ERROR": "Token de connexion invalide. Veuillez vous reconnecter.",
    "LOGIN_2FA_REQUIRED_ERROR": "Vérification 2FA requise.",
    "INVALID_LOGIN_2FA_CODE_ERROR": "Code de vérification invalide.",
    "EXPIRED_LOGIN_2FA_CODE_ERROR": "Code de vérification expiré.",
    "LOGIN_2FA_ATTEMPT_LIMIT_REACHED_ERROR": "Trop de tentatives de vérification. Veuillez recommencer la connexion.",
    "LOGIN_2FA_RESEND_LIMIT_REACHED_ERROR": "Renvoyez le code plus tard.",
    "INVALID_TRACK_NUMBER_ERROR": "Numéro de suivi invalide.",
    "INVALID_TYPE_ERROR": "Type de composant invalide.",
    "INVALID_UPDATE_STATUS_DATE_ERROR": "Date de mise à jour du statut invalide.",
    "ITECH_CLIENT_NOT_FOUND_ERROR": "Client introuvable pour le service ITECH. Veuillez contacter un administrateur Boomerang.",
    "ITECH_CLIENT_PARAM_MISSING_ERROR": "Paramètre client manquant pour le service ITECH.",
    "ITECH_DOCUMENT_INTEGRATION_ERROR": "Service ITECH a renvoyé : {params}. Veuillez contacter un administrateur Boomerang.",
    "ITECH_DOCUMENT_LINES_NOT_FOUND_ERROR": "Lignes du document ITECH introuvables.",
    "ITECH_ENVIRONMENT_NOT_CONFIGURED_ERROR": "Environnement non paramétré sur ITECH. Veuillez contacter un administrateur Boomerang.",
    "ITECH_GENERIC_ERROR": "Service ITECH incapable de délivrer une réponse complète.",
    "ITECH_HEADER_NOT_FOUND_ERROR": "En-tête ITECH introuvable.",
    "ITECH_INVALID_CREDENTIALS_ERROR": "Identifiants ITECH invalides.",
    "ITECH_INVALID_FILTER_ERROR": "Filtre ITECH invalide.",
    "ITECH_INVALID_FORMAT_ERROR": "Format ITECH invalide.",
    "ITECH_INVALID_OR_EXPIRED_TOKEN_ERROR": "Token ITECH invalide ou expiré.",
    "ITECH_LINE_ERRORS_PRESENT_ERROR": "Erreurs présentes dans les lignes ITECH.",
    "ITECH_MODIFICATION_FORBIDDEN_ERROR": "Modification ITECH interdite.",
    "ITECH_MODIFICATION_NOT_APPLIED_ERROR": "Modification ITECH non appliquée.",
    "ITECH_PRODUCTS_PARAM_MISSING_ERROR": "Paramètre produit manquant pour le service ITECH.",
    "ITECH_PRODUCT_NOT_FOUND_ERROR": "Service ITECH a renvoyé : {params}. Veuillez contacter un administrateur Boomerang.",
    "ITECH_REQUEST_CODE_NOT_FOUND_ERROR": "Code de requête ITECH introuvable.",
    "ITECH_TABLE_NOT_ACCESSIBLE_ERROR": "Table ITECH non accessible.",
    "ITECH_TABLE_NOT_FOUND_ERROR": "Table ITECH introuvable.",
    "LABOR_COST_ERROR": "Coût de main-d'œuvre invalide.",
    "LEAVE_REASON_INVALID_ERROR": "Raison de départ invalide.",
    "LIMIT_REACHED_ERROR": "Limite atteinte.",
    "MANUFACTURER_HAS_PRODUCTS_ERROR": "Fabricant contenant toujours des produits.",
    "MANUFACTURER_NOT_FOUND_ERROR": "Fabricant introuvable.",
    "MARGIN_ERROR": "Marge invalide.",
    "MODEL_SERIAL_NUMBER_NOT_FOUND_ERROR": "Numéro de série introuvable.",
    "MODEL_SERIAL_NUMBER_PRODUCT_TYPE_NOT_FOUND_ERROR": "Numéro de série introuvable.",
    "NETWORK_NOT_FOUND_ERROR": "Réseau introuvable.",
    "KEY_ACCOUNT_GROUP_NOT_FOUND_ERROR": "Groupement introuvable.",
    "KEY_ACCOUNT_NETWORK_NOT_FOUND_ERROR": "Réseau grand compte introuvable.",
    "NETWORK_NOT_FOUND_FOR_LINK_ERROR": "Connexion au réseau introuvable.",
    "NOTIFICATION_INVALID_CONTENT_ERROR": "Contenu de la notification invalide.",
    "NOTIFICATION_INVALID_REDIRECTION_MESSAGE_ERROR": "Message de redirection de la notification invalide.",
    "NOTIFICATION_INVALID_REDIRECTION_STATUS_ERROR": "Statut de redirection de la notification invalide.",
    "NOTIFICATION_INVALID_REDIRECTION_URL_ERROR": "URL de redirection de la notification invalide.",
    "NOTIFICATION_INVALID_SUBTITLE_ERROR": "Sous-titre de la notification invalide.",
    "NOTIFICATION_INVALID_TITLE_ERROR": "Titre de la notification invalide.",
    "NOTIFICATION_NOT_FOUND_ERROR": "Notification introuvable.",
    "NOT_EMPTY_LIST_ERROR": "Rôle encore utilisé par certains comptes.",
    "NOT_FOUND_CLIENT_NUMBER_ERROR": "Numéro client introuvable.",
    "NOT_FOUND_ERROR": "Entité introuvable.",
    "NOT_FOUND_REGION_CODE_ERROR": "Code région introuvable.",
    "NOT_FOUND_SUPPLIER_CODE_ERROR": "Paramétrage nécessaire du compte client chez réparateur. Contacter BOOMERANG.",
    "NOT_FOUND_TEMPORARY_MESSAGE_ERROR": "Message temporaire introuvable.",
    "NO_MORE_GROUP_NUMBER_AVAILABLE_ERROR": "Aucun numéro de groupe disponible.",
    "NO_MULTI_COLLABORATOR_ACCOUNT_ERROR": "Compte n'acceptant pas plusieurs collaborateurs.",
    "OFFER_TYPE_ALREADY_EXIST_ERROR": "Type d'offre déjà existant.",
    "OFFER_TYPE_ERROR": "Type d'offre invalide.",
    "PACKAGE_AMPERE_INVALID_ERROR": "Ampérage du colis invalide.",
    "PACKAGE_CHECK_BOX_INVALID_ERROR": "Case à cocher du colis invalide.",
    "PACKAGE_LENGTH_INVALID_ERROR": "Longueur du colis invalide.",
    "PACKAGE_NOT_FOUND_ERROR": "Forfait introuvable.",
    "PACKAGE_WATT_HOUR_INVALID_ERROR": "Wattheure du colis invalide.",
    "PACKAGE_WATT_INVALID_ERROR": "Wattage du colis invalide.",
    "PACKAGE_WEIGHT_INVALID_ERROR": "Poids du colis invalide.",
    "PACKET_WIDTH_INVALID_ERROR": "Largeur du colis invalide.",
    "PRICING_TYPE_INVALID_ERROR": "Type de tarification invalide.",
    "PRODUCT_BOOMERANG_ID_INVALID_ERROR": "Identifiant Boomerang du produit invalide.",
    "PRODUCT_BREAKDOWN_ALREADY_ASSOCIATED_ERROR": "Panne produit déjà associée.",
    "PRODUCT_BREAKDOWN_INVALID_MANUFACTURER_ERROR": "Fabricant invalide pour cette panne.",
    "PRODUCT_BREAKDOWN_INVALID_PRODUCT_ERROR": "Produit invalide pour cette panne.",
    "PRODUCT_BREAKDOWN_INVALID_SUB_CATEGORY_ERROR": "Sous-catégorie invalide pour cette panne.",
    "PRODUCT_BREAKDOWN_NOT_ASSOCIATED_ERROR": "Panne non associée.",
    "PRODUCT_BREAKDOWN_NOT_FOUND_ERROR": "Panne introuvable.",
    "PRODUCT_BUY_FILE_PROOF_ERROR": "Preuve d'achat du produit invalide.",
    "PRODUCT_CONDITION_NOT_FOUND_ERROR": "État du produit introuvable.",
    "PRODUCT_END_COST_INVALID_ERROR": "Coût final du produit invalide.",
    "PRODUCT_END_STATUS_INVALID_ERROR": "Statut final du produit invalide.",
    "PRODUCT_FORCE_SUPPORT_FILE_PROOF_ERROR": "Preuve de prise en charge forcée invalide.",
    "PRODUCT_GUARANTEE_EXTENSION_FILE_PROOF_ERROR": "Preuve d'extension de garantie invalide.",
    "PRODUCT_IMAGE_REQUIRED_ERROR": "Image du produit requise.",
    "PRODUCT_INVALID_CATEGORY_ERROR": "Catégorie invalide.",
    "PRODUCT_INVALID_MANUFACTURER_ERROR": "Fabricant invalide.",
    "PRODUCT_INVALID_SUB_CATEGORY_ERROR": "Sous-catégorie invalide.",
    "PRODUCT_INVALID_TYPE_ERROR": "Type de produit invalide.",
    "PRODUCT_NOT_FOUND_ERROR": "Produit introuvable.",
    "PRODUCT_QUESTION_MAX_QUESTIONS_ERROR": "Nombre maximum de questions atteint.",
    "PRODUCT_QUESTION_NOT_FOUND_ERROR": "Question introuvable.",
    "PRODUCT_SUB_PRODUCT_ALREADY_EXISTS_ERROR": "Sous-catégorie déjà associée.",
    "PRODUCT_SUB_PRODUCT_NOT_FOUND_ERROR": "Sous-catégorie introuvable.",
    "PRODUCT_VERSION_NOT_FOUND_ERROR": "Version du produit introuvable.",
    "PROSPECT_ADDITIONAL_INFO_ERROR": "Informations complémentaires du prospect invalides.",
    "INVALID_SUB_CATEGORY_PICTURE_ERROR": "L'illustration de la demande préalable doit être une image valide.",
    "SUB_CATEGORY_PICTURE_UPLOAD_ERROR": "Impossible d'envoyer l'illustration de la demande préalable. Veuillez réessayer.",
    "PROSPECT_CONTACT_EMAIL_ERROR": "Email de contact du prospect invalide.",
    "RECONDITIONER_CENTER_LINK_NOT_FOUND_ERROR": "Liaison centre de reconditionnement introuvable.",
    "RECONDITIONER_CENTER_LINK_STORE_NOT_FOUND_ERROR": "Liaison magasin centre de reconditionnement introuvable.",
    "RECONDITIONER_CENTER_NOT_FOUND_ERROR": "Centre de reconditionnement introuvable.",
    "RECONDITIONER_NOT_FOUND_ERROR": "Reconditionneur introuvable.",
    "RECYCLER_BAC_CENTER_LINK_NOT_FOUND_ERROR": "Liaison centre BAC introuvable.",
    "RECYCLER_BAC_HAS_CENTERS_ERROR": "Suppression impossible, BAC toujours associé à un ou plusieurs centres de reconditionnement ou de recyclage.",
    "RECYCLER_BAC_NOT_FOUND_ERROR": "Recycleur BAC introuvable.",
    "RECYCLER_CENTER_LINK_NOT_FOUND_ERROR": "Liaison centre de recyclage introuvable.",
    "RECYCLER_CENTER_LINK_STORE_NOT_FOUND_ERROR": "Liaison magasin centre de recyclage introuvable.",
    "RECYCLER_CENTER_NOT_FOUND_ERROR": "Centre de recyclage introuvable.",
    "RECYCLER_NOT_FOUND_ERROR": "Recycleur introuvable.",
    "RECYCLING_BAC_NOT_FOUND_ERROR": "BAC de recyclage introuvable.",
    "RECYCLING_BOOMERANG_ID_NOT_FOUND_ERROR": "Aucun reconditionneur ou recycleur trouvé pour ce produit. Veuillez contacter l'administration Boomerang.",
    "RECYCLING_BUYBACK_PRICE_INVALID_PRODUCT_BOOMERANG_ID_ERROR": "Prix de rachat recyclage invalide pour ce produit.",
    "RECYCLING_FOLDER_ATTACHMENT_NOT_FOUND_ERROR": "Fichier attaché à ce dossier de recyclage introuvable.",
    "RECYCLING_FOLDER_NOT_FOUND_ERROR": "Dossier de recyclage introuvable.",
    "REGION_CODE_ASSOCIATION_ERROR": "Code de région toujours associé à un groupe ou un magasin.",
    "REGION_CODE_INVALID_COUNTRY_NAME_ERROR": "Nom du pays invalide.",
    "REGION_CODE_INVALID_REGION_CODE_ERROR": "Code de région invalide.",
    "REGION_CODE_INVALID_REGION_NAME_ERROR": "Nom de région invalide.",
    "REGION_CODE_NOT_FOUND_ERROR": "Code de région introuvable.",
    "RENTAL_FILE_ATTACHMENT_RENTAL_FILE_NOT_FOUND_ERROR": "Dossier de location introuvable.",
    "RENTAL_FILE_DELIVERY_ADDRESS_NOT_FOUND_ERROR": "Adresse de livraison du dossier de location introuvable.",
    "RENTAL_FILE_NETWORK_NOT_FOUND_ERROR": "Réseau du dossier de location introuvable.",
    "RENTAL_FILE_NOT_FOUND_ERROR": "Dossier de location introuvable.",
    "RENTAL_FILE_RENTAL_PRODUCT_ADDITIONAL_COST_NOT_FOUND_ERROR": "Surcoût du produit de location introuvable.",
    "RENTAL_FILE_RENTAL_PRODUCT_PACKAGE_NOT_FOUND_ERROR": "Colis du produit de location introuvable.",
    "RENTAL_FILE_STATUS_NOT_FOUND_ERROR": "Statut du dossier de location introuvable.",
    "RENTAL_FILE_STORE_NOT_FOUND_ERROR": "Magasin du dossier de location introuvable.",
    "RENTAL_PAGINATED_PRODUCT_REPAIR_FILE_BOOMERANG_ID_ERROR": "Identifiant Boomerang du dossier de réparation du produit de location invalide.",
    "RENTAL_PRODUCT_INVALID_AVAILABILITY_STATUS_ERROR": "Statut de disponibilité du produit de location invalide.",
    "RENTAL_PRODUCT_NOT_FOUND_ERROR": "Produit de location introuvable.",
    "REPAIRER_ESTIMATE_ALREADY_EXIST_ERROR": "Devis du réparateur déjà existant.",
    "REPAIRER_ESTIMATE_NOT_FOUND_ERROR": "Devis du réparateur introuvable.",
    "REPAIRER_ESTIMATE_OPTION_ERROR": "Option du devis du réparateur invalide.",
    "REPAIRER_NOT_FOUND_ERROR": "Réparateur introuvable.",
    "REPAIR_CENTER_INVALID_REPAIRER_ERROR": "Réparateur introuvable pour ce centre de réparation.",
    "REPAIR_CENTER_LINK_CATEGORY_NOT_LINKED_ERROR": "Liaison catégorie - centre de réparation introuvable.",
    "REPAIR_CENTER_LINK_INVALID_CATEGORY_ERROR": "Catégorie invalide pour cette liaison centre de réparation.",
    "REPAIR_CENTER_LINK_INVALID_SUB_CATEGORY_ERROR": "Sous-catégorie invalide pour cette liaison centre de réparation.",
    "REPAIR_CENTER_LINK_INVALID_MANUFACTURER_ERROR": "Fabricant invalide pour cette liaison centre de réparation.",
    "REPAIR_CENTER_LINK_INVALID_NETWORK_ERROR": "Réseau invalide pour cette liaison centre de réparation.",
    "REPAIR_CENTER_LINK_INVALID_KEY_ACCOUNT_NETWORK_ERROR": "Réseau grand compte invalide pour cette liaison centre de réparation.",
    "REPAIR_CENTER_LINK_INVALID_REPAIR_CENTER_ERROR": "Centre de réparation invalide pour cette liaison centre de réparation.",
    "REPAIR_CENTER_LINK_INVALID_STORE_ERROR": "Magasin invalide pour cette liaison centre de réparation.",
    "REPAIR_CENTER_LINK_INVALID_OPERATING_CENTER_ERROR": "Centre d'exploitation invalide pour cette liaison centre de réparation.",
    "REPAIR_CENTER_LINK_MANUFACTURER_NOT_LINKED_ERROR": "Fabricant non lié à cette liaison centre de réparation.",
    "REPAIR_CENTER_LINK_NOT_FOUND_ERROR": "Liaison centre de réparation introuvable.",
    "REPAIR_CENTER_LINK_STORE_NOT_LINKED_ERROR": "Magasin non lié à cette liaison centre de réparation.",
    "REPAIR_CENTER_LINK_OPERATING_CENTER_NOT_LINKED_ERROR": "Centre d'exploitation non lié à cette liaison centre de réparation.",
    "REPAIR_CENTER_LINK_SUB_CATEGORY_NOT_LINKED_ERROR": "Sous-catégorie non liée à cette liaison centre de réparation.",
    "REPAIR_CENTER_NOT_FOUND_ERROR": "Centre de réparation introuvable.",
    "OPERATING_CENTER_INVALID_RATING_REDIRECT_ERROR": "Lien de redirection introuvable pour ce centre d'exploitation.",
    "REPAIR_FILE_ATTACHMENT_NOT_FOUND_ERROR": "Pièce jointe du dossier de réparation introuvable.",
    "REPAIR_FILE_ATTACHMENT_TYPE_ERROR": "Type de pièce jointe du dossier de réparation invalide.",
    "REPAIR_FILE_COMMENT_NOT_FOUND_ERROR": "Commentaire du dossier de réparation introuvable.",
    "REPAIR_FILE_NOT_FOUND_ERROR": "Dossier de réparation introuvable.",
    "REPAIR_FILE_REPAIR_CENTER_NOT_FOUND_ERROR": "Aucun centre de réparation n'est associé à ce dossier de réparation.",
    "REPAIR_FILE_PROSPECT_DOCUMENT_NOT_FOUND_ERROR": "Document prospect du dossier de réparation introuvable.",
    "REPAIR_FILE_PROSPECT_PICTURE_NOT_FOUND_ERROR": "Photo prospect du dossier de réparation introuvable.",
    "REPAIR_FILE_STATUS_CLIENT_PHONE_NOTIFICATION_TYPE_ERROR": "Type de notification téléphonique du client invalide.",
    "REPAIR_FILE_STATUS_CLIENT_TAKEOVER_TYPE_ERROR": "Type de prise en charge client invalide.",
    "REPAIR_FILE_STATUS_DETAIL_ERROR": "Détail du statut du dossier de réparation invalide.",
    "REPAIR_FILE_STORE_ERP_INTERNAL_ERROR": "Erreur interne ERP du magasin pour le dossier de réparation.",
    "RETURN_ADDRESS_CITY_INVALID_ERROR": "Ville de l'adresse de retour invalide.",
    "RETURN_ADDRESS_CONTACT_EMAIL_INVALID_ERROR": "Email de contact de l'adresse de retour invalide.",
    "RETURN_ADDRESS_CONTACT_NAME_INVALID_ERROR": "Nom de contact de l'adresse de retour invalide.",
    "RETURN_ADDRESS_CONTACT_PHONE_INVALID_ERROR": "Téléphone de contact de l'adresse de retour invalide.",
    "RETURN_ADDRESS_NAME_INVALID_ERROR": "Nom de l'adresse de retour invalide.",
    "RETURN_ADDRESS_NUMBER_INVALID_ERROR": "Numéro de l'adresse de retour invalide.",
    "RETURN_ADDRESS_STREET_INVALID_ERROR": "Rue de l'adresse de retour invalide.",
    "RETURN_ADDRESS_ZIP_CODE_INVALID_ERROR": "Code postal de l'adresse de retour invalide.",
    "SHIPPING_COLLECT_DATE_INVALID_ERROR": "Date de collecte d'expédition invalide.",
    "SHIPPING_COLLECT_STATUS_INVALID_ERROR": "Statut de collecte d'expédition invalide.",
    "STATUS_ERROR": "Statut invalide.",
    "STORE_INVALID_GROUP_ERROR": "Groupe introuvable pour ce magasin.",
    "STORE_INVALID_MANUFACTURER_ERROR": "Fabricant introuvable pour ce magasin.",
    "STORE_INVALID_RATING_REDIRECT_ERROR": "Lien de redirection introuvable pour ce magasin.",
    "STORE_INVALID_REGION_CODE_ERROR": "Code de région introuvable pour ce magasin.",
    "STORE_INVALID_REPAIRER_ERROR": "Réparateur introuvable pour ce magasin.",
    "STORE_INVALID_REPAIR_CENTER_ERROR": "Centre de réparation introuvable pour ce magasin.",
    "STORE_INVALID_SIRET_ERROR": "SIRET invalide.",
    "STORE_ERP_ACCOUNT_REQUIRED_ERROR": "Code Magasin ERP requis pour ce magasin.",
    "STORE_ERP_STORE_BEACON_CODE_REQUIRED_ERROR": "Code Balise magasin requis pour ce magasin.",
    "STORE_ERP_STORE_BEACON_CODE_INVALID_ERROR": "Le Code Balise magasin doit contenir au maximum 20 caractères (contournement temporaire).",
    "STORE_MILWAUKEE_ACCOUNT_REQUIRED_ERROR": "Compte Milwaukee requis pour ce magasin.",
    "STORE_MILWAUKEE_PASSWORD_REQUIRED_ERROR": "Mot de passe Milwaukee requis pour ce magasin.",
    "STORE_NOT_FOUND_ERROR": "Magasin introuvable.",
    "STORE_NOT_FOUND_FOR_LINK_ERROR": "Magasin introuvable pour cette liaison.",
    "SUB_CATEGORY_HAS_PRODUCTS_ERROR": "Sous-catégorie contenant toujours des produits.",
    "SUB_CATEGORY_NOT_FOUND_ERROR": "Sous-catégorie introuvable.",
    "TOO_MANY_REPAIR_CENTER_FOUND_ERROR": "Trop de centres de réparation trouvés.",
    "TOTAL_COST_ERROR": "Coût total invalide.",
    "TRANSPORTER_EXPRESSIST_INVALID_ERROR": "Transporteur expressiste invalide.",
    "TRANSPORTER_EXPRESSIST_NOT_FOUND_ERROR": "Transporteur expressiste introuvable.",
    "TRANSPORTER_MODALITY_INVALID_ERROR": "Modalité du transporteur invalide.",
    "TRANSPORTER_NAME_INVALID_ERROR": "Nom du transporteur invalide.",
    "TRANSPORTER_NOT_FOUND_ERROR": "Transporteur introuvable.",
    "TRANSPORTER_TYPE_INVALID_ERROR": "Type de transporteur invalide.",
    "TRANSPORT_COST_ERROR": "Coût de transport invalide.",
    "TRANSPORT_PACKAGE_NOT_FOUND_ERROR": "Forfait transport introuvable.",
    "UNAUTHORIZED_ENTITY_ACCESS_ERROR": "Accès non autorisé à certaines ressources.",
    "UNEXPECTED_ERROR": "Erreur inattendue générée.",
    "UNSUPPORTED_ATTACHMENT_TYPE_ERROR": "Type de pièce jointe non supporté.",
    "USER_ALREADY_EXISTS_ERROR": "Utilisateur déjà existant."
  },
  "DISCONNECT": {
    "MESSAGE": "Vous avez été déconnecté"
  },
  "STATUS": {
    "PENDING": "En attente",
    "AWAITING_INFORMATION": "En attente d'informations",
    "SENDING": "En cours d'envoi",
    "SENT": "Envoyé",
    "SUCCESS": "Succès",
    "ERROR": "Écart détecté",
    "FAILED": "Échec technique",
    "FAILURE": "Échec",
    "TECHNICAL_FAILURE": "Échec technique",
    "POST_SEND_FAILURE": "Échec post-envoi",
    "CANCELLED": "Annulé",
    "INACTIVE": "Inactif",
    "ACTIVE": "Actif",
    "DELETED": "Supprimé",
    "APPROVED": "Approuvé",
    "DENIED": "Refusé"
  },
  "INFO_QUALITY": {
    "MISSING": "Manquant",
    "PARTIAL": "Partiel",
    "COMPLETE": "Complet"
  },
  "LAYOUTS": {
    "DASHBOARD": "Accueil",
    "REPAIR_FILE": "Dossier",
    "ACCOUNTS": "Compte",
    "DISTRIBUTOR_NETWORK": "Réseau distributeur",
    "KEY_ACCOUNT_NETWORK": "Réseau grand compte",
    "KEY_ACCOUNT_GROUP": "Groupement grand compte",
    "OPERATING_CENTER": "Centre d'exploitation",
    "MANUFACTURERS": "Produit",
    "REPAIRMAN": "Réparateur",
    "TRANSPORTER": "Transporteur",
    "OTHER_MANAGEMENT": "Autres",
    "LOGOUT": "Déconnexion",
    "PROFILE": "Profil",
    "RENTAL_MODULE": "Location",
    "RECYCLING_MODULE": "Recyclage",
    "KEY_ACCOUNT_PRODUCT": "Parc produit",
    "EMAIL_OUTBOX": "Emails",
    "IMPORTS_EXPORTS": "Imports & Exports"
  },
  "DISTRIBUTOR_NETWORKS_PAGE": {
    "TITLE": {
      "HEADER_NETWORK": "Réseaux distributeurs",
      "HEADER_GROUP": "Groupements distributeurs",
      "HEADER_STORE": "Magasins",
      "HEADER_MANUFACTURER": "Fabricants"
    },
    "SUBTITLE": {
      "HEADER_NETWORK": "Liste des réseaux distributeurs",
      "HEADER_GROUP": "Liste des groupements distributeurs",
      "HEADER_STORE": "Liste des magasins distributeurs"
    },
    "BUTTON": {
      "NEW_NETWORK": "Nouveau réseau distributeur",
      "NEW_GROUP": "Nouveau groupement distributeur",
      "NEW_STORE": "Nouveau magasin",
      "NETWORK": "Réseaux",
      "GROUP": "Groupements",
      "STORE": "Magasins",
      "MANUFACTURER": "Fabricants"
    }
  },
  "DISTRIBUTOR_GROUP_PAGE": {
    "PLACEHOLDER": {
      "NETWORK": "Sélectionner le réseau",
      "REGION": "Sélectionner la zone",
      "STATUS": "Sélectionner le statut"
    },
    "TABLE": {
      "GROUP_NUMBER": "Numéros du groupement",
      "NETWORK": "Réseau",
      "GROUP": "Groupement",
      "AUTHORIZATION_EMAIL": "Email autorisation",
      "REGION": "Zone"
    },
    "MESSAGE": {
      "SUCCESS": "Le groupement a été supprimé avec succès."
    },
    "MODAL": {
      "TITLE": "Suppression d’un groupement",
      "MESSAGE": "Voulez-vous vraiment supprimer {group}?",
      "WARNING": "Cette action est irréversible."
    },
    "EXPORT_SUCCESS": "L'export des groupements a été effectué et sera envoyé par mail"
  },
  "CREATE_DISTRIBUTOR_GROUP_PAGE": {
    "TITLE": {
      "HEADER": "Nouveau groupement distributeur",
      "SUBTITLE": "Formulaire d'ajout d'un groupement distributeur"
    },
    "FORM": {
      "GROUP_INFO": "Informations du groupement",
      "LABEL_NETWORK": "Réseau",
      "LABEL_REGION": "Zone",
      "LABEL_NAME": "Nom",
      "LABEL_AUTHORIZATION_EMAIL": "Email autorisation",
      "LABEL_NUMBER": "Numéro",
      "OTHER": "autre",
      "OTHERS": "autres"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'ajout du groupement"
    },
    "MESSAGE": {
      "SUCCESS": "Le groupement a été ajouté avec succès",
      "ERROR": "Impossible d'ajouter le groupement"
    },
    "PLACEHOLDER": {
      "NETWORK": "Sélectionner un réseau",
      "NAME": "Ex : Île-de-France",
      "REGION": "Sélectionner une zone",
      "AUTHORIZATION_EMAIL": "Ex : contact{'@'}exemple.fr"
    }
  },
  "EDIT_DISTRIBUTOR_GROUP_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'un groupement distributeur",
      "SUBTITLE": "Formulaire d'édition d'un groupement distributeur"
    },
    "FORM": {
      "GROUP_INFO": "Informations du groupement",
      "LABEL_NETWORK": "Réseau",
      "LABEL_AUTHORIZATION_EMAIL": "Email autorisation",
      "LABEL_NAME": "Nom",
      "LABEL_NUMBER": "Numéro",
      "LABEL_REGION": "Zone"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'édition du groupement"
    },
    "MESSAGE": {
      "SUCCESS": "Le groupement a été modifié avec succès",
      "ERROR": "Impossible de modifier le groupement"
    },
    "PLACEHOLDER": {
      "REGION": "Sélectionner une zone",
      "NETWORK": "Sélectionner un réseau",
      "NAME": "Ex : Île-de-France",
      "AUTHORIZATION_EMAIL": "Ex : contact{'@'}exemple.fr"
    }
  },
  "STORE_PAGE": {
    "PLACEHOLDER": {
      "NETWORK": "Sélectionner le réseau",
      "REGION": "Sélectionner la zone",
      "GROUP": "Sélectionner un groupement",
      "STATUS": "Sélectionner le statut"
    },
    "TABLE": {
      "STORE_ID": "ID",
      "STORE_BOOMERANG_ID": "ID",
      "NETWORK": "Réseau",
      "GROUP": "Groupement",
      "STORE_NAME": "Nom",
      "CONTACT_EMAIL": "Email contact",
      "PHONE_NUMBER": "Téléphone",
      "FOLDER_STATS": "Nombre de dossier",
      "ZONE": "Zone"
    },
    "MODAL": {
      "TITLE": "Suppression d’un magasin",
      "MESSAGE": "Voulez-vous vraiment supprimer {store}?",
      "WARNING": "Cette action est irréversible."
    },
    "MESSAGE": {
      "SUCCESS": "Le magasin a été supprimer avec succès",
      "ERROR": "Impossible de supprimer le magasin",
      "UPDATE_SUCCESS": "Le magasin a été modifié avec succès"
    },
    "EXPORT_SUCCESS": "L'export des magasins a été effectué et sera envoyé par mail"
  },
  "CREATE_STORE_PAGE": {
    "TITLE": {
      "HEADER": "Nouveau magasin",
      "SUBTITLE": "Formulaire d'ajout d'un magasin",
      "GENERAL_INFO": "Informations du magasin",
      "CONTEXT": "Contexte",
      "GENERAL_SECTION": "Informations générales",
      "CONTACTS": "Coordonnées",
      "ADDRESS": "Adresse",
      "SATISFACTION_QUESTIONNAIRE_CONFIGURATION": "Questionnaire de satisfaction",
      "STORE_CONFIGURATION": "Configuration magasin",
      "WHITE_LIST_CONFIGURATION": "Liste blanche"
    },
    "FORM": {
      "LABEL_BANNER": "Bannière de l'email",
      "LABEL_BILLING_CUSTOMER_ACCOUNT_NUMBER": "N° compte client facturation",
      "LABEL_KEY_ACCOUNT_CLIENT_NUMBER": "Nº client grand compte",
      "LABEL_CLIENT_NUMBER_FORMAT": "Nb de caractère",
      "LABEL_NETWORK": "Réseau",
      "LABEL_GROUP": "Groupement",
      "LABEL_NAME": "Nom",
      "LABEL_BOOMERANG_ID": "ID",
      "LABEL_PHONE": "Téléphone",
      "LABEL_RESPONSIBLE_EMAIL": "Email responsable",
      "LABEL_CONTACT_EMAIL": "Email contact",
      "LABEL_BACKUP_EMAIL": "Email backup réception retours clients",
      "LABEL_SIRET": "Numéro de SIRET",
      "LABEL_LABEL_NAME": "Nom adresse postale pour étiquette",
      "LABEL_ADDRESS_NUMBER": "Numéro d'adresse postale",
      "LABEL_ADDRESS_STREET": "Rue",
      "LABEL_ADDRESS_COMPLEMENT_1": "Complément 1",
      "LABEL_ADDRESS_COMPLEMENT_2": "Complément 2",
      "LABEL_ADDRESS_ZIP_CODE": "Code postal",
      "LABEL_ADDRESS_CITY": "Ville",
      "LABEL_ADDRESS_COUNTRY": "Pays",
      "LABEL_REGION_CODE": "Zone",
      "LABEL_BILLING": "Facturation",
      "LABEL_MANUFACTURER": "Fabricant local",
      "LABEL_MILWAUKEE_ACCOUNT": "Identifiant Milwaukee",
      "LABEL_MILWAUKEE_PASSWORD": "Mot de passe Milwaukee",
      "LABEL_ERP_ACCOUNT_ID": "Code Magasin référent dans votre ERP",
      "LABEL_ERP_STORE_BEACON_CODE": "Code Balise magasin",
      "LABEL_LOGO": "Logo",
      "LABEL_LOGO_INPUT": "Ajouter un logo",
      "LABEL_MIN_RANGE": "Note minimale",
      "LABEL_MAX_RANGE": "Note maximale",
      "PREVIEW": "Aperçu",
      "LABEL_REDIRECT_URL": "Lien de redirection",
      "LABEL_SATISFACTION_QUESTIONNAIRE": "Gestion questionnaire satisfaction"
    },
    "PLACEHOLDER": {
      "BANNER": "Importez la bannière du questionnaire satisfaction",
      "CLIENT_NUMBER_FORMAT": "Ex: 20, 25, 32 chiffres",
      "NETWORK": "Sélectionner un réseau",
      "BILLING": "Sélectionner une facturation",
      "MANUFACTURER": "Sélectionner un fabricant local",
      "REGION_CODE": "Sélectionner une zone",
      "GROUP": "Sélectionner un groupement",
      "NAME": "Ex : VINAY GRENOBLE",
      "BOOMERANG_ID": "Ex : B123456",
      "LABEL_NAME": "Ex : VINAY GRENOBLE",
      "SIRET": "Ex : 12345678901234",
      "PHONE": "Ex : 01 23 45 67 89",
      "RESPONSIBLE_EMAIL": "Ex : contact{'@'}exemple.fr",
      "CONTACT_EMAIL": "Ex : contact{'@'}exemple.fr",
      "BACKUP_EMAIL": "Ex : contact{'@'}exemple.fr",
      "ADDRESS_NUMBER": "Ex : 12",
      "ADDRESS_STREET": "Ex : Rue de la Paix",
      "ADDRESS_COMPLEMENT_1": "Ex : 12 rue de la Paix",
      "ADDRESS_COMPLEMENT_2": "Ex : 12 rue de la Paix",
      "ADDRESS_ZIP_CODE": "Ex : 75001",
      "ADDRESS_CITY": "Ex : Paris",
      "ADDRESS_COUNTRY": "Ex : France",
      "SELECT_REPAIRER": "Sélectionner un ou plusieurs réparateurs",
      "ERP_ACCOUNT_ID": "Ex : B123456",
      "MIN_RANGE": "Ex : 1",
      "MAX_RANGE": "Ex : 10",
      "REDIRECT_URL": "Ex : https://www.exemple.fr",
      "BILLING_CUSTOMER_ACCOUNT_NUMBER": "Ex : FAC-123456",
      "KEY_ACCOUNT_CLIENT_NUMBER": "Ex : GC-123456",
      "SELECT_STORE_MANUFACTURER": "Sélectionner une ou plusieurs marques",
      "SELECT_WORKSHOP_MANUFACTURER": "Sélectionner une ou plusieurs marques",
      "SELECT_REPAIR_CENTER_ALTERNATIVE": "Sélectionner un ou plusieurs centres de réparation",
      "ERP_STORE_BEACON_CODE": "Ex : BALISE-001",
      "MILWAUKEE_ACCOUNT": "Ex : MWK-123456",
      "MILWAUKEE_PASSWORD": "Saisir votre mot de passe",
      "SELECT_SUPPORT_GUARANTEE_TRANSPORT": "Sélectionner une ou plusieurs marques"
    },
    "SWITCH": {
      "ALLOW_REPAIR_CENTER_ALTERNATIVE": "Réparateurs alternatifs",
      "CLIENT_NUMBER_STATUS": "Demande N° Compte client",
      "REPAIR_STATUS": "Réparation dans le magasin",
      "WORKSHOP_DEPOSIT": "Dépôt dans un atelier de la marque",
      "REPAIRER_TRANSPORT": "Conditions spéciales sur Transport",
      "MILWAUKEE_SUPPORT": "Gestion Boomerang Milwaukee",
      "ERP_SUPPORT": "Gestion ERP",
      "SATISFACTION_QUESTIONNAIRE": "Gestion questionnaire satisfaction",
      "SUPPORT_GUARANTEE_TRANSPORT": "Support Garantie Transport",
      "SUPPORT_WITHOUT_GUARANTEE_TRANSPORT": "Support Sans Garantie Transport",
      "CHRONOPOST_WITHOUT_COLLECT_PRECHECKED": "Chronopost sans collecte pré-coché",
      "KEY_ACCOUNT_NON_ORIGIN_PRICING_AVAILABLE": "Disponible hors magasin d'achat GC sous garantie"
    },
    "SELECTOR": {
      "SELECT_REPAIRER": "Sélectionner un/des réparateurs",
      "SELECT_REPAIR_CENTER_ALTERNATIVE": "Sélectionner un/des Centre de réparation",
      "SELECT_WORKSHOP_MANUFACTURER": "Sélectionner un/des fabricants",
      "SELECT_STORE_MANUFACTURER": "Sélectionner un/des fabricants",
      "SELECT_SUPPORT_GUARANTEE_TRANSPORT": "Sélectionner un/des fabricants",
      "SELECT_SUPPORT_WITHOUT_GUARANTEE_TRANSPORT": "Sélectionner un/des fabricants"
    },
    "BUTTON": {
      "ADD_REDIRECT_URL": "Ajouter",
      "VALIDATE": "Valider l'ajout du magasin"
    },
    "MESSAGE": {
      "SUCCESS": "Le magasin a été ajouté avec succès",
      "ERROR": "Impossible d'ajouter le magasin"
    }
  },
  "EDIT_STORE_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'un magasin",
      "GENERAL_INFO": "Informations du magasin",
      "CONTEXT": "Contexte",
      "GENERAL_SECTION": "Informations générales",
      "CONTACTS": "Coordonnées",
      "ADDRESS": "Adresse",
      "STORE_CONFIGURATION": "Configuration magasin",
      "SATISFACTION_QUESTIONNAIRE_CONFIGURATION": "Questionnaire de satisfaction",
      "SUBTITLE": "Formulaire d'édition d'un magasin",
      "WHITE_LIST_CONFIGURATION": "Liste blanche"
    },
    "FORM": {
      "LABEL_BANNER": "Bannière de l'email",
      "LABEL_BILLING_CUSTOMER_ACCOUNT_NUMBER": "N° compte client facturation",
      "LABEL_KEY_ACCOUNT_CLIENT_NUMBER": "Nº client grand compte",
      "LABEL_CLIENT_NUMBER_FORMAT": "Nb de caractère",
      "LABEL_NETWORK": "Réseau",
      "LABEL_GROUP": "Groupement",
      "LABEL_NAME": "Nom",
      "LABEL_BOOMERANG_ID": "ID",
      "LABEL_PHONE": "Téléphone",
      "LABEL_RESPONSIBLE_EMAIL": "Email responsable",
      "LABEL_CONTACT_EMAIL": "Email contact",
      "LABEL_BACKUP_EMAIL": "Email backup réception retours clients",
      "LABEL_SIRET": "Numéro de SIRET",
      "LABEL_LABEL_NAME": "Nom adresse postale pour étiquette",
      "LABEL_ADDRESS_NUMBER": "Numéro d'adresse postale",
      "LABEL_ADDRESS_STREET": "Rue",
      "LABEL_ADDRESS_COMPLEMENT_1": "Complément 1",
      "LABEL_ADDRESS_COMPLEMENT_2": "Complément 2",
      "LABEL_ADDRESS_ZIP_CODE": "Code postal",
      "LABEL_ADDRESS_CITY": "Ville",
      "LABEL_ADDRESS_COUNTRY": "Pays",
      "LABEL_REGION_CODE": "Zone",
      "LABEL_BILLING": "Facturation",
      "LABEL_MANUFACTURER": "Fabricant local",
      "LABEL_MILWAUKEE_ACCOUNT": "Identifiant Milwaukee",
      "LABEL_MILWAUKEE_PASSWORD": "Mot de passe Milwaukee",
      "LABEL_ERP_ACCOUNT_ID": "Code Magasin référent dans votre ERP",
      "LABEL_ERP_STORE_BEACON_CODE": "Code Balise magasin",
      "LABEL_LOGO": "Logo",
      "LABEL_MIN_RANGE": "Note minimale",
      "LABEL_MAX_RANGE": "Note maximale",
      "PREVIEW": "Aperçu",
      "LABEL_REDIRECT_URL": "Lien de redirection",
      "LABEL_SATISFACTION_QUESTIONNAIRE": "Gestion questionnaire satisfaction"
    },
    "PLACEHOLDER": {
      "BANNER": "Importez la bannière du questionnaire satisfaction",
      "CLIENT_NUMBER_FORMAT": "Ex: 20, 25, 32 chiffres",
      "NETWORK": "Sélectionner un réseau",
      "BILLING": "Sélectionner une facturation",
      "MANUFACTURER": "Sélectionner un fabricant local",
      "REGION_CODE": "Sélectionner une zone",
      "GROUP": "Sélectionner un groupement",
      "NAME": "Ex : VINAY GRENOBLE",
      "LABEL_NAME": "Ex : Magasin Paris Centre",
      "SIRET": "Ex : 12345678901234",
      "PHONE": "Ex : 01 23 45 67 89",
      "RESPONSIBLE_EMAIL": "Ex : contact{'@'}exemple.fr",
      "CONTACT_EMAIL": "Ex : contact{'@'}exemple.fr",
      "BACKUP_EMAIL": "Ex : contact{'@'}exemple.fr",
      "ADDRESS_NUMBER": "Ex : 12",
      "ADDRESS_STREET": "Ex : Rue de la Paix",
      "ADDRESS_COMPLEMENT_1": "Ex : 12 rue de la Paix",
      "ADDRESS_COMPLEMENT_2": "Ex : 12 rue de la Paix",
      "ADDRESS_ZIP_CODE": "Ex : 75001",
      "ADDRESS_CITY": "Ex : Paris",
      "ADDRESS_COUNTRY": "Ex : France",
      "SELECT_REPAIRER": "Sélectionner un ou plusieurs réparateurs",
      "ERP_ACCOUNT_ID": "Ex : B123456",
      "MIN_RANGE": "Ex : 1",
      "MAX_RANGE": "Ex : 10",
      "REDIRECT_URL": "Ex : https://www.exemple.fr",
      "BILLING_CUSTOMER_ACCOUNT_NUMBER": "Ex : FAC-123456",
      "KEY_ACCOUNT_CLIENT_NUMBER": "Ex : GC-123456",
      "SELECT_STORE_MANUFACTURER": "Sélectionner une ou plusieurs marques",
      "SELECT_WORKSHOP_MANUFACTURER": "Sélectionner une ou plusieurs marques",
      "SELECT_REPAIR_CENTER_ALTERNATIVE": "Sélectionner un ou plusieurs centres de réparation",
      "ERP_STORE_BEACON_CODE": "Ex : BALISE-001",
      "MILWAUKEE_ACCOUNT": "Ex : MWK-123456",
      "MILWAUKEE_PASSWORD": "Saisir votre mot de passe",
      "SELECT_SUPPORT_GUARANTEE_TRANSPORT": "Sélectionner une ou plusieurs marques"
    },
    "SWITCH": {
      "ALLOW_REPAIR_CENTER_ALTERNATIVE": "Réparateurs alternatifs",
      "CLIENT_NUMBER_STATUS": "Demande N° Compte client",
      "REPAIR_STATUS": "Réparation dans le magasin",
      "WORKSHOP_DEPOSIT": "Dépôt dans un atelier de la marque",
      "REPAIRER_TRANSPORT": "Conditions spéciales sur Transport",
      "MILWAUKEE_SUPPORT": "Gestion Boomerang Milwaukee",
      "ERP_SUPPORT": "Gestion ERP",
      "SATISFACTION_QUESTIONNAIRE": "Gestion questionnaire satisfaction",
      "SUPPORT_GUARANTEE_TRANSPORT": "Support Garantie Transport",
      "SUPPORT_WITHOUT_GUARANTEE_TRANSPORT": "Support Sans Garantie Transport",
      "CHRONOPOST_WITHOUT_COLLECT_PRECHECKED": "Chronopost sans collecte pré-coché",
      "KEY_ACCOUNT_NON_ORIGIN_PRICING_AVAILABLE": "Disponible hors magasin d'achat GC sous garantie"
    },
    "SELECTOR": {
      "SELECT_REPAIRER": "Sélectionner un/des réparateurs",
      "SELECT_REPAIR_CENTER_ALTERNATIVE": "Sélectionner un/des Centre de réparation",
      "SELECT_WORKSHOP_MANUFACTURER": "Sélectionner un/des fabricants",
      "SELECT_STORE_MANUFACTURER": "Sélectionner un/des fabricants",
      "SELECT_SUPPORT_GUARANTEE_TRANSPORT": "Sélectionner un/des fabricants",
      "SELECT_SUPPORT_WITHOUT_GUARANTEE_TRANSPORT": "Sélectionner un/des fabricants"
    },
    "BUTTON": {
      "ADD_REDIRECT_URL": "Ajouter",
      "VALIDATE": "Valider l'édition du magasin",
      "UPDATE_MILWAUKEE": "Modifier le compte"
    },
    "MESSAGE": {
      "SUCCESS": "Le magasin a été modifié avec succès",
      "ERROR": "Impossible de modifier le magasin"
    }
  },
  "DETAIL_STORE_PAGE": {
    "TITLE": {
      "HEADER": "Détail d'un magasin",
      "SUB_HEADER": "Magasin"
    },
    "SUBTITLE": {
      "HEADER_DETAIL": "Magasin - {storeName}",
      "HEADER_TRANSPORT": "Liste des transporteurs expressistes rattachés à {storeName}",
      "HEADER_REPAIR_CENTER": "Liste des centres de réparation rattachés à {storeName}",
      "HEADER_LOCAL_BRAND": "Liste des marques locales rattachées à {storeName}",
      "HEADER_ACCOUNT": "Liste des utilisateurs rattachés à {storeName}"
    },
    "MANAGEMENT": {
      "TRANSPORT_TAB_TITLE": "Transporteurs Expressistes",
      "REPAIR_CENTER_TAB_TITLE": "Centre de réparation",
      "LOCAL_BRAND_TAB_TITLE": "Marques locales"
    },
    "CARD_ACCOUNT": {
      "TITLE": "Utilisateurs associés au magasin",
      "TABLE": {
        "ACCOUNT_ID": "ID",
        "ACCOUNT_LOGIN": "Login",
        "ACCOUNT_ROLE": "Rôle"
      }
    },
    "TABLE": {
      "REPAIR_CENTER": {
        "BOOMERANG_ID": "ID",
        "NAME": "Nom",
        "CITY": "Ville",
        "EMAIL_CONTACT": "Email contact",
        "LOADING_STORES_LINKED": "Chargement des magasins liés..."
      }
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "CONTACT_INFO": "Contacts",
      "NETWORK": "Réseau",
      "GROUP": "Groupement",
      "BOOMERANG_ID": "ID",
      "STATUS": "Statut",
      "STATUS_ACTIVE": "Actif",
      "STATUS_INACTIVE": "Inactif",
      "ADDRESS": "Adresse",
      "CONTACT_EMAIL": "Email contact",
      "PHONE_NUMBER": "Téléphone",
      "MANAGER": "Manager magasin",
      "SIRET": "Siret",
      "BACKUP_EMAIL": "Backup email",
      "ZONE": "Zone"
    },
    "BUTTON": {
      "UPDATE_LOGO": "Modifier le logo"
    }
  },
  "DETAIL_DISTRIBUTOR_GROUP_PAGE": {
    "TITLE": {
      "HEADER": "Détail d'un groupement distributeur",
      "SUB_HEADER": "Groupement"
    },
    "SUBTITLE": {
      "HEADER_DETAIL": "Groupement distributeur - {groupName} - {networkName}",
      "HEADER_STORE": "Liste des magasins rattachés à {groupName} - {networkName}",
      "HEADER_REGION_CODE": "Liste des zones géographiques rattachées à {groupName} - {networkName}"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "ID": "ID",
      "NUMBER": "Numéro",
      "NAME": "Nom",
      "NETWORK": "Réseau",
      "AUTHORIZATION_EMAIL": "Email autorisation"
    },
    "CARD_TITLE": {
      "STORE": "Magasins",
      "REGION_CODE": "Zones Géographiques"
    },
    "TABLE": {
      "STORE_ID": "ID",
      "STORE_NETWORK": "Réseau",
      "STORE_NAME": "Nom",
      "STORE_EMAIL": "Email autorisation",
      "REGION_CODE_ID": "ID",
      "REGION_CODE_NAME": "Nom officiel",
      "REGION_CODE_CODE": "Code",
      "REGION_CODE_CODE_ZONE": "Code zone officiel"
    },
    "BUTTON": {
      "ADD_STORE": "Ajouter un magasin",
      "ADD_REGION_CODE": "Ajouter une zone"
    }
  },
  "DETAIL_KEY_ACCOUNT_GROUP_PAGE": {
    "TITLE": {
      "HEADER": "Détail d'un groupement grand compte",
      "SUB_HEADER": "Groupement"
    },
    "SUBTITLE": {
      "HEADER_DETAIL": "Groupement grand compte - {groupName} - {networkName}",
      "HEADER_OPERATING_CENTER": "Liste des centres d'exploitation rattachés à {groupName} - {networkName}",
      "HEADER_REGION_CODE": "Liste des zones géographiques rattachées à {groupName} - {networkName}"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "ID": "ID",
      "NUMBER": "Numéro",
      "NAME": "Nom",
      "NETWORK": "Réseau",
      "AUTHORIZATION_EMAIL": "Email autorisation"
    },
    "CARD_TITLE": {
      "OPERATING_CENTER": "Centres d'exploitation",
      "REGION_CODE": "Zones Géographiques"
    },
    "TABLE": {
      "OPERATING_CENTER_ID": "ID",
      "OPERATING_CENTER_NETWORK": "Réseau",
      "OPERATING_CENTER_GROUP": "Groupement",
      "OPERATING_CENTER_NAME": "Nom",
      "OPERATING_CENTER_EMAIL": "Email autorisation",
      "OPERATING_CENTER_PHONE": "Téléphone",
      "REGION_CODE_ID": "ID",
      "REGION_CODE_NAME": "Nom officiel",
      "REGION_CODE_CODE": "Code",
      "REGION_CODE_CODE_ZONE": "Code zone officiel"
    },
    "BUTTON": {
      "ADD_OPERATING_CENTER": "Ajouter un centre d'exploitation",
      "ADD_REGION_CODE": "Ajouter une zone"
    }
  },
  "DETAIL_DISTRIBUTOR_NETWORK_PAGE": {
    "TITLE": {
      "HEADER": "Détail d'un réseau distributeur"
    },
    "SUBTITLE": {
      "HEADER_DETAIL": "Réseau distributeur - {networkName}",
      "HEADER_GROUP": "Liste des groupements rattachés à {networkName}",
      "HEADER_STORE": "Liste des magasins rattachés à {networkName}",
      "HEADER_MANUFACTURER": "Liste des fabricants rattachés à {networkName}"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "BOOMERANG_ID": "ID",
      "NAME": "Nom",
      "PRIMARY_COLOR": "Couleur primaire",
      "SECONDARY_COLOR": "Couleur secondaire",
      "CUSTOM_THEME_ENABLED": "Thème personnalisé",
      "STORE": "Magasin",
      "FOLDER": "Dossier",
      "USER": "Utilisateur",
      "ZONE_LINK": "Zones liées",
      "COLLABORATOR": "Collaborateur",
      "STATISTIC": "Statistiques",
      "NAMEPLATE_LOGIN_ID": "Identifiant PS"
    },
    "CARD_TITLE": {
      "GROUP": "Groupements",
      "STORE": "Magasins"
    },
    "TABLE": {
      "STORE_ID": "ID",
      "STORE_NETWORK": "Réseau",
      "STORE_NAME": "Nom",
      "STORE_EMAIL": "Email autorisation",
      "NO_STORE": "Aucun magasin",
      "REGION_CODE_ID": "ID",
      "REGION_CODE_NAME": "Nom officiel",
      "REGION_CODE_CODE": "Code",
      "REGION_CODE_CODE_ZONE": "Code zone officiel",
      "NO_REGION_CODE": "Aucune zone géographique"
    },
    "BUTTON": {
      "ADD_STORE": "Ajouter un magasin",
      "ADD_REGION_CODE": "Ajouter une zone"
    }
  },
  "FINALIZATION_PAGE": {
    "TITLE": "Finalisation du dossier nº{number}",
    "SUBTITLE": "Suivez les 3 étapes obligatoires ci-dessous pour déclencher le suivi de votre réparation. Aucune ne peut être omise.",
    "SUBTITLE_WITHOUT_TRACKING": "Suivez les 3 étapes ci-dessous pour déclencher le suivi de votre réparation.",
    "REPAIRER_NUMBER": "Numéro de réparateur",
    "REPAIRER_NUMBER_PLACEHOLDER": "Saisir le numéro",
    "DOWNLOAD": "Télécharger",
    "REDOWNLOAD": "Re-télécharger",
    "TRACKING_NUMBER": "Numéro de suivi",
    "TRACKING_NUMBER_PLACEHOLDER": "XR123456789FR",
    "FINISH_LATER": "Terminer plus tard",
    "ACTIVATE_TRACKING": "Déclencher le suivi du dossier",
    "SECTIONS": {
      "TRANSPORT_DETAILS": "Renseigner les informations de transport",
      "DOCUMENTS": "Imprimer les documents pour le réparateur",
      "DOCUMENTS_SUBTITLE": "Ces documents doivent impérativement être glissés dans le colis. Sans eux, votre produit ne pourra pas être pris en charge ni réparé par le technicien.",
      "ACTIVATE_TRACKING": "Activer le suivi du dossier",
      "ACTIVATE_TRACKING_SUBTITLE": "En confirmant, vous déclarez avoir renseigné le numéro de suivi et placé l'ensemble des documents dans le colis. Le suivi de votre réparation sera alors activé.",
      "ACTIVATE_WITHOUT_TRACKING_SUBTITLE": "En confirmant, vous déclarez avoir placé l'ensemble des documents dans le colis. Le suivi de votre réparation sera alors activé."
    },
    "DOCUMENTS_INCLUDED": {
      "REPAIR_ORDER": "Ordre de réparation",
      "GUARANTEE_EXTENSION_PROOF": "Justificatif d'extension de garantie",
      "PURCHASE_PROOF": "Justificatif d'achat",
      "ASBESTOS_PROOF": "Justificatif amiante",
      "FORCE_SUPPORT_PROOF": "Justificatif de prise en charge forcée",
      "BATTERY_LABEL": "Étiquette batterie",
      "TRANSPORT_LABEL": "Étiquette de transport",
      "TRANSPORTER_REPAIRER_DOCUMENT": "Document transporteur pour le réparateur"
    },
    "DOCUMENT_PLACEMENTS": {
      "STICK_ON_PARCEL": "À coller sur le colis",
      "PUT_IN_PARCEL": "À mettre dans le colis"
    },
    "MESSAGE": {
      "LOAD_ERROR": "Le dossier ou la liste des documents n'a pas pu être chargé.",
      "SUCCESS": "Dossier finalisé"
    }
  },
  "RENTAL_FILE_WELCOME": {
    "TITLE": "Bienvenue sur Boomerang location",
    "SUBTITLE": "Découvrez notre sélection de produits électroportatifs à louer, idéale pour ne pas rester sans matériel pendant la réparation de son équipement.",
    "EMPTY": "Aucun produit ne correspond à votre recherche et aux disponibilités sélectionnées.",
    "LOAD_ERROR": "Impossible de charger les produits de location. Veuillez réessayer.",
    "FIND_PRODUCT": "Trouver votre produit",
    "SELECT_ALL": "Tout voir",
    "AVAILABILITY_STATUS_GROUP": "Disponibilité",
    "AVAILABILITY_STATUS": {
      "AVAILABLE": "Disponible",
      "IN_COMING": "À venir",
      "UNAVAILABLE": "Indisponible"
    }
  },
  "RENTAL_PRODUCT_DETAIL": {
    "TITLE": "Détail du produit de location",
    "SERIAL_NUMBER": "Numéro de série : {number}",
    "RENTAL_PRICE": "Prix de location HT",
    "PRODUCT_SHEET": "Fiche produit",
    "SPECIFICATIONS": "Caractéristiques",
    "CONSUMABLE_REFERENCE": "Réf. {reference}",
    "CONTRACT_DETAILS_HINT": "Les détails du contrat vous seront demandés à la création du dossier.",
    "FIELDS": {
      "BRAND": "Marque",
      "CATEGORY": "Gamme",
      "MODEL": "Modèle",
      "REFERENCE": "Référence",
      "SUB_CATEGORY": "Sous-catégorie",
      "WEIGHT": "Poids",
      "LENGTH": "Longueur",
      "WIDTH": "Largeur"
    },
    "NO_PICTURE": "Photo du produit indisponible",
    "CONSUMABLE_PICTURE": "Photo du consommable"
  },
  "RENTAL_FILE_CREATE": {
    "LOAD_ERROR": "Impossible de charger le formulaire de location. Veuillez réessayer.",
    "DATE_ERROR": "Sélectionnez une date de livraison valide, aujourd'hui ou ultérieure.",
    "SAME_BILLING_ADDRESS": "Adresse de facturation identique à l'adresse de livraison",
    "SECTIONS": {
      "DELIVERY_ADDRESS": "Adresse de livraison",
      "BILLING_ADDRESS": "Adresse de facturation",
      "DELIVERY_DEPOSIT": "Livraison et caution",
      "ADDITIONAL_INFORMATION": "Informations complémentaires"
    }
  },
  "COMMON": {
    "PRELIMINARY_REQUEST": "Demande préalable",
    "SUB_CATEGORY_PROSPECT": {
      "PICTURE_MANDATORY": "Photo obligatoire pour la demande préalable",
      "DESCRIPTION": "Instructions pour la demande préalable",
      "PICTURE": "Image d'illustration de la demande préalable",
      "PREVIEW": "Aperçu",
      "REMOVE_PICTURE": "Supprimer l'image"
    },
    "GUARANTEE": {
      "TITLE": "Garantie",
      "ALL": "Tous",
      "UNDER_GUARANTEE": "En garantie",
      "NOT_GUARANTEE": "Hors garantie",
      "UNDEFINED": "Non renseignée"
    },
    "EAN": "EAN / Code-barres de vente",
    "EAN_DIGITS_ONLY": "Le code EAN doit contenir uniquement des chiffres.",
    "ORDER_NUMBER": "N° de commande",
    "COST": "Coût",
    "COST_EXCLUSIVE_TAX": "Coût (HT)",
    "PUBLIC_PAGE": {
      "LOADING": "Chargement…",
      "INVALID_TITLE": "Ce lien n’est plus valide",
      "INVALID_MESSAGE": "Ce lien est invalide, expiré ou déjà utilisé. Veuillez demander un nouveau lien.",
      "FAILED_TITLE": "Impossible de charger cette page",
      "FAILED_MESSAGE": "Vérifiez votre connexion et réessayez.",
      "RETRY": "Réessayer"
    },
    "PUBLIC_UPLOAD": {
      "CAPACITY": "{count} / {max} photos envoyées. Vous pouvez en ajouter {remaining}.",
      "PARTIAL": "Certaines photos n’ont pas pu être envoyées. Réessayez avec les photos restantes.",
      "FAILED_FILES": "Photos à renvoyer : {names}",
      "MAX_SIZE": "Taille maximale par fichier : {size} {unit}",
      "MEGABYTE": "Mo",
      "TOO_LARGE": "Un fichier sélectionné dépasse la taille maximale.",
      "OVER_CAPACITY": "Trop de photos sélectionnées. Retirez des photos pour respecter la capacité restante.",
      "DROPZONE": "Glissez un document ici ou sélectionnez un fichier",
      "RELAUNCH_FORMATS": "Formats acceptés : PDF, JPG, PNG",
      "REMOVE": "Retirer le fichier"
    },
    "ADDRESS_FIELDS": {
      "NAME": "Nom de l'adresse",
      "NUMBER": "Numéro",
      "STREET": "Rue",
      "ZIP_CODE": "Code postal",
      "CITY": "Ville",
      "COUNTRY": "Pays"
    },
    "REQUIRED": "Obligatoire",
    "LOADING": "Chargement...",
    "KILOGRAM": "kg",
    "OR": "ou",
    "FROM": "De",
    "BY": "par",
    "AT": "le",
    "NOT_AUTHORIZED_MESSAGE": "Vous n'êtes pas autorisé à voir cette page, merci de contacter un administrateur",
    "NOT_AUTHORIZED_ACTION_MESSAGE": "Vous n'êtes pas autorisé à effectuer cette action, merci de contacter un administrateur",
    "IN_PROGRESS_MESSAGE": "Page en construction",
    "FILTER": {
      "SEARCH": "Rechercher",
      "EXPORT": "Exporter",
      "NOT_AUTHORIZED_ACTION_MESSAGE": "Vous n'êtes pas autorisé à effectuer cette action",
      "SHOW_FILTERS": "Afficher les filtres",
      "TO_DELETION": "Supprimer des dossiers par magasin"
    },
    "WORKFLOW": {
      "POWER_TOOLS": "Électroportatif",
      "GENERIC": "Générique"
    },
    "PREVIEW_TOOLBAR": {
      "ZOOM_IN": "Zoomer",
      "ZOOM_OUT": "Dézoomer",
      "ROTATE": "Pivoter",
      "RESET": "Réinitialiser",
      "REFRESH": "Recharger",
      "PREVIOUS_PAGE": "Page précédente",
      "NEXT_PAGE": "Page suivante",
      "PAGE_COUNT": "{count} page(s)"
    },
    "KPI": {
      "STATUS": "Statut",
      "OPEN_SINCE": "Ouvert depuis"
    },
    "STATUS_MACRO": {
      "DRAFT": "BROUILLON",
      "IN_CREATION": "EN CRÉATION",
      "IN_CREATION_ESTIMATE": "EN CRÉATION - DEVIS",
      "IN_CREATION_PROSPECT": "EN CRÉATION - DEMANDE",
      "TRANSPORT_GO": "TRANSPORT ALLER",
      "RECEPTION_AT_REPAIRER": "RÉCEP. RÉPARATEUR",
      "DIAGNOSTIC_MANUFACTURER_RECEIVED": "DIAGNOSTIC RÉP. REÇU",
      "DIAGNOSTIC_MANUFACTURER_PROCESSED": "DIAGNOSTIC RÉP. TRAITÉ",
      "ESTIMATE_SENT_TO_CUSTOMER": "DECISION CLIENT - DEVIS",
      "ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER": "DEVIS RÉP. VALIDE",
      "IN_REPARATION": "RÉPARATION",
      "SENT_BACK_BY_REPAIRER": "TRANSPORT RETOUR",
      "RECEIPT_AT_STORE": "RÉCEP. MAGASIN",
      "SENT_AVAILABLE_TO_CUSTOMER": "ATTENTE COLLECTE",
      "TAKEOVER_BY_CUSTOMER": "CLÔTURÉ",
      "NETWORK_BILLING": "FACTURATION",
      "FINISHED": "TERMINÉ",
      "ABORT_BY_CUSTOMER": "ABANDON PAR CLIENT",
      "DELETED": "SUPPRIMÉ"
    },
    "STATUS_DETAIL": {
      "GUARANTEE_EVALUATED": "Création de dossier",
      "PRICING_SENT_TO_CUSTOMER": "Devis forfait",
      "PRICING_EVALUATED": "Création de dossier",
      "INFORMATION_RETRIEVED": "N° de commande",
      "INTERNAL_COMMAND_NUMBER_LINKED": "Sélection du transport",
      "TRANSPORTER_REPAIR_FILE_TRANSFER": "Finalisation du dossier",
      "FINALIZE_REPAIR_FILE": "Finalisation du dossier",
      "REPAIR_FILE_CREATED": "Transfert du produit",
      "COLLECTION_TO_REPAIRER": "Enlèvement Aller",
      "RECEPTION_AT_REPAIRER": "Réception chez réparateur",
      "DIAGNOSTIC_MANUFACTURER_RECEIVED": "Devis envoyé par le fabricant",
      "ESTIMATE_CREATED": "Réception devis réparateur",
      "ESTIMATE_SENT_TO_CUSTOMER": "Devis envoyé au client",
      "ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER": "Décision client envoyée au réparateur",
      "IN_REPARATION": "En réparation",
      "SENT_BACK_BY_REPAIRER": "Expédition par réparateur",
      "RECEIPT_AT_STORE": "Réception en magasin",
      "SENT_AVAILABLE_TO_CUSTOMER": "Client informé dispo",
      "TAKEOVER_BY_CUSTOMER": "Remise au client - Clôturé",
      "NETWORK_BILLING": "Facturation",
      "FINISHED": "Terminé",
      "ABORT_BY_CUSTOMER": "Abandonné",
      "DELETED": "Supprimé"
    },
    "BUTTON": {
      "YES": "Oui",
      "NO": "Non",
      "BACK": "Retour",
      "CLOSE": "Fermer",
      "REMOVE": "Supprimer",
      "DETAIL": "Détails",
      "UPDATE": "Mettre à jour",
      "CREATE": "Créer",
      "DELETE": "Supprimer",
      "LOAD_MORE": "Charger plus",
      "RETRY": "Réessayer",
      "CANCEL": "Annuler",
      "VALIDATE": "Valider",
      "SEND": "Envoyer",
      "CONTINUE": "Continuer",
      "SAVE": "Sauvegarder",
      "EXPORT_CHRONOPOST": "Export enlèvement Chronopost",
      "EXPORT_TNT": "Export enlèvement TNT",
      "EXPORT_GENERAL": "Export Général",
      "EXPORT_INDUSTRIAL": "Export Industriels",
      "EXPORT_RELAUNCH": "Export des Relances",
      "UPLOAD": "Importer les données",
      "TRUE": "Oui",
      "FALSE": "Non"
    },
    "FILE_UPLOAD": {
      "INVALID_FORMAT": "Ce format de fichier n'est pas accepté."
    },
    "MULTI_SELECT": {
      "SELECT_ALL": "Tout sélectionner",
      "UNSELECT_ALL": "Tout désélectionner"
    },
    "INPUTS": {
      "OTHER_SELECTED": "+{count} autre",
      "OTHERS_SELECTED": "+{count} autres"
    },
    "PRODUCT_TYPE": {
      "ALL": "Tout",
      "MACHINE": "Machine",
      "BATTERY": "Batterie",
      "CHARGER": "Chargeur",
      "PRODUCT": "Produit",
      "ACCESSORY_ONE": "Accessoire 1",
      "ACCESSORY_TWO": "Accessoire 2",
      "BRIEFCASE": "Mallette",
      "PREMIUM_CONSUMABLE": "Consommable Premium",
      "PPE": "Équipement de protection individuelle",
      "EQUIPMENT": "Équipement",
      "PALLET": "Palette"
    },
    "MODAL": {
      "VALIDATE": "Valider",
      "DELETE": "Supprimer",
      "CANCEL": "Annuler"
    },
    "IMPORT_EXPORT": {
      "PAGE_TITLE": "Imports & Exports",
      "SELECT": {
        "TITLE": "Type d'import",
        "TEXT": "Choisissez l'import que vous voulez gérer"
      },
      "MODEL": {
        "LABEL": "Modèle",
        "TEXT": "Afin d'importer les données vous devez respecter le modèle disponible sur la plateforme",
        "DOWNLOAD": "Télécharger un modèle",
        "EXPORT_DATA": "Exporter les données"
      },
      "IMPORT": {
        "LABEL": "Importer",
        "TEXT": "Choisir un fichier à importer",
        "UPLOAD": "Importer les données",
        "REPLACE_WARNING": "Attention ! En effectuant cet import, vous allez écraser les données existantes de la base de données."
      },
      "PLACEHOLDER": {
        "IMPORT_TYPE": "Sélectionner un type d'import"
      },
      "OTHER_TAB": {
        "IMPORT_CARD": {
          "TITLE": "Importer des données",
          "SUBTITLE": "Sélectionnez un type puis glissez votre fichier"
        },
        "MODELS_EXPORT": {
          "TITLE": "Modèles & Export",
          "SUBTITLE": "{count} types disponibles"
        },
        "HEADERS": {
          "TYPE": "Type",
          "ACTIONS": "Actions"
        },
        "DROPZONE": {
          "DRAG_HERE": "Glissez votre fichier ici",
          "OR": "ou",
          "BROWSE": "parcourez vos fichiers",
          "ACCEPTED_FORMATS": "Formats acceptés : .xlsx"
        },
        "CATEGORIES": {
          "PRODUCT": "Produit",
          "TRANSPORTER": "Transporteur",
          "OTHER_REFERENTIALS": "Autres référentiels",
          "RECYCLING": "Recyclage",
          "RENTAL": "Location"
        },
        "RECYCLING_FOLDER_REPORT": "Rapport des dossiers de recyclage"
      }
    },
    "MASS_IMPORT": {
      "PRODUCT": "Produit",
      "MODEL_SERIAL_NUMBER": "Modèle numéro de série",
      "EXTENSION_GUARANTEE": "Extension de garantie",
      "GUARANTEE": "Garantie",
      "PACKAGE": "Forfait",
      "PRODUCT_BREAKDOWN": "Pannes produit",
      "PRODUCT_DISTRIBUTOR_REF": "Références distributeur",
      "PRODUCT_STORE_PRICE": "Prix de vente distributeur réels",
      "KEY_ACCOUNT_PRODUCT": "Parc produit grand compte"
    },
    "OTHER_IMPORT": {
      "ADDITIONAL_REPAIR_COST": "Surcoût de réparation",
      "TRANSPORT_PACKAGE": "Forfait de transport",
      "TRANSPORTER": "Transporteur",
      "ESTIMATE_TRANSPORT_COST": "Coût transporteur devis"
    },
    "UPDATE_STATUS": "Mises à jour de statut",
    "GENERIC_EXPORT_SUCCESS": "L'export a été effectué et sera envoyé par mail",
    "EXPORT_SUCCESS": "L'export des {type} a été effectué et sera envoyé par mail",
    "IMPORT_SUCCESS": "L'import des {type} a été traité et le résultat sera envoyé par mail",
    "RECYCLING_IMPORT": {
      "BAC": "BAC de recyclage",
      "BUYBACK": "Prix de rachat",
      "CLIENT_LINK": "Liaisons Client"
    },
    "RENTAL_IMPORT": "Données de location",
    "TABLE": {
      "OTHER": "autre",
      "OTHERS": "autres",
      "ADDITIONAL_COUNT": "+{count}",
      "NO_PRODUCT": "Aucun produit"
    },
    "FORM": {},
    "MESSAGE": {
      "ADD_ATTACHMENT_SUCCESS": "La pièce jointe a été ajoutée avec succès.",
      "UPDATE_SUCCESS": "Mise à jour faite avec succès"
    },
    "PRICING_TYPE": {
      "PACKAGE": "Forfait",
      "ESTIMATE": "Devis"
    },
    "PRODUCT_END_STATUS": {
      "PRODUCT_REPAIRED": "Réparation de la machine",
      "PRODUCT_REPLACED_STANDARD": "Remplacement produit standard",
      "PRODUCT_REPLACED_SUPERIOR": "Remplacement produit supérieur",
      "PRODUCT_CREDIT": "Gestion par avoir",
      "PRODUCT_RECYCLED": "Non-réparation : recyclage",
      "PRODUCT_RETURN_DISASSEMBLED": "Non-réparation : retour de la machine démontée",
      "DEFAULT": "Dossier sans remise client",
      "PROSPECT_REPAIR_WITH_GUARANTEE": "Demande préalable : Réparation de la machine sous garantie",
      "PROSPECT_REPAIR_WITHOUT_GUARANTEE": "Demande préalable : Réparation de la machine hors garantie",
      "PROSPECT_CREDIT_OR_REFUND": "Demande préalable : Avoir",
      "PROSPECT_REPLACEMENT": "Demande préalable : Échange",
      "PROSPECT_REJECT": "Demande préalable : Pas de prise en charge",
      "PROSPECT_OTHER": "Demande préalable : Autre"
    },
    "DATE_PLACEHOLDER": "JJ/MM/AAAA",
    "EURO": "€",
    "PERCENT": "%",
    "DAYS": " jours",
    "DAY": " jour",
    "EXCLUSIVE_TAX": " (HT)",
    "NO_DATA": "Aucun résultat",
    "NO_VALUE": "-",
    "YES": "Oui",
    "NO": "Non",
    "PLACEHOLDER": {
      "FILE_NAME": "Ex : nom du fichier",
      "PHONE_NUMBER": "Ex : 01 23 45 67 89",
      "EMAIL_ADDRESS": "Ex : contact{'@'}exemple.fr",
      "PRICE": "Ex : 49,90",
      "MARGIN": "Ex : 30",
      "TRACKING_NUMBER": "Ex : XZ123456789FR",
      "TRANSPORTER": "Sélectionner un transporteur"
    }
  },
  "MANUFACTURERS_PAGE": {
    "TITLE": {
      "HEADER_MANUFACTURERS": "Fabricants",
      "HEADER_CATEGORIES": "Gammes",
      "HEADER_PRODUCTS": "Produits",
      "HEADER_GUARANTEES": "Garanties",
      "HEADER_MASS_IMPORT": "Import de Masse",
      "HEADER_IMPORT_EXPORT": "Import / Export"
    },
    "SUBTITLE": {
      "HEADER_MANUFACTURERS": "Liste des fabricants",
      "HEADER_CATEGORIES": "Liste des gammes",
      "HEADER_PRODUCTS": "Liste des produits",
      "HEADER_WHITELIST": "Gestion de la liste blanche"
    },
    "BUTTON": {
      "NEW_MANUFACTURER": "Nouveau fabricant",
      "NEW_CATEGORY": "Nouvelle gamme",
      "NEW_PRODUCT": "Nouveau produit",
      "NEW_GUARANTEE": "Nouvelle garantie",
      "MANUFACTURERS": "Fabricants",
      "CATEGORIES": "Gammes",
      "PRODUCTS": "Produits",
      "GUARANTEES": "Garanties",
      "MASS_IMPORT": "Import de Masse",
      "IMPORT_EXPORT": "Import / Export",
      "WHITELIST": "Liste blanche"
    }
  },
  "MANUFACTURER_PAGE": {
    "TABLE": {
      "ID": "ID",
      "NAME": "Nom",
      "CATEGORY_COUNT": "Nombre de gamme",
      "PRODUCT_COUNT": "Nombre de produit"
    },
    "MODAL": {
      "TITLE": "Supprimer un fabricant",
      "MESSAGE": "Voulez-vous vraiment supprimer le fabricant {manufacturer}?",
      "WARNING": "Cette action est irréversible."
    },
    "MESSAGE": {
      "SUCCESS_INACTIVE": "Le fabricant a été désactivé avec succès"
    }
  },
  "CREATE_MANUFACTURER_PAGE": {
    "TITLE": {
      "HEADER": "Ajouter un fabricant",
      "SUBTITLE": "Formulaire d'ajout d'un fabricant"
    },
    "FORM": {
      "MANUFACTURER_INFO": "Informations du fabricant",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom",
      "BOOMERANG_FULL_SUPPORT": "Support complet de boomerang",
      "MANDATORY_BREAKDOWN": "Panne obligatoire"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'ajout d'un fabricant"
    },
    "MESSAGE": {
      "SUCCESS": "Le fabricant a été ajouté avec succès",
      "ERROR": "Impossible d'ajouter le fabricant"
    },
    "PLACEHOLDER": {
      "ID": "Ex : B123456",
      "NAME": "Ex : Bosch"
    }
  },
  "EDIT_MANUFACTURER_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'un fabricant",
      "SUBTITLE": "Formulaire d'édition d'un fabricant"
    },
    "FORM": {
      "MANUFACTURER_INFO": "Informations du fabricant",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom",
      "BOOMERANG_FULL_SUPPORT": "Support complet de boomerang",
      "MANDATORY_BREAKDOWN": "Panne obligatoire"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'édition du fabricant"
    },
    "MESSAGE": {
      "SUCCESS": "Le fabricant a été modifié avec succès",
      "ERROR": "Impossible de modifier le fabricant"
    },
    "PLACEHOLDER": {
      "NAME": "Ex : Bosch"
    }
  },
  "DETAIL_MANUFACTURER_PAGE": {
    "TITLE": {
      "HEADER": "Détail d'un fabricant",
      "SUB_HEADER": "Fabricant"
    },
    "SUBTITLE": {
      "HEADER_DETAIL": "Fabricant - {manufacturerName}",
      "HEADER_CATEGORY": "Liste des gammes associées au fabricant {manufacturerName}"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "ID": "ID",
      "NAME": "Nom",
      "BOOMERANG_FULL_SUPPORT": "Support complet de boomerang"
    },
    "VALUE": {
      "YES": "Oui",
      "NO": "Non"
    },
    "CARD_TITLE": {
      "CATEGORIES": "Gammes"
    },
    "TABLE": {
      "CATEGORY_ID": "ID",
      "CATEGORY_NAME": "Nom",
      "SUB_CATEGORY_COUNT": "Nombre de sous-gamme",
      "CATEGORY_PRODUCT_COUNT": "Nombre de produit"
    },
    "BUTTON": {
      "ADD_CATEGORY": "Ajouter une gamme"
    }
  },
  "CATEGORY_PAGE": {
    "PLACEHOLDER": {
      "MANUFACTURER": "Sélectionner un fabricant"
    },
    "TABLE": {
      "ID": "ID",
      "MANUFACTURER_NAME": "Fabricant",
      "CATEGORY_NAME": "Nom",
      "SUB_CATEGORY_COUNT": "Nombre de sous-gamme",
      "CATEGORY_PRODUCT_COUNT": "Nombre de produit"
    },
    "MODAL": {
      "TITLE": "Supprimer une gamme",
      "MESSAGE": "Voulez-vous vraiment supprimer la gamme {category}?",
      "WARNING": "Cette action est irréversible."
    },
    "MESSAGE": {
      "SUCCESS_INACTIVE": "La gamme a été supprimée avec succès"
    },
    "EXPORT_SUCCESS": "L'export des gammes a été effectué et sera envoyé par mail"
  },
  "CREATE_CATEGORY_PAGE": {
    "TITLE": {
      "HEADER": "Ajouter une gamme",
      "SUBTITLE": "Formulaire d'ajout d'une gamme"
    },
    "FORM": {
      "CATEGORY_INFO": "Informations de la gamme",
      "LABEL_MANUFACTURER": "Fabricant",
      "LABEL_NAME": "Nom",
      "LABEL_ID": "ID"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'ajout d'une gamme"
    },
    "MESSAGE": {
      "SUCCESS": "La gamme a été ajouté avec succès",
      "ERROR": "Impossible d'ajouter la gamme"
    },
    "PLACEHOLDER": {
      "MANUFACTURER": "Sélectionner un fabricant",
      "ID": "Ex : B123456",
      "NAME": "Ex : Outillage électroportatif"
    }
  },
  "EDIT_CATEGORY_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'une gamme",
      "SUBTITLE": "Formulaire d'édition d'une gamme"
    },
    "FORM": {
      "CATEGORY_INFO": "Informations de la gamme",
      "LABEL_MANUFACTURER": "Fabricant",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'édition d'une gamme"
    },
    "MESSAGE": {
      "SUCCESS": "La gamme a été modifiée avec succès",
      "ERROR": "Impossible de modifier la gamme"
    },
    "PLACEHOLDER": {
      "MANUFACTURER": "Sélectionner un fabricant",
      "NAME": "Ex : Outillage électroportatif"
    }
  },
  "DETAIL_CATEGORY_PAGE": {
    "TITLE": {
      "HEADER": "Détail d'une gamme",
      "SUB_HEADER": "Gamme"
    },
    "SUBTITLE": {
      "HEADER_DETAIL": "Gamme {categoryName} du fabricant {manufacturerName}",
      "HEADER_SUB_CATEGORY": "Liste des sous-gammes associées à la gamme {categoryName}"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "ID": "ID",
      "NAME": "Nom",
      "MANUFACTURER": "Fabricant"
    },
    "CARD_TITLE": {
      "SUB_CATEGORIES": "Sous-gammes"
    },
    "TABLE": {
      "ID": "ID",
      "SUB_CATEGORY_NAME": "Nom",
      "SUB_CATEGORY_PRODUCT_COUNT": "Nombre de produit"
    },
    "BUTTON": {
      "ADD_SUB_CATEGORY": "Ajouter une sous-gamme"
    },
    "MODAL": {
      "TITLE": "Supprimer une sous-gamme",
      "MESSAGE": "Voulez-vous vraiment supprimer la sous-gamme {sub_category}?",
      "WARNING": "Cette action est irréversible."
    },
    "MESSAGE": {
      "SUCCESS_INACTIVE": "La sous-gamme a été supprimée avec succès"
    }
  },
  "CREATE_SUB_CATEGORY_PAGE": {
    "TITLE": {
      "HEADER": "Ajouter une sous-gamme",
      "SUBTITLE": "Formulaire d'ajout d'une sous-gamme"
    },
    "FORM": {
      "SUB_CATEGORY_INFO": "Informations de la sous-gamme",
      "LABEL_MANUFACTURER": "Fabricant",
      "LABEL_CATEGORY": "Gamme",
      "LABEL_NAME": "Nom",
      "LABEL_ID": "ID"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'ajout d'une sous-gamme"
    },
    "MESSAGE": {
      "SUCCESS": "La sous-gamme a été ajoutée avec succès",
      "ERROR": "Impossible d'ajouter la sous-gamme"
    },
    "PLACEHOLDER": {
      "ID": "Ex : B123456",
      "NAME": "Ex : Outillage électroportatif"
    }
  },
  "EDIT_SUB_CATEGORY_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'une sous-gamme",
      "SUBTITLE": "Formulaire d'édition d'une sous-gamme"
    },
    "FORM": {
      "SUB_CATEGORY_INFO": "Informations de la sous-gamme",
      "LABEL_MANUFACTURER": "Fabricant",
      "LABEL_CATEGORY": "Gamme",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'édition d'une sous-gamme"
    },
    "MESSAGE": {
      "SUCCESS": "La sous-gamme a été modifiée avec succès",
      "ERROR": "Impossible de modifier la sous-gamme"
    },
    "PLACEHOLDER": {
      "NAME": "Ex : Outillage électroportatif"
    }
  },
  "DETAIL_SUB_CATEGORY_PAGE": {
    "TITLE": {
      "HEADER": "Détail d'une sous-gamme",
      "SUB_HEADER": "Sous-gamme",
      "GUARANTEE": "Garantie"
    },
    "SUBTITLE": {
      "HEADER_DETAIL": "Sous-gamme {subCategoryName} de la gamme {categoryName}",
      "HEADER_GUARANTEE": "Liste des garanties associées à la sous-gamme {subCategoryName}",
      "HEADER_SERIAL_NUMBER": "Liste des modèles de numéro de série associés à la sous-gamme {subCategoryName}"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "ID": "ID",
      "NAME": "Nom",
      "CATEGORY": "Gamme",
      "MANUFACTURER": "Fabricant"
    },
    "PLACEHOLDER": {
      "NETWORK": "Sélectionner un réseau"
    },
    "BUTTON": {
      "ADD_GUARANTEE": "Ajouter une garantie"
    },
    "TABLE": {
      "PRODUCT_TYPE": "Composant",
      "NETWORK_NAME": "Réseau",
      "COMMERCIAL_GUARANTEE": "Garantie commerciale",
      "EXTENSION_GUARANTEE": "Extension de garantie",
      "REPAIR_EXTENSION_GUARANTEE": "Extension si réparation"
    },
    "MODAL": {
      "TITLE": "Supprimer une garantie",
      "MESSAGE": "Voulez-vous vraiment supprimer la garantie?",
      "WARNING": "Cette action est irréversible."
    },
    "MESSAGE": {
      "SUCCESS_DELETED": "La garantie a été supprimée avec succès"
    }
  },
  "PRODUCT_PAGE": {
    "PLACEHOLDER": {
      "MANUFACTURER": "Sélectionner une marque",
      "CATEGORY": "Sélectionner une gamme",
      "SUB_CATEGORY": "Sélectionner une sous-gamme",
      "REPARABLE": "Sélectionner un état de réparabilité",
      "CONTROLLABLE": "Sélectionner un état de contrôlabilité"
    },
    "REPARABLE_STATE": {
      "ACTIVE": "Oui",
      "INACTIVE": "Non"
    },
    "TABLE": {
      "VERSION_NUMBER": "Version",
      "BOOMERANG_ID": "ID",
      "PRODUCT_NAME": "Nom",
      "MANUFACTURER_NAME": "Fabricant",
      "CATEGORY_NAME": "Gamme",
      "SUB_CATEGORY_NAME": "Sous Gamme",
      "REPARABLE": "Réparable",
      "CONTROLLABLE": "Contrôlable",
      "DATE": "Date"
    },
    "TABLE_PRODUCT": {
      "PRODUCT_NAME": "Nom du Produit",
      "WORKFLOW": "Workflow",
      "PICTURE": "Photo",
      "REPARABLE": "Réparable",
      "CONTROLLABLE": "Contrôlable",
      "WEIGHT": "Poids (kg)",
      "LENGTH": "Taille (cm)",
      "COMMERCIAL_PRO": "Commerciale pro",
      "COMMERCIAL_PRIVATE": "Commerciale privé",
      "WEB": "Web (fab)",
      "REPARATION": "Réparation"
    },
    "TABLE_PRODUCT_BREAKDOWN": {
      "BOOMERANG_ID": "ID",
      "MANUFACTURER": "Fabricant",
      "DESCRIPTION": "Description",
      "LOADING_PRODUCT": "Chargement des pannes...",
      "MODAL": {
        "TITLE": "Dissocier une panne d'un produit",
        "MESSAGE": "Voulez-vous vraiment dissocier {productBreakdown} du produit?"
      }
    },
    "MESSAGE": {
      "DISSOCIATE": "Panne dissociée avec succès"
    },
    "EXPORT_SUCCESS": "L'export des produits a été effectué et sera envoyé par mail"
  },
  "ACTION_HISTORY": {
    "TITLE": {
      "HEADER": "Historique"
    },
    "SUBTITLE": {
      "HEADER": "Liste des actions utilisateur"
    },
    "WARNING": "Il n'y a aucun détail pour cet élément à afficher.",
    "UNSUPPORTED_TYPE": "Ce type d'élément n'est pas supporté",
    "FILTER": {
      "DATE_START": "Date de début",
      "DATE_END": "Date de fin"
    },
    "PLACEHOLDER": {
      "ELEMENT_TYPE": "Sélectionner un type",
      "ELEMENT_ACTION": "Sélectionner une action"
    },
    "TABLE": {
      "DATE": "Date",
      "AUTHOR": "Auteur",
      "ELEMENT_NAME": "Nom de l'élément",
      "ELEMENT_ACTION": "Action",
      "ELEMENT_TYPE": "Type",
      "MESSAGE": "Message",
      "OTHER": "autre",
      "OTHERS": "autres"
    },
    "ELEMENT_TYPE": {
      "PRODUCT_BREAKDOWN": "Panne produit",
      "PRODUCT_QUESTION": "Test produit",
      "PRODUCT": "Produit",
      "KEY_ACCOUNT_PRODUCT": "Parc produit grand compte",
      "NETWORK": "Réseau",
      "GROUP": "Groupe",
      "STORE": "Magasin",
      "KEY_ACCOUNT_NETWORK": "Réseau grand compte",
      "KEY_ACCOUNT_GROUP": "Groupement grand compte",
      "OPERATING_CENTER": "Centre d'exploitation",
      "MANUFACTURER": "Fabricant",
      "CATEGORY": "Gamme",
      "SUB_CATEGORY": "Sous Gamme",
      "ACCOUNT": "Compte",
      "COLLABORATOR": "Collaborateur",
      "ROLE": "Rôle",
      "GUARANTEE": "Garantie",
      "GUARANTEE_EXTENSION": "Extension de garantie",
      "MODEL_SERIAL_NUMBER": "Modèle de numéro de série",
      "REPAIRER": "Réparateur",
      "REPAIR_CENTER": "Centre de réparation",
      "BILLING": "Facturation",
      "REPAIR_FILE": "Dossier de réparation",
      "ADDITIONAL_REPAIR_COST": "Surcoût de réparation",
      "REPAIR_PACKAGE": "Forfait de réparation",
      "TRANSPORT_PACKAGE": "Forfait de transport",
      "TRANSPORTER": "Transporteur",
      "PRODUCT_DISTRIBUTOR_REF": "Référence produit distributeur",
      "REPAIR_FILE_COMMENT": "Commentaire de dossier",
      "REPAIR_FILE_REPAIRER_ESTIMATE": "Devis réparateur",
      "REPAIR_FILE_REPAIRER_ESTIMATE_OPTION": "Option de devis réparateur",
      "MANUFACTURER_WHITELIST": "Liste blanche",
      "NOTIFICATION_PUSH": "Notification",
      "EXPRESSIST_TRANSPORTER": "Transporteur expressiste",
      "EXPRESSIST_TRANSPORTER_CONNEXION": "Connexion transporteur expressiste",
      "EXPRESSIST_TRANSPORTER_CONNEXION_LINK": "Liaison connexion transporteur expressiste",
      "ESTIMATE_TRANSPORTER_COST": "Devis coût transporteur",
      "RENTAL_MODULE": "Données de location",
      "RENTAL_FILE": "Dossier de réparation",
      "RENTAL_FILE_COMMENT": "Commentaire dossier de réparation",
      "RENTAL_FILE_ATTACHMENT": "Pièce jointe dossier de réparation",
      "RECYCLER": "Recycleur",
      "RECYCLER_CENTER": "Centre de recyclage",
      "RECYCLER_CENTER_LINK": "Liaison centre de recyclage",
      "RECYCLER_BAC": "BAC de recyclage",
      "RECYCLING_BUYBACK": "Prix de rachat recyclage",
      "RECYCLING_CLIENT_LINK": "Liaison client de recyclage",
      "RECONDITIONER": "Reconditionneur",
      "RECONDITIONER_CENTER": "Centre de reconditionnement",
      "RECONDITIONER_CENTER_LINK": "Liaison centre de reconditionnement",
      "CLOUD_STORAGE_INTEGRITY": "Contrôle stockage distant"
    },
    "ELEMENT_ACTION": {
      "CREATE": "Création",
      "UPDATE": "Modification",
      "DELETE": "Suppression",
      "DEACTIVATE": "Désactivation",
      "REACTIVATE": "Réactivation",
      "IMPORT": "Import",
      "EXPORT": "Export",
      "LINK": "Liaison",
      "UNLINK": "Dissociation"
    }
  },
  "EMAIL_OUTBOX_PAGE": {
    "TITLE": {
      "HEADER": "Emails"
    },
    "SUBTITLE": {
      "HEADER": "Suivi des emails asynchrones et relance des échecs"
    },
    "TABLE": {
      "ID": "ID",
      "TYPE": "Type",
      "RECIPIENTS": "Destinataires",
      "STATUS": "Statut",
      "SUBJECT": "Sujet",
      "ATTEMPTS": "Tentatives",
      "LAST_ERROR": "Dernière erreur",
      "CREATED_AT": "Créé le",
      "UPDATED_AT": "Mis à jour le",
      "SENT_AT": "Envoyé le",
      "ACTIONS": "Actions"
    },
    "ACTIONS": {
      "RESEND": "Relancer",
      "RESEND_TECHNICAL_TOOLTIP": "Relance complète : l'email sera renvoyé.",
      "RESEND_POST_SEND_TOOLTIP": "Relance post-envoi : l'email ne sera pas renvoyé. Seuls les traitements après envoi seront repris."
    },
    "MESSAGE": {
      "RESEND_SCHEDULED": "Email planifié pour renvoi"
    }
  },
  "EMAIL_OUTBOX_TYPE": {
    "REPAIRER_ESTIMATE_RECEIPT_FOLLOWUP": "Confirmation de réception de la décision client - relance réparateur",
    "FORGOT_PASSWORD": "Mot de passe oublié",
    "INITIALIZATION_PASSWORD": "Initialisation du mot de passe",
    "ACCOUNT_CREATION_CONFIRMATION": "Création de compte",
    "RENTAL_FILE_CREATED": "Dossier de location créé",
    "RENTAL_STORE_RECEIPT": "Réception location en magasin",
    "RECYCLING_CERTIFICATE": "Certificat recyclage",
    "RECYCLING_COLLECTION_NOTIFICATION": "Notification ramasse recyclage",
    "PUBLIC_ACCOUNT_CREATION_REQUESTER": "Demande compte - demandeur",
    "PUBLIC_ACCOUNT_CREATION_ADMIN": "Demande compte - admin",
    "GUARANTEE_EXTENSION": "Extension de garantie",
    "DOCUMENT_BY_EMAIL": "Documents dossier réparation",
    "LOGIN_2FA": "Code de connexion 2FA",
    "REPAIR_FILE_TRANSPORT_REPAIRER": "Demande transport réparateur",
    "REPAIR_FILE_REMINDER_REPAIRER": "Relance réparateur",
    "REPAIR_FILE_RECEIPT_AT_STORE": "Réception dossier réparation en magasin",
    "MANUFACTURER_ESTIMATE_STORE": "Devis envoyé par le fabricant - information magasin",
    "RECEIPT_AT_STORE_PICKUP_RELAUNCH": "Relance réception en magasin - retrait client",
    "RECEIPT_AT_STORE_SENT_BY_STORE_RELAUNCH": "Relance réception en magasin - envoi magasin",
    "ESTIMATE_PACKAGE_CLIENT": "Devis forfait client",
    "ESTIMATE_PACKAGE_CLIENT_RELAUNCH": "Rappel devis forfait client",
    "ESTIMATE_PACKAGE_CHOICE_STORE": "Choix forfait magasin",
    "REPAIRER_ESTIMATE_CLIENT": "Devis réparateur client",
    "REPAIRER_ESTIMATE_CLIENT_RELAUNCH": "Rappel devis réparateur client",
    "NEW_REPAIRER_ESTIMATE_CLIENT": "Nouveau devis réparateur client",
    "REPAIRER_ESTIMATE_CHOICE_CLIENT": "Choix devis réparateur client",
    "REPAIRER_ESTIMATE_CHOICE_REPAIRER": "Choix devis réparateur",
    "REPAIRER_ESTIMATE_CHOICE_STORE": "Choix devis réparateur magasin",
    "REPAIRER_ESTIMATE_PURCHASE_ORDER_STORE": "Bon de commande devis réparateur magasin",
    "PROSPECT_REQUEST_REPAIRER": "Demande préalable réparateur",
    "PROSPECT_RESPONSE_STORE": "Réponse demande préalable magasin",
    "PROSPECT_MANUFACTURER_SELECTION_STORE": "Sélection fabricant demande préalable magasin",
    "REPAIR_FILE_SHARE_CLIENT": "Partage dossier SAV client",
    "REPAIR_FILE_SHARE_PREPARER": "Partage dossier SAV préparateur",
    "REPAIR_FILE_SHARE_COMMERCIAL": "Partage dossier SAV commercial",
    "REPAIR_FILE_SATISFACTION_QUESTIONNAIRE": "Questionnaire de satisfaction dossier SAV",
    "ADMIN_RELAUNCH_STATUS_CONFIRMATION": "Confirmation relance statut admin",
    "IMPORT_SUCCESS": "Import réussi",
    "IMPORT_ERROR": "Import en erreur",
    "EXPORT_SUCCESS": "Export réussi",
    "EXPORT_ERROR": "Export en erreur",
    "NAMEPLATE_REPAIR_REQUEST": "Demande SAV plaque signalétique",
    "KEY_ACCOUNT_PRODUCT_REQUEST_ADMIN": "Demande de création produit grand compte - admin",
    "KEY_ACCOUNT_PRODUCT_REQUEST_APPROVED": "Demande de création produit grand compte approuvée",
    "KEY_ACCOUNT_PRODUCT_REQUEST_DENIED": "Demande de création produit grand compte refusée",
    "KEY_ACCOUNT_PRODUCT_REQUEST_AWAITING_INFORMATION": "Demande de création produit grand compte - informations complémentaires attendues",
    "KEY_ACCOUNT_PRODUCT_REQUEST_DRAFT_SHARE": "Partage de demande de création produit grand compte",
    "PICKUP_REQUEST": "Demande d'enlèvement SAV",
    "CLOUD_STORAGE_INTEGRITY_RESULT": "Résultat contrôle intégrité stockage distant",
    "PRODUCT_CREATION_REQUEST": "Demande de création produit"
  },
  "CREATE_PRODUCT_PAGE": {
    "PLACEHOLDER": {
      "MANUFACTURER": "Sélectionner le fabricant",
      "CATEGORY": "Sélectionner la gamme",
      "SUB_CATEGORY": "Sélectionner une sous-gamme",
      "COUNTRY_CODE": "Ex : France",
      "PRODUCT_TYPE": "Sélectionner un type",
      "WORKFLOW": "Sélectionner un workflow",
      "NAME": "Ex : Perceuse sans fil",
      "MANUFACTURER_NAME": "Ex : Bosch",
      "DESCRIPTION": "Décrire les informations utiles",
      "SEARCH_KEY_WORDS": "Ex : Batterie, chargeur, perceuse",
      "LENGTH": "Ex : 12",
      "WIDTH": "Ex : 300",
      "WEIGHT": "Ex : 30",
      "REPAIR_TIME": "Ex : 15",
      "PRICE_NEW": "Ex : 49,90",
      "AMOUNT_REPAIR_FUND": "Ex : 49,90",
      "COMMENT": "Ajouter un commentaire utile",
      "MANUFACTURER_CODE_REF": "Ex : REF-12345"
    },
    "TITLE": {
      "HEADER": "Ajouter un produit",
      "SUBTITLE": "Formulaire d'ajout d'un produit"
    },
    "HEADER": {
      "CARD_DENOMINATION": "Dénomination",
      "CARD_INFORMATION": "Informations",
      "CARD_SELLING": "Commercialisation",
      "CARD_CHARACTERISTIC": "Caractéristique",
      "CARD_FINANCE": "Financier"
    },
    "FORM": {
      "LABEL_LOGO": "Vignette produit",
      "PREVIEW": "Aperçu",
      "LABEL_SERIAL_NUMBER_PICTURE": "Numéro de série",
      "LABEL_NAME": "Nom",
      "LABEL_MANUFACTURER_NAME": "Nom fabricant",
      "LABEL_MANUFACTURER_ID_BDD": "ID BDD EG Fabricant",
      "LABEL_MANUFACTURER": "Fabricant",
      "LABEL_CATEGORY": "Gamme",
      "LABEL_SUB_CATEGORY": "Sous-gamme",
      "LABEL_WORKFLOW": "Workflow boomerang",
      "LABEL_ASBESTOS_SHEET": "Amiante",
      "LABEL_RETURNABLE": "Retournable",
      "LABEL_DESCRIPTION": "Description",
      "LABEL_REPAIR_END_DATE": "Année de fin de réparation",
      "LABEL_SELLING_END_DATE": "Année de fin commercialisation",
      "LABEL_REPARABLE": "Réparable",
      "LABEL_CONTROLLABLE": "Contrôlable",
      "LABEL_MANUFACTURER_CODE_REF": "Code référence fabricant",
      "LABEL_COMMENT": "Commentaire",
      "LABEL_SEARCH_KEY_WORDS": "Mot clé de recherche (séparer par une virgule)",
      "LABEL_LENGTH": "Longueur (en mm)",
      "LABEL_WIDTH": "Largeur (en mm)",
      "LABEL_WEIGHT": "Poids (en kg)",
      "LABEL_PRICE_NEW": "Prix neuf en €",
      "LABEL_AMOUNT_REPAIR_FUND": "Fond de réparation en €",
      "LABEL_REPAIR_TIME": "Délais de réparation moyen en jours",
      "LABEL_COUNTRY_CODE": "Pays",
      "LABEL_NEW_PRICE_DATE": "Date prix neuf",
      "LABEL_PRODUCT_TYPE": "Type de composant"
    },
    "BUTTON": {
      "DOWNLOAD_SIMILAR_SERIAL": "Télécharger l'image d'un N° de série d'un produit similaire",
      "VALIDATE": "Valider l'ajout d'un produit"
    },
    "MESSAGE": {
      "SUCCESS": "Le produit a été ajouté avec succès",
      "ERROR": "Impossible d'ajouter le produit"
    }
  },
  "EDIT_PRODUCT_PAGE": {
    "PLACEHOLDER": {
      "MANUFACTURER": "Sélectionner une marque",
      "CATEGORY": "Sélectionner la gamme",
      "SUB_CATEGORY": "Sélectionner une sous-gamme",
      "COUNTRY_CODE": "Ex : France",
      "PRODUCT_TYPE": "Sélectionner un type",
      "WORKFLOW": "Sélectionner un workflow",
      "NAME": "Ex : Perceuse sans fil",
      "MANUFACTURER_NAME": "Ex : Bosch",
      "MANUFACTURER_CODE_REF": "Ex : REF-12345",
      "DESCRIPTION": "Décrire les informations utiles",
      "SEARCH_KEY_WORDS": "Ex : Batterie, chargeur, perceuse",
      "LENGTH": "Ex : 12",
      "WIDTH": "Ex : 300",
      "WEIGHT": "Ex : 30",
      "REPAIR_TIME": "Ex : 15",
      "PRICE_NEW": "Ex : 49,90",
      "AMOUNT_REPAIR_FUND": "Ex : 49,90",
      "COMMENT": "Ajouter un commentaire utile"
    },
    "TITLE": {
      "HEADER": "Édition un produit",
      "SUBTITLE": "Formulaire d'édition d'un produit"
    },
    "HEADER": {
      "CARD_INFORMATION": "Informations",
      "CARD_SELLING": "Commercialisation",
      "CARD_CHARACTERISTIC": "Caractéristiques",
      "CARD_FINANCE": "Financier"
    },
    "FORM": {
      "LABEL_LOGO": "Vignette produit",
      "PREVIEW": "Aperçu",
      "LABEL_SERIAL_NUMBER_PICTURE": "Numéro de série",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom",
      "LABEL_MANUFACTURER_NAME": "Nom fabricant",
      "LABEL_MANUFACTURER_ID_BDD": "ID BDD EG Fabricant",
      "LABEL_MANUFACTURER": "Fabricant",
      "LABEL_CATEGORY": "Gamme",
      "LABEL_SUB_CATEGORY": "Sous-gamme",
      "LABEL_WORKFLOW": "Workflow boomerang",
      "LABEL_ASBESTOS_SHEET": "Amiante",
      "LABEL_RETURNABLE": "Retournable",
      "LABEL_DESCRIPTION": "Description",
      "LABEL_REPAIR_END_DATE": "Année de fin de réparation",
      "LABEL_SELLING_END_DATE": "Année de fin commercialisation",
      "LABEL_REPARABLE": "Réparable",
      "LABEL_CONTROLLABLE": "Contrôlable",
      "LABEL_MANUFACTURER_CODE_REF": "Code référence fabricant",
      "LABEL_COMMENT": "Commentaire",
      "LABEL_SEARCH_KEY_WORDS": "Mot clé de recherche (séparer par une virgule)",
      "LABEL_LENGTH": "Longueur (en mm)",
      "LABEL_WIDTH": "Largeur (en mm)",
      "LABEL_WEIGHT": "Poids (en kg)",
      "LABEL_PRICE_NEW": "Prix neuf en €",
      "LABEL_AMOUNT_REPAIR_FUND": "Fond de réparation en €",
      "LABEL_REPAIR_TIME": "Délais de réparation moyen en jours",
      "LABEL_COUNTRY_CODE": "Pays",
      "LABEL_NEW_PRICE_DATE": "Date prix neuf",
      "LABEL_PRODUCT_TYPE": "Type de composant"
    },
    "BUTTON": {
      "DOWNLOAD_SIMILAR_SERIAL": "Télécharger l'image d'un N° de série d'un produit similaire",
      "VALIDATE": "Valider l'édition d'un produit"
    },
    "MESSAGE": {
      "SUCCESS": "Le produit a été mise à jour avec succès",
      "ERROR": "Impossible de mettre à jour le produit"
    }
  },
  "DETAIL_PRODUCT_PAGE": {
    "TITLE": {
      "HEADER": "Détail d'un produit"
    },
    "SUBTITLE": {
      "HEADER_PRODUCT": "{productId} - {productName}",
      "HEADER_DETAIL": "Consultez les informations détaillées du produit {productName}.",
      "HEADER_VERSION": "Consultez les versions enregistrées pour le produit {productName}.",
      "HEADER_SUB_PRODUCT": "Liste des sous-produits liés au produit {productName}",
      "HEADER_PRODUCT_BREAKDOWN": "Liste des pannes liées au produit {productName}"
    },
    "TAB": {
      "DETAIL_TITLE": "Détail",
      "VERSION_TITLE": "Version"
    },
    "LABEL": {
      "MANUFACTURER": "Fabricant",
      "CATEGORY": "Gamme",
      "SUB_CATEGORY": "Sous-gamme",
      "FOLDER_WORKFLOW": "Workflow boomerang",
      "ID": "ID",
      "IS_PROSPECT": "Demande Préalable",
      "REPAIR_END_DATE": "Année de fin de réparation",
      "SELLING_END_DATE": "Année de fin de commercialisation",
      "REPAIR_TIME": "Délai de réparation moy/3 derniers mois",
      "LENGTH": "Longueur (mm)",
      "WIDTH": "Largeur (mm)",
      "WEIGHT": "Poids (kg)",
      "AMOUNT_REPAIR_FUND": "Fond de réparation",
      "NEW_PRICE": "Prix neuf",
      "ASBESTOS_SHEET": "Amiante",
      "GENERAL_INFO": "Informations générales",
      "STATUS": "Statut",
      "REPARABLE": "Réparabilité",
      "CONTROLLABLE": "Contrôlabilité"
    },
    "ASBESTOS_SHEET": {
      "ACTIVE": "Oui",
      "INACTIVE": "Non"
    },
    "CARD_TITLE": {
      "CARD_PRODUCT": "Produit",
      "CARD_CHARACTERISTIC": "Caractéristiques",
      "CARD_BREAKDOWN": "Pannes principales récurrente",
      "CARD_SUB_PRODUCT": "Sous-produits",
      "CARD_PRODUCT_BREAKDOWN": "Pannes"
    },
    "REPARABLE": {
      "ACTIVE": "Réparable",
      "INACTIVE": "Non réparable"
    },
    "TABLE": {
      "NO_REGION_CODE": "Aucune zone géographique"
    },
    "BUTTON": {
      "ADD_SUB_PRODUCT": "Ajouter une liaison",
      "UPDATE_LOGO": "Modifier",
      "ADD_STORE": "Ajouter un magasin",
      "ADD_REGION_CODE": "Ajouter une liaison",
      "ADD_PRODUCT_BREAKDOWN": "Ajouter une panne"
    },
    "MODAL": {
      "TITLE": "Suppression d’un sous-produit",
      "MESSAGE": "Voulez-vous vraiment supprimer {product}?",
      "WARNING": "Cette action est irréversible."
    },
    "MESSAGE": {
      "SUCCESS": "Le produit a été supprimé avec succès."
    }
  },
  "PRODUCT_VERSION_COMPARISON": {
    "FIELD": "Champ",
    "VERSION_DATE": "Version date",
    "CURRENT": "Actuelle",
    "COMPARED": "Comparée",
    "NO_CHANGE": "Aucun changement",
    "CHANGE_COUNT": "{count} modifié",
    "HISTORY_TITLE": "Historique des versions",
    "HISTORY_SUBTITLE": "Sélectionnez une version à comparer.",
    "VERSION_NUMBER": "Version {number}",
    "NO_VERSION": "Aucune version disponible",
    "GROUP": {
      "IDENTIFICATION": "Identification",
      "VISUAL": "Visuel produit",
      "LIFECYCLE": "Cycle de vie"
    }
  },
  "ADD_REGION_CODE_DIALOG": {
    "TITLE": "Lier des zones géographiques",
    "MESSAGE": "Veuillez choisir des zones à lier au groupement afin de composer un ensemble",
    "FILTER": {
      "LABEL_GROUP": "Groupement",
      "LABEL_REGION_CODE": "Département"
    },
    "PLACEHOLDER": {
      "REGION_CODE": "Sélectionner un département"
    },
    "SELECT": {
      "TITLE": "Produit",
      "LABEL_PRODUCT": "Choisir un produit"
    }
  },
  "ADD_SUB_PRODUCT_DIALOG": {
    "TITLE": "Lier un produit",
    "MESSAGE": "Veuillez choisir un produit à lier afin de composer un ensemble de produit",
    "FILTER": {
      "TITLE": "Filtres",
      "LABEL_MANUFACTURER": "Fabricant",
      "LABEL_CATEGORY": "Gamme",
      "LABEL_SUB_CATEGORY": "Sous-gamme"
    },
    "PLACEHOLDER": {
      "MANUFACTURER": "Sélectionner une marque",
      "CATEGORY": "Sélectionner la gamme",
      "SUB_CATEGORY": "Sélectionner une sous-gamme",
      "PRODUCT": "Sélectionner le produit"
    },
    "SELECT": {
      "TITLE": "Produit",
      "LABEL_PRODUCT": "Choisir un produit"
    }
  },
  "CREATE_PRODUCT_BREAKDOWN_PAGE": {
    "TITLE": {
      "HEADER": "Panne",
      "SUBTITLE": "Lier une panne",
      "LINK_SUBTITLE": "Réutilisez une panne déjà référencée dans le catalogue",
      "HEADER_BREAKDOWN": "Nouvelle panne",
      "HEADER_QUESTION": "Test de la panne",
      "HEADER_QUESTIONS": "Tests de la panne",
      "INFORMATION": "Informations",
      "PRODUCT_INFO": "Produit concerné",
      "TEST_NUMBER": "Test {number}"
    },
    "FORM": {
      "MANUFACTURER": "Fabricant",
      "PRODUCT": "Produit",
      "PRODUCT_BREAKDOWN": "Panne existante",
      "DESCRIPTION": "Description",
      "QUESTION": "Question",
      "PICTURE": "Image",
      "PREVIEW": "Aperçu",
      "BOOMERANG_ID": "ID",
      "OPTION_ONE": "Option 1",
      "OPTION_TWO": "Option 2"
    },
    "BUTTON": {
      "LINK": "Lier",
      "ADD_FORM": "Ajouter un test",
      "ADD_TEST": "Ajouter un nouveau test",
      "ADD_NEW_BREAKDOWN_NOT_IN_CATALOG": "Ajouter une nouvelle panne qui n'existe pas encore au catalogue",
      "VALIDATE": "Valider l'ajout d'une panne au produit"
    },
    "MESSAGE": {
      "SUCCESS_ASSOCIATE": "La panne a été associée avec succès",
      "SUCCESS_CREATE": "La panne a été créé avec succès"
    },
    "ERROR": {
      "NO_NETWORK": "Aucun réseau"
    },
    "PLACEHOLDER": {
      "BOOMERANG_ID": "Ex : B123456",
      "PRODUCT_BREAKDOWN": "Sélectionner une panne existante",
      "OPTION_ONE": "Ex : Oui",
      "OPTION_TWO": "Ex : Non",
      "QUESTION": "Rédiger une question claire"
    }
  },
  "EDIT_PRODUCT_BREAKDOWN_PAGE": {
    "TITLE": {
      "HEADER": "Panne",
      "HEADER_BREAKDOWN": "Édition d'une panne",
      "HEADER_QUESTION": "Test de la panne",
      "HEADER_QUESTIONS": "Tests de la panne",
      "INFORMATION": "Informations",
      "TEST_NUMBER": "Test {number}"
    },
    "FORM": {
      "MANUFACTURER": "Fabricant",
      "PRODUCT": "Produit",
      "PRODUCT_BREAKDOWN": "Panne existante *",
      "SUB_CATEGORY": "Tous les produits liés à une sous-gamme",
      "DESCRIPTION": "Description",
      "QUESTION": "Question",
      "PICTURE": "Image",
      "PREVIEW": "Aperçu",
      "BOOMERANG_ID": "ID",
      "OPTION_ONE": "Option 1",
      "OPTION_TWO": "Option 2"
    },
    "BUTTON": {
      "LINK": "Lier",
      "ADD_FORM": "Ajouter un test",
      "ADD_TEST": "Ajouter un nouveau test",
      "VALIDATE": "Valider la modification de la panne produit"
    },
    "MESSAGE": {
      "SUCCESS_UPDATE": "La panne été mise à jour avec succès"
    },
    "ERROR": {
      "NO_NETWORK": "Aucun réseau"
    },
    "PLACEHOLDER": {
      "BOOMERANG_ID": "Ex : B123456",
      "OPTION_ONE": "Ex : Oui",
      "OPTION_TWO": "Ex : Non",
      "QUESTION": "Rédiger une question claire"
    }
  },
  "CREATE_GUARANTEE_PAGE": {
    "TITLE": {
      "HEADER": "Ajouter une garantie",
      "SUBTITLE": "Formulaire d'ajout d'une garantie"
    },
    "FORM": {
      "GUARANTEE_INFO": "Informations de garantie",
      "LABEL_MANUFACTURER": "Fabricant",
      "LABEL_CATEGORY": "Gamme",
      "LABEL_SUB_CATEGORY": "Sous-gamme",
      "LABEL_NETWORK": "Réseau",
      "LABEL_PRODUCT_TYPE": "Type de composant",
      "LABEL_COMMERCIAL_GUARANTEE": "Garantie commerciale (en jour)",
      "LABEL_EXTENSION_GUARANTEE": "Extension de garantie commerciale (en jour)",
      "LABEL_REPAIR_EXTENSION_GUARANTEE": "Extension de garantie (en cas de réparation)",
      "OTHER": "autre",
      "OTHERS": "autres"
    },
    "PLACEHOLDER": {
      "PRODUCT_TYPE": "Sélectionner le type de composant",
      "NETWORK": "Sélectionner le réseau",
      "COMMERCIAL_GUARANTEE": "Ex : 24",
      "EXTENSION_GUARANTEE": "Ex : 24",
      "REPAIR_EXTENSION_GUARANTEE": "Ex : 24"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'ajout d'une garantie"
    },
    "MESSAGE": {
      "SUCCESS": "La garantie a été ajoutée avec succès",
      "ERROR": "Impossible d'ajouter la garantie"
    }
  },
  "EDIT_GUARANTEE_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'une garantie",
      "SUBTITLE": "Formulaire d'édition d'une garantie"
    },
    "FORM": {
      "GUARANTEE_INFO": "Informations de garantie",
      "LABEL_MANUFACTURER": "Fabricant",
      "LABEL_CATEGORY": "Gamme",
      "LABEL_SUB_CATEGORY": "Sous-gamme",
      "LABEL_PRODUCT_TYPE": "Type de composant",
      "LABEL_NETWORK": "Réseau",
      "LABEL_COMMERCIAL_GUARANTEE": "Garantie commerciale (en jour)",
      "LABEL_EXTENSION_GUARANTEE": "Extension de garantie commerciale (en jour)",
      "LABEL_REPAIR_EXTENSION_GUARANTEE": "Extension de garantie (en cas de réparation)"
    },
    "PLACEHOLDER": {
      "PRODUCT_TYPE": "Sélectionner le type de composant",
      "NETWORK": "Sélectionner le réseau",
      "COMMERCIAL_GUARANTEE": "Ex : 24",
      "EXTENSION_GUARANTEE": "Ex : 24",
      "REPAIR_EXTENSION_GUARANTEE": "Ex : 24"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'édition d'une garantie"
    },
    "MESSAGE": {
      "SUCCESS": "La garantie a été modifiée avec succès",
      "ERROR": "Impossible de modifier la garantie"
    }
  },
  "SERIAL_NUMBER_LIST_PAGE": {
    "TITLE": "Modèle de numéro de série",
    "PLACEHOLDER": {
      "TYPE": "Sélectionner un composant"
    },
    "TABLE": {
      "ID": "ID",
      "FORMAT": "Format",
      "TYPE": "Composant"
    },
    "MODAL": {
      "TITLE": "Supprimer un numéro de série",
      "MESSAGE": "Voulez-vous vraiment supprimer le numéro de série {serialNumber}?",
      "WARNING": "Cette action est irréversible."
    },
    "MESSAGE": {
      "SUCCESS_INACTIVE": "Le numéro de série a été supprimée avec succès"
    },
    "BUTTON": {
      "ADD_SERIAL_MODEL": "Ajouter un modèle"
    }
  },
  "CREATE_MODEL_SERIAL_NUMBER_PAGE": {
    "TITLE": {
      "HEADER": "Ajouter un modèle de numéro de séries",
      "SUBTITLE": "Formulaire d'ajout d'un modèle de numéro de séries"
    },
    "FORM": {
      "MODEL_SERIAL_NUMBER_INFO": "Informations du modèle de numéro de série",
      "MANUFACTURER": "Fabricant",
      "CATEGORY": "Gamme",
      "SUB_CATEGORY": "Sous-gamme",
      "FORMAT": "Format",
      "COMPONENT": "Composant",
      "DESCRIPTION": "Description",
      "MESSAGE_ERROR": "Message d’erreur",
      "GUARANTEE_EXCLUSION": "Listing des exclusions de garantie",
      "OTHER": "autre",
      "OTHERS": "autres"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'ajout d'un modèle de numéro de séries"
    },
    "MESSAGE": {
      "SUCCESS": "Le modèle de numéro de séries a été ajouté avec succès",
      "ERROR": "Impossible d'ajouter le modèle de numéro de séries"
    },
    "PLACEHOLDER": {
      "FORMAT": "Ex : 12 caractères alphanumériques",
      "DESCRIPTION": "Décrire les informations utiles",
      "MESSAGE_ERROR": "Rédiger le message affiché en cas d’erreur",
      "GUARANTEE_EXCLUSION": "Ex : 24"
    }
  },
  "EDIT_MODEL_SERIAL_NUMBER_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'un modèle de numéro de séries",
      "SUBTITLE": "Formulaire d'édition d'un modèle de numéro de séries"
    },
    "FORM": {
      "MODEL_SERIAL_NUMBER_INFO": "Informations du modèle de numéro de série",
      "MANUFACTURER": "Fabricant",
      "CATEGORY": "Gamme",
      "SUB_CATEGORY": "Sous-gamme",
      "FORMAT": "Format",
      "COMPONENT": "Composant",
      "DESCRIPTION": "Description",
      "MESSAGE_ERROR": "Message d’erreur",
      "GUARANTEE_EXCLUSION": "Listing des exclusions de garantie",
      "OTHER": "autre",
      "OTHERS": "autres"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'édition d'un modèle de numéro de séries"
    },
    "MESSAGE": {
      "SUCCESS": "Le modèle de numéro de séries a été modifiée avec succès",
      "ERROR": "Impossible de modifier le modèle de numéro de séries"
    },
    "PLACEHOLDER": {
      "FORMAT": "Ex : 12 caractères alphanumériques",
      "DESCRIPTION": "Décrire les informations utiles",
      "MESSAGE_ERROR": "Rédiger le message affiché en cas d’erreur",
      "GUARANTEE_EXCLUSION": "Ex : 24"
    }
  },
  "REPAIRERS_PAGE": {
    "TITLE": "Réparateurs",
    "SUBTITLE": {
      "HEADER": "Liste des réparateurs"
    },
    "BUTTON": {
      "NEW_REPAIRER": "Nouveau réparateur",
      "REPAIRERS": "Réparateurs",
      "MASS_IMPORT": "Import de Masse"
    }
  },
  "REPAIRER_PAGE": {
    "EXPORT_SUCCESS": "L'export des réparateurs a été effectué et sera envoyé par mail",
    "TABLE": {
      "ID": "ID",
      "NAME": "Nom",
      "REPAIR_CENTER_COUNT": "Nombre de centres"
    },
    "MODAL": {
      "TITLE": "Suppression d’un réparateur",
      "MESSAGE": "Attention, la suppression d'un réparateur entraînera la suppression de tous ses centres de réparation ainsi que l'ensemble des liaisons les concernant avec les distributeurs. Voulez-vous vraiment supprimer {repairer}?",
      "WARNING": "Cette action est irréversible."
    },
    "MESSAGE": {
      "SUCCESS_DELETED": "Le réparateur a été supprimé avec succès"
    }
  },
  "DETAIL_REPAIRER_PAGE": {
    "TITLE": {
      "HEADER": "Détail d'un réparateur",
      "SUB_HEADER": "Réparateur",
      "REPAIR_CENTERS": "Centres de réparation"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "ID": "ID",
      "NAME": "Nom"
    },
    "TABLE": {
      "BOOMERANG_ID": "ID",
      "NAME": "Nom",
      "CITY": "Ville",
      "EMAIL_CONTACT": "Email contact"
    },
    "MODAL": {
      "TITLE": "Suppression d’un centre de réparation",
      "MESSAGE": "Attention la suppression d'un centre de réparation entrainera également la suppression de ses liaisons avec un distributeur. Voulez-vous vraiment supprimer {repair_center}?",
      "WARNING": "Cette action est irréversible."
    },
    "BUTTON": {
      "NEW_REPAIR_CENTER": "Ajouter un centre de réparation"
    },
    "MESSAGE": {
      "SUCCESS_DELETED": "Le centre de réparation a été supprimé avec succès"
    },
    "SUBTITLE": {
      "HEADER_DETAIL": "{repairerName} - {repairerId}",
      "HEADER_REPAIR_CENTER": "Liste des centres de réparation liés à {repairerName}"
    }
  },
  "CREATE_REPAIRER_PAGE": {
    "TITLE": {
      "HEADER": "Ajouter un réparateur",
      "SUBTITLE": "Formulaire d'ajout d'un réparateur"
    },
    "FORM": {
      "REPAIRER_INFO": "Informations générales",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'ajout d'un réparateur"
    },
    "MESSAGE": {
      "SUCCESS": "Le réparateur a été ajouté avec succès",
      "ERROR": "Impossible d'ajouter le réparateur"
    },
    "PLACEHOLDER": {
      "ID": "Ex : B123456",
      "NAME": "Ex : Réparateur agréé"
    }
  },
  "EDIT_REPAIRER_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'un réparateur",
      "SUBTITLE": "Formulaire d'édition d'un réparateur"
    },
    "FORM": {
      "REPAIRER_INFO": "Informations générales",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'édition du réparateur"
    },
    "MESSAGE": {
      "SUCCESS": "Le réparateur a été modifié avec succès",
      "ERROR": "Impossible de modifier le réparateur"
    },
    "PLACEHOLDER": {
      "NAME": "Ex : Réparateur agréé"
    }
  },
  "CREATE_REPAIR_CENTER_PAGE": {
    "BUTTON": {
      "VALIDATE": "Valider l'ajout d'un centre de réparation"
    },
    "FORM": {
      "HINT": {
        "ADDITIONAL_INFORMATION": "Notez ici les informations pratiques sur le fonctionnement du centre de réparation."
      },
      "LABEL": {
        "REPAIRER": "Réparateur",
        "ID": "ID",
        "NAME": "Nom",
        "ADDITIONAL_INFORMATION": "Observations",
        "ADDRESS_NUMBER": "Numéro d'adresse postale",
        "ADDRESS_STREET": "Rue",
        "ADDRESS_COMPLEMENT": "Complément d'adresse",
        "ADDRESS_ZIP_CODE": "Code postal",
        "ADDRESS_CITY": "Ville",
        "ADDRESS_COUNTRY": "Pays",
        "CONTACT_EMAIL": "Email de contact",
        "COLLECT_EMAIL": "Email enlèvement",
        "TNT_CLIENT_KEY": "Clé client TNT",
        "PHONE_NUMBER": "Téléphone",
        "WORKFLOW_DEPOSIT_TEXT": "Sélectionnable comme dépôt atelier",
        "ALLOW_RETURN_ADDRESS_OVERRIDE": "Autoriser la modification de l'adresse de retour"
      },
      "PLACEHOLDER": {
        "ADDITIONAL_INFORMATION": "Ex: spécificités de contact, horaires à éviter, préférences de traitement..."
      }
    },
    "MESSAGE": {
      "SUCCESS": "Le centre de réparation a été ajouté avec succès",
      "ERROR": "Impossible d'ajouter le centre de réparation"
    },
    "TITLE": {
      "HEADER": "Ajouter un centre de réparation",
      "SUBTITLE": "Formulaire d'ajout d'un centre de réparation"
    },
    "SUBTITLE": {
      "ADDITIONAL_INFO": "Informations complémentaires",
      "CONTACT": "Contact",
      "GENERAL_INFO": "Informations générales",
      "OPTIONS": "Options"
    },
    "PLACEHOLDER": {
      "ID": "Ex : B123456",
      "NAME": "Ex : Atelier Paris Nord",
      "ADDRESS_NUMBER": "Ex : 12",
      "ADDRESS_STREET": "Ex : Rue de la Paix",
      "ADDRESS_CITY": "Ex : Paris",
      "CONTACT_EMAIL": "Ex : contact{'@'}exemple.fr",
      "COLLECT_EMAIL": "Ex : contact{'@'}exemple.fr",
      "PHONE_NUMBER": "Ex : 01 23 45 67 89",
      "TNT_CLIENT_KEY": "Ex : TNT-CLIENT-001",
      "ADDRESS_COMPLEMENT": "Ex : 12 rue de la Paix",
      "ADDRESS_ZIP_CODE": "Ex : 75001",
      "ADDRESS_COUNTRY": "Ex : France"
    }
  },
  "DETAIL_REPAIR_CENTER_PAGE": {
    "BUTTON": {
      "NEW_LINK_TO_STORE": "Ajouter une liaison"
    },
    "LABEL": {
      "ADDITIONAL_INFO": "Observations",
      "GENERAL_INFO": "Informations générales",
      "ID": "ID",
      "NAME": "Nom",
      "REPAIRER": "Réparateur",
      "ADDRESS": "Adresse",
      "CONTACT": "Contact",
      "CONTACT_EMAIL": "Email de contact",
      "COLLECT_EMAIL": "Email d'enlèvement",
      "TNT_CLIENT_KEY": "Clé client TNT",
      "PHONE_NUMBER": "Téléphone"
    },
    "MESSAGE": {
      "SUCCESS_DELETED": "La liaison a été supprimée avec succès"
    },
    "MODAL": {
      "TITLE": "Supprimer la liaison",
      "MESSAGE": "Voulez-vous vraiment supprimer la liaison {repair_center_link}?",
      "WARNING": "Cette action est irréversible."
    },
    "TABLE": {
      "BOOMERANG_ID": "ID",
      "NAME": "Nom",
      "TYPE": "Type",
      "MANUFACTURER_COUNT": "Nombre de fabricant",
      "CATEGORY_COUNT": "Nombre de gamme",
      "SUB_CATEGORY_COUNT": "Nombre de sous-gamme",
      "STORE_COUNT": "Nombre de magasin",
      "OPERATING_CENTER_COUNT": "Nombre de centre d'exploitation"
    },
    "TITLE": {
      "ADDITIONAL_INFO": "Informations complémentaires",
      "HEADER": "Détail d'un centre de réparation",
      "REPAIR_CENTER_LINK": "Liaison centre de réparation",
      "SUB_HEADER": "Centre de réparation"
    },
    "SUBTITLE": {
      "HEADER_DETAIL": "{repairCenterName} - {repairCenterId}",
      "HEADER_REPAIR_CENTER_LINK": "Liste des liaisons centre de réparation liées à {repairCenterName}"
    }
  },
  "EDIT_REPAIR_CENTER_PAGE": {
    "BUTTON": {
      "VALIDATE": "Valider l'édition du centre de réparation"
    },
    "FORM": {
      "HINT": {
        "ADDITIONAL_INFORMATION": "Notez ici les informations pratiques sur le fonctionnement du centre de réparation."
      },
      "LABEL": {
        "REPAIRER": "Réparateur",
        "ID": "ID",
        "NAME": "Nom",
        "ADDITIONAL_INFORMATION": "Observations",
        "ADDRESS_NUMBER": "Numéro d'adresse postale",
        "ADDRESS_STREET": "Rue",
        "ADDRESS_COMPLEMENT": "Complément d'adresse",
        "ADDRESS_ZIP_CODE": "Code postal",
        "ADDRESS_CITY": "Ville",
        "ADDRESS_COUNTRY": "Pays",
        "CONTACT_EMAIL": "Email de contact",
        "COLLECT_EMAIL": "Email enlèvement",
        "TNT_CLIENT_KEY": "Clé client TNT",
        "PHONE_NUMBER": "Téléphone",
        "WORKFLOW_DEPOSIT_TEXT": "Sélectionnable comme dépôt atelier",
        "ALLOW_RETURN_ADDRESS_OVERRIDE": "Autoriser la modification de l'adresse de retour"
      },
      "PLACEHOLDER": {
        "ADDITIONAL_INFORMATION": "Ex: spécificités de contact, horaires à éviter, préférences de traitement..."
      }
    },
    "MESSAGE": {
      "SUCCESS": "Le centre de réparation a été modifié avec succès",
      "ERROR": "Impossible de modifier le centre de réparation"
    },
    "TITLE": {
      "HEADER": "Édition d'un centre de réparation",
      "SUBTITLE": "Formulaire d'édition d'un centre de réparation"
    },
    "SUBTITLE": {
      "ADDITIONAL_INFO": "Informations complémentaires",
      "CONTACT": "Contact",
      "GENERAL_INFO": "Informations générales",
      "OPTIONS": "Options"
    },
    "PLACEHOLDER": {
      "NAME": "Ex : Atelier Paris Nord",
      "ADDRESS_NUMBER": "Ex : 12",
      "ADDRESS_STREET": "Ex : Rue de la Paix",
      "ADDRESS_ZIP_CODE": "Ex : 75001",
      "ADDRESS_CITY": "Ex : Paris",
      "ADDRESS_COUNTRY": "Ex : France",
      "CONTACT_EMAIL": "Ex : contact{'@'}exemple.fr",
      "COLLECT_EMAIL": "Ex : contact{'@'}exemple.fr",
      "PHONE_NUMBER": "Ex : 01 23 45 67 89",
      "TNT_CLIENT_KEY": "Ex : TNT-CLIENT-001",
      "ADDRESS_COMPLEMENT": "Ex : 12 rue de la Paix"
    }
  },
  "CREATE_REPAIR_CENTER_LINK_PAGE": {
    "TITLE": {
      "HEADER": "Liaison centre de réparation",
      "SUB_HEADER": "Centre de réparation",
      "STORE_LINKED": "Magasins liés"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "ID": "ID",
      "NAME": "Nom",
      "REPAIRER": "Réparateur",
      "ADDRESS": "Adresse",
      "CONTACT": "Contact",
      "CONTACT_EMAIL": "Email de contact",
      "COLLECT_EMAIL": "Email d'enlèvement",
      "PHONE_NUMBER": "Téléphone",
      "LINK_REPAIR_CENTER_STORE": "Liaison centre de réparation - magasin",
      "LINK_REPAIR_CENTER": "Liaison centre de réparation"
    },
    "FORM": {
      "LABEL_TYPE": "Type de liaison",
      "LABEL_MANUFACTURER": "Fabricant",
      "LABEL_CATEGORY": "Gamme",
      "LABEL_SUB_CATEGORY": "Sous-gamme",
      "LABEL_GUARANTEE": "Garantie",
      "LABEL_NETWORK": "Réseau",
      "LABEL_STORE": "Magasin",
      "LABEL_KEY_ACCOUNT_NETWORK": "Réseau",
      "LABEL_OPERATING_CENTER": "Centre d'exploitation",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom",
      "LABEL_GUARANTEE_TEXT": "Garantie",
      "LABEL_WITHOUT_GUARANTEE_TEXT": "Hors garantie",
      "LABEL_PROSPECT_CONTACT_EMAIL": "Email de contact pour la demande préalable"
    },
    "PLACEHOLDER": {
      "MANUFACTURER": "Sélectionner le fabricant",
      "CATEGORY": "Sélectionner la gamme",
      "SUB_CATEGORY": "Sélectionner la sous-gamme",
      "GUARANTEE": "Ex : 24",
      "NETWORK": "Sélectionner le réseau",
      "REGION_CODE": "Sélectionner un code région",
      "STORE": "Sélectionner le magasin",
      "KEY_ACCOUNT_NETWORK": "Sélectionner le réseau",
      "OPERATING_CENTER": "Sélectionner le centre d'exploitation",
      "ID": "Ex : B123456",
      "NAME": "Ex : Atelier Paris Nord",
      "PROSPECT_CONTACT_EMAIL": "Ex : contact{'@'}exemple.fr"
    },
    "BUTTON": {
      "VALIDATE": "Valider la liaison"
    },
    "MESSAGE": {
      "SUCCESS": "Liaison ajoutée avec succès."
    }
  },
  "BILLINGS_PAGE": {
    "TITLE": {
      "HEADER_BILLINGS": "Facturations"
    },
    "SUBTITLE": {
      "HEADER_BILLINGS": "Gestion des facturations"
    },
    "BUTTON": {
      "NEW_BILLING": "Nouvelle facturation",
      "BILLING": "Facturation"
    }
  },
  "BILLING_PAGE": {
    "TABLE": {
      "ID": "ID",
      "EMAIL_BILLING": "Email de facturation",
      "NETWORK": "Réseau",
      "GROUP": "Groupement",
      "STORE": "Magasin",
      "DATE": "Date",
      "ACCOUNT_EMAIL": "Utilisateur"
    },
    "PLACEHOLDER": {
      "NETWORK": "Sélectionner un réseau"
    },
    "FILTER": {
      "DATE_START": "Date de début",
      "DATE_END": "Date de fin"
    }
  },
  "CREATE_BILLING_PAGE": {
    "TITLE": {
      "HEADER": "Ajouter une facture",
      "SUBTITLE": "Formulaire d'ajout de facture"
    },
    "FORM": {
      "BILLING_INFO": "Informations de facturation",
      "CONTACT_INFO": "Contact facturation",
      "ID": "ID",
      "NAME": "Nom facturation",
      "ID_NETWORK": "Réseau",
      "BILLING_EMAIL": "Email de facturation",
      "CONTACT_FIRSTNAME": "Prénom du responsable facturation",
      "CONTACT_LASTNAME": "Nom du responsable facturation",
      "PHONE": "Téléphone",
      "NUMBER_MANUFACTURER": "N° de fournisseur"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'ajout de facturation"
    },
    "MESSAGE": {
      "SUCCESS": "La facture a été ajouté avec succès",
      "ERROR": "Impossible d'ajouter la facture"
    },
    "PLACEHOLDER": {
      "ID": "Ex : B123456",
      "NAME": "Ex : Facturation réseau Nord",
      "ID_NETWORK": "Sélectionner un réseau",
      "NUMBER_MANUFACTURER": "Ex : N° de fournisseur",
      "BILLING_EMAIL": "Ex : contact{'@'}exemple.fr",
      "CONTACT_FIRSTNAME": "Ex : Marie",
      "CONTACT_LASTNAME": "Ex : Dupont",
      "PHONE": "Ex : 01 23 45 67 89"
    }
  },
  "EDIT_BILLING_PAGE": {
    "TITLE": {
      "HEADER": "Édition de facture",
      "SUBTITLE": "Formulaire d'édition de facture"
    },
    "FORM": {
      "BILLING_INFO": "Informations de facturation",
      "CONTACT_INFO": "Contact facturation",
      "ID": "ID",
      "NAME": "Nom facturation",
      "ID_NETWORK": "Réseau",
      "BILLING_EMAIL": "Email de facturation",
      "CONTACT_FIRSTNAME": "Prénom du responsable facturation",
      "CONTACT_LASTNAME": "Nom du responsable facturation",
      "PHONE": "Téléphone",
      "NUMBER_MANUFACTURER": "N° de fournisseur"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'édition de la facture"
    },
    "MESSAGE": {
      "SUCCESS": "La facture a été modifié avec succès",
      "ERROR": "Impossible de modifier la facture"
    },
    "PLACEHOLDER": {
      "NAME": "Ex : Facturation réseau Nord",
      "NUMBER_MANUFACTURER": "Ex : N° de fournisseur",
      "BILLING_EMAIL": "Ex : contact{'@'}exemple.fr",
      "CONTACT_FIRSTNAME": "Ex : Marie",
      "CONTACT_LASTNAME": "Ex : Dupont",
      "PHONE": "Ex : 01 23 45 67 89"
    }
  },
  "DETAIL_BILLING_PAGE": {
    "TITLE": {
      "HEADER": "Détail d'une facturation",
      "SUB_HEADER": "Facturation",
      "GENERAL_INFO": "Informations générales",
      "CONTACT_INFO": "Contact facturation",
      "STORES": "Magasins",
      "ACCOUNTS": "Utilisateurs"
    },
    "SUBTITLE": {
      "HEADER_DETAIL": "{billingName}",
      "HEADER_STORE": "Liste des magasins liés à {billingName}",
      "HEADER_ACCOUNT": "Liste des utilisateurs liés à {billingName}"
    },
    "LABEL": {
      "GENERAL_INFO": "Informations générales",
      "ID": "ID",
      "NAME": "Nom facturation",
      "ID_NETWORK": "Réseau",
      "BILLING_EMAIL": "Email de facturation",
      "CONTACT_FIRSTNAME": "Prénom du responsable facturation",
      "CONTACT_LASTNAME": "Nom du responsable facturation",
      "PHONE": "Téléphone",
      "NUMBER_MANUFACTURER": "N° de fournisseur"
    },
    "CARD_TITLE": {
      "STORE": "Magasins liés",
      "ACCOUNT": "Utilisateurs liés"
    },
    "TABLE": {
      "STORE_ID": "ID",
      "STORE_ADDRESS_CITY": "Ville",
      "STORE_NAME": "Nom",
      "STORE_CONTACT_EMAIL": "Email de contact",
      "USER_ID": "ID",
      "USER": "Utilisateur",
      "USER_APPLICANT": "Demandeur",
      "USER_NETWORK": "Réseau",
      "USER_ROLE": "Rôle",
      "USER_FILE": "Nombre de dossier",
      "USER_GROUPS": "Groupement",
      "USER_STATUS": "Statut",
      "USER_INFO_QUALITY": "Formation",
      "USER_DESCRIPTION": "Description",
      "USER_SUB_STATUS": "Sous-statut",
      "USER_ACTIVATED_DATE": "Date d'activation",
      "OTHER": "autre",
      "OTHERS": "autres"
    }
  },
  "DETAIL_REPAIR_CENTER_LINK_PAGE": {
    "TITLE": {
      "HEADER": "Détail d'une liaison centre de réparation",
      "SUB_HEADER": "Centre de réparation"
    },
    "SUBTITLE": {
      "HEADER_DETAIL": "{repairCenterLinkName} - {repairCenterLinkId}",
      "HEADER_STORE": "Liste des magasins liés à {repairCenterLinkName}",
      "HEADER_OPERATING_CENTER": "Liste des centres d'exploitation liés à {repairCenterLinkName}",
      "HEADER_PRODUCT_SCOPE": "Liste des produits du périmètre liés à {repairCenterLinkName}",
      "HEADER_MANUFACTURER": "Liste des fabricants liés à {repairCenterLinkName}",
      "HEADER_CATEGORY": "Liste des gammes liées à {repairCenterLinkName}",
      "HEADER_SUB_CATEGORY": "Liste des sous-gammes liées à {repairCenterLinkName}"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "ID": "ID",
      "NAME": "Nom",
      "REPAIR_CENTER": "Centre de réparation",
      "REPAIRER": "Réparateur",
      "ADDRESS": "Adresse",
      "NETWORK": "Réseau",
      "PROSPECT_CONTACT_EMAIL": "Email de contact pour la demande préalable"
    },
    "OPERATING_CENTER": {
      "TITLE": {
        "OPERATING_CENTER_LINKED": "Centres d'exploitation liés"
      },
      "TABLE": {
        "BOOMERANG_ID": "ID",
        "NETWORK": "Réseau",
        "GROUP": "Groupement",
        "OPERATING_CENTER_NAME": "Nom",
        "CONTACT_EMAIL": "Email contact",
        "PHONE_NUMBER": "Téléphone",
        "ZONE": "Zone",
        "NO_OPERATING_CENTER_LINKED": "Aucun centre d'exploitation"
      },
      "MODAL": {
        "TITLE": "Supprimer la liaison avec un centre d'exploitation",
        "MESSAGE": "Voulez-vous vraiment supprimer la liaison avec le centre d'exploitation {operatingCenter}?",
        "WARNING": "Cette action est irréversible."
      },
      "MESSAGE": {
        "SUCCESS_DELETED": "La liaison a été supprimée avec succès"
      }
    },
    "STORE": {
      "TITLE": {
        "STORE_LINKED": "Magasins liés"
      },
      "TABLE": {
        "BOOMERANG_ID": "ID",
        "NETWORK": "Réseau",
        "GROUP": "Groupement",
        "STORE_NAME": "Nom",
        "CONTACT_EMAIL": "Email contact",
        "PHONE_NUMBER": "Téléphone",
        "FOLDER_STATS": "Nombre de dossier",
        "ZONE": "Zone"
      },
      "MODAL": {
        "TITLE": "Supprimer la liaison avec un magasin",
        "MESSAGE": "Voulez-vous vraiment supprimer la liaison avec le magasin {store}?",
        "WARNING": "Cette action est irréversible."
      },
      "MESSAGE": {
        "SUCCESS_DELETED": "La liaison a été supprimée avec succès"
      }
    },
    "MANUFACTURER": {
      "TITLE": {
        "MANUFACTURER_LINKED": "Fabricants liés"
      },
      "TABLE": {
        "BOOMERANG_ID": "ID",
        "NETWORK": "Réseau",
        "CATEGORY_COUNT": "Nombre de gamme",
        "PRODUCT_COUNT": "Nombre de produit"
      },
      "MODAL": {
        "TITLE": "Supprimer la liaison avec un fabricant",
        "MESSAGE": "Voulez-vous vraiment supprimer la liaison avec le fabricant {manufacturer}?",
        "WARNING": "Cette action est irréversible."
      },
      "MESSAGE": {
        "SUCCESS_DELETED": "La liaison a été supprimée avec succès"
      }
    },
    "CATEGORY": {
      "TITLE": {
        "CATEGORY_LINKED": "Gammes liés"
      },
      "TABLE": {
        "BOOMERANG_ID": "ID",
        "MANUFACTURER_NAME": "Fabricant",
        "CATEGORY_NAME": "Nom",
        "SUB_CATEGORY_COUNT": "Nombre de sous-gamme",
        "CATEGORY_PRODUCT_COUNT": "Nombre de produit"
      },
      "MODAL": {
        "TITLE": "Supprimer la liaison avec une gamme",
        "MESSAGE": "Voulez-vous vraiment supprimer la liaison avec la gamme {category}?",
        "WARNING": "Cette action est irréversible."
      },
      "MESSAGE": {
        "SUCCESS_DELETED": "La liaison a été supprimée avec succès"
      }
    },
    "SUB_CATEGORY": {
      "TITLE": {
        "SUB_CATEGORY_LINKED": "Sous-gammes liés"
      },
      "TABLE": {
        "ID": "ID",
        "SUB_CATEGORY_NAME": "Nom",
        "SUB_CATEGORY_PRODUCT_COUNT": "Nombre de produit"
      },
      "MODAL": {
        "TITLE": "Supprimer la liaison avec une sous-gamme",
        "MESSAGE": "Voulez-vous vraiment supprimer la liaison avec la sous-gamme {sub_category}?",
        "WARNING": "Cette action est irréversible."
      },
      "MESSAGE": {
        "SUCCESS_DELETED": "La liaison a été supprimée avec succès"
      }
    }
  },
  "EDIT_REPAIR_CENTER_LINK_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'une liaison centre de réparation",
      "SUB_HEADER": "Formulaire d'une liaison centre de réparation"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "ID": "ID",
      "NAME": "Nom",
      "REPAIRER": "Réparateur",
      "ADDRESS": "Adresse",
      "CONTACT": "Contact",
      "CONTACT_EMAIL": "Email de contact",
      "COLLECT_EMAIL": "Email d'enlèvement",
      "PHONE_NUMBER": "Téléphone",
      "LINK_REPAIR_CENTER_STORE": "Liaison centre de réparation - magasin",
      "LINK_REPAIR_CENTER": "Liaison centre de réparation"
    },
    "FORM": {
      "LABEL_TYPE": "Type de liaison",
      "LABEL_MANUFACTURER": "Fabricant",
      "LABEL_CATEGORY": "Gamme",
      "LABEL_SUB_CATEGORY": "Sous-gamme",
      "LABEL_GUARANTEE": "Garantie",
      "LABEL_NETWORK": "Réseau",
      "LABEL_STORE": "Magasin",
      "LABEL_KEY_ACCOUNT_NETWORK": "Réseau",
      "LABEL_OPERATING_CENTER": "Centre d'exploitation",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom",
      "LABEL_GUARANTEE_TEXT": "Garantie",
      "LABEL_WITHOUT_GUARANTEE_TEXT": "Hors garantie"
    },
    "PLACEHOLDER": {
      "MANUFACTURER": "Sélectionner le fabricant",
      "CATEGORY": "Sélectionner la gamme",
      "SUB_CATEGORY": "Sélectionner la sous-gamme",
      "GUARANTEE": "Ex : 24",
      "NETWORK": "Sélectionner le réseau",
      "REGION_CODE": "Sélectionner un code région",
      "STORE": "Sélectionner le magasin",
      "KEY_ACCOUNT_NETWORK": "Sélectionner le réseau",
      "OPERATING_CENTER": "Sélectionner le centre d'exploitation",
      "NAME": "Ex : Atelier Paris Nord"
    },
    "BUTTON": {
      "VALIDATE": "Modifier la liaison"
    },
    "MESSAGE": {
      "SUCCESS": "Liaison modifiée avec succès."
    }
  },
  "OTHERS_PAGE": {
    "TITLE": {
      "HEADER_OTHERS": "Gestion et autres",
      "HEADER_REGION_CODE": "Régions",
      "HEADER_CLOUD_STORAGE_INTEGRITY": "Stockage distant",
      "HEADER_NOTIFICATION": "Notifications",
      "HEADER_TEMPORARY_MESSAGE": "Message temporaire",
      "HEADER_ITECH": "Itech",
      "HEADER_IMPORT": "Import"
    },
    "SUBTITLE": {
      "HEADER_REGION_CODE": "Gestion des codes régionaux",
      "HEADER_CLOUD_STORAGE_INTEGRITY": "Intégrité du stockage cloud",
      "HEADER_NOTIFICATION": "Gestion des notifications",
      "HEADER_TEMPORARY_MESSAGE": "Gestion des messages temporaires",
      "HEADER_ITECH": "Gestion des mises à jour Itech"
    },
    "BUTTON": {
      "IMPORT": "Import",
      "IMPORT_EXPORT": "Import / Export",
      "NOTIFICATION": "Notification",
      "ITECH": "Itech",
      "CHRONOPOST": "Chronopost",
      "REGION_CODE": "Régions",
      "TEMPORARY_MESSAGE": "Message temporaire",
      "CLOUD_STORAGE_INTEGRITY": "Stockage distant"
    }
  },
  "IMPORT_EXPORT_PAGE": {
    "TITLE": {
      "HEADER_IMPORT_EXPORT": "Imports & Exports",
      "HEADER_PRODUCT": "Produits",
      "HEADER_TRANSPORTER": "Transporteurs",
      "HEADER_OTHER_REFERENTIALS": "Autres référentiels",
      "HEADER_RECYCLING": "Recyclage",
      "HEADER_RENTAL": "Location"
    },
    "SUBTITLE": {
      "HEADER_IMPORT_EXPORT": "Gestion des imports et exports",
      "HEADER_PRODUCT": "Gestion des imports et exports des référentiels produit",
      "HEADER_TRANSPORTER": "Gestion des imports et exports des référentiels transporteur",
      "HEADER_OTHER_REFERENTIALS": "Gestion des imports et exports des autres référentiels",
      "HEADER_RECYCLING": "Gestion des imports et exports des référentiels recyclage",
      "HEADER_RENTAL": "Gestion des imports et exports des référentiels location"
    }
  },
  "CLOUD_STORAGE_INTEGRITY_PAGE": {
    "MANUAL_SCAN": {
      "TITLE": "Vérification manuelle",
      "SUBTITLE": "Lancer un scan de cohérence stockage distant",
      "DESCRIPTION": "Lancer une vérification manuelle pour s'assurer que le contenu de la base de données correspond aux fichiers présents sur le stockage distant. Les écarts détectés seront signalés. Vous recevrez un e-mail avec le résultat du scan une fois celui-ci terminé.",
      "LAST_EXECUTION": "Dernière exécution"
    },
    "LAST_SCAN": {
      "TITLE": "Statut du dernier scan",
      "SUBTITLE": "Résultat de la dernière vérification de cohérence.",
      "STATUS": "Statut",
      "RESULT": "Résultat",
      "STARTED_AT": "Démarré à",
      "ENDED_AT": "Terminé à"
    },
    "BUTTON": {
      "TRIGGER": "Lancer la vérification"
    },
    "PENDING_NOTE": "Un contrôle est déjà en cours. Le bouton sera réactivé une fois terminé.",
    "MESSAGE": {
      "SCHEDULED": "Le contrôle d'intégrité a bien été planifié."
    }
  },
  "LOCAL_BRAND_LIST": {
    "TABLE": {
      "ID": "ID",
      "NAME": "Nom",
      "CATEGORY_COUNT": "Nombre de gamme",
      "PRODUCT_COUNT": "Nombre de produit"
    }
  },
  "CREATE_LOCAL_BRAND_PAGE": {
    "TITLE": {
      "CARD_CREATE": "Créez une nouvelle marque locale et liez-la à ce magasin",
      "CARD_ASSOCIATE": "Liez le magasin à une marque locale existante",
      "CARD_ASSOCIATE_SUBTITLE": "Réutilisez une marque locale déjà référencée dans le catalogue",
      "HEADER": "Ajouter une marque locale au magasin",
      "STORE_INFO": "Magasin",
      "SUBTITLE": "Formulaire d'ajout d'une marque locale"
    },
    "FORM": {
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom",
      "LABEL_MANUFACTURER": "Marque locale",
      "LABEL_NETWORK": "Réseau",
      "LABEL_STORE": "Magasin"
    },
    "PLACEHOLDER": {
      "MANUFACTURER": "Sélectionner une marque locale",
      "ID": "Ex : B123456",
      "NAME": "Ex : Boomerang"
    },
    "BUTTON": {
      "ASSOCIATE_VALIDATE": "Valider la liaison d'une marque locale au magasin",
      "CREATE_VALIDATE": "Valider la création et l'ajout d'une marque locale au magasin"
    },
    "MESSAGE": {
      "SUCCESS": "La marque locale a été ajoutée avec succès",
      "ERROR": "Impossible d'ajouter la marque locale au magasin"
    }
  },
  "TRANSPORTER_PAGE": {
    "TITLE": {
      "HEADER": "Transporteurs",
      "EXPRESSIST": "Expressistes",
      "TRACKING": "Suivi transporteur"
    },
    "SUBTITLE": {
      "HEADER_EXPRESSIST": "Liste des transporteurs",
      "HEADER_TRACKING": "Suivi des expéditions"
    },
    "BUTTON": {
      "NEW_TRANSPORTER": "Ajouter un transporteur"
    },
    "TABLE": {
      "NAME": "Nom du transporteur",
      "STORE_NAME": "Magasin",
      "NO_TRANSPORTER": "Aucun transporteur",
      "OTHER": "autre",
      "OTHERS": "autres"
    },
    "MODAL": {
      "TITLE": "Suppression d’un transporteur",
      "MESSAGE": "Voulez-vous vraiment supprimer {transporter}?",
      "WARNING": "Cette action est irréversible."
    },
    "MESSAGE": {
      "SUCCESS": "Le transporteur a été supprimer avec succès",
      "ERROR": "Impossible de supprimer le transporteur"
    }
  },
  "TRANSPORTER_TRACKING_PAGE": {
    "MANUAL_SCAN": {
      "TITLE": "Vérification manuelle",
      "LAST_EXECUTION": "Dernière exécution"
    },
    "LAST_SCAN": {
      "TITLE": "Statut du dernier contrôle",
      "STATUS": "Statut",
      "TYPE": "Type",
      "CHECKED_COUNT": "Dossiers vérifiés",
      "UPDATED_COUNT": "Dossiers mis à jour",
      "STARTED_AT": "Démarré à",
      "ENDED_AT": "Terminé à"
    },
    "TYPE": {
      "MANUAL": "Manuel",
      "AUTOMATIC": "Automatique"
    },
    "BUTTON": {
      "TRIGGER": "Lancer la vérification"
    },
    "PENDING_NOTE": "Un contrôle est déjà en cours. Le bouton sera réactivé une fois terminé.",
    "MESSAGE": {
      "SCHEDULED": "La vérification transporteur a bien été planifiée."
    },
    "MANUAL_SCAN_SUBTITLE": "Lancer une vérification du tracking {carrier}",
    "MANUAL_SCAN_DESCRIPTION": "Lancer une vérification manuelle des dossiers en transit {carrier}. Les dossiers livrés seront automatiquement mis à jour. Une vérification automatique est exécutée quotidiennement à 7h00 ainsi qu'à 14h00.",
    "LAST_SCAN_SUBTITLE": "Résultat de la dernière vérification {carrier}."
  },
  "CREATE_TRANSPORTER_PAGE": {
    "TITLE": {
      "HEADER": "Ajouter un transporteur",
      "SUBTITLE": "Formulaire d'ajout de transporteur"
    },
    "FORM": {
      "TRANSPORTER_NAME": "Nom du transporteur",
      "STORE_NAME": "Nom du magasin",
      "WEIGHT": "Poids max (kg)",
      "POWER": "Puissance max (wh)",
      "LENGTH": "Taille max (mm)"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'ajout de transporteur"
    },
    "MESSAGE": {
      "SUCCESS": "Le transporteur a été ajouté avec succès",
      "ERROR": "Impossible d'ajouter le transporteur"
    }
  },
  "EDIT_TRANSPORTER_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'un transporteur",
      "SUBTITLE": "Formulaire d'édition de transporteur"
    },
    "FORM": {
      "TRANSPORTER_NAME": "Nom du transporteur",
      "STORE_NAME": "Nom du magasin",
      "WEIGHT": "Poids max (kg)",
      "POWER": "Puissance max (wh)",
      "LENGTH": "Taille max (mm)"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'édition de transporteur"
    },
    "MESSAGE": {
      "SUCCESS": "Le transporteur a été modifié avec succès",
      "ERROR": "Impossible de modifier le transporteur"
    }
  },
  "DETAIL_TRANSPORTER_PAGE": {
    "TITLE": {
      "HEADER": "Détail d'un transporteur",
      "SUB_HEADER": "Transporteur"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "TRANSPORTER_NAME": "Nom du transporteur",
      "STORE_NAME": "Nom du magasin",
      "WEIGHT": "Poids max (kg)",
      "POWER": "Puissance max (wh)",
      "LENGTH": "Taille max (mm)"
    }
  },
  "REPAIR_FILE": {
    "BUTTON": {
      "EXPORT": "Exporter les dossiers"
    }
  },
  "WHITELIST": {
    "TEXT": "Choisissez le(s) fabricant(s) à mettre en liste blanche",
    "PLACEHOLDER": {
      "MANUFACTURER": "Sélectionner une ou plusieurs marques"
    }
  },
  "REPAIR_FILE_LIST": {
    "TITLE": "Dossiers",
    "FILTER": "Filtrer",
    "EXPORT": "Exporter",
    "DELETE_FILTER": "Effacer les filtres",
    "TABLE": {
      "INTERNAL_COMMAND_NUMBER": "Dossier",
      "COMPANY_NAME": "Nom entreprise",
      "STORE_NAME": "Nom magasin",
      "MANUFACTURER_NAME": "Marque",
      "PRODUCT_NAME": "Produit",
      "STATUS": "Statut",
      "TIME": "Temps",
      "DATE": "Date",
      "MODALITY": "Pris en charge"
    },
    "MODALITY": {
      "TRANSPORTER": "Transporteur",
      "WORKSHOP": "Atelier",
      "STORE": "Magasin",
      "DISTRIBUTOR_DROP_OFF": "Dépôt distributeur",
      "EXCLUDING_SUPPORT": "Hors process"
    },
    "FILTERS": {
      "CURRENT_FOLDER": "Dossiers en cours uniquement",
      "DATE_CREATION": "Date de création",
      "RENTAL": "Avec dossier de location uniquement"
    },
    "PLACEHOLDER": {
      "MANUFACTURER": "Sélectionnez la marque",
      "STATUS_MACRO": "Sélectionnez le statut",
      "MODALITY": "Sélectionnez la modalité",
      "STORE": "Sélectionnez le magasin",
      "NETWORK": "Sélectionnez le réseau"
    },
    "DAYS": "jours"
  },
  "REPAIR_FILE_LAYOUT": {
    "TITLE": "Dossiers",
    "SUBTITLE": {
      "HEADER_LISTING": "Liste des dossiers de réparation",
      "HEADER_UPDATE_STATUS": "Mise à jour des statuts",
      "HEADER_MANUAL_CLOSE": "Fermeture manuelle des dossiers",
      "HEADER_DELETE_BY_STORE": "Suppression par magasin"
    },
    "TAB": {
      "LISTING": "Liste des dossiers",
      "UPDATE_STATUS": "Mise à jour statuts",
      "MANUAL_CLOSE": "Clôture manuelle",
      "DELETE_BY_STORE": "Suppression par magasin"
    }
  },
  "REPAIR_FILE_MANUAL_CLOSE_PAGE": {
    "CONFIRMATION_MODAL": {
      "TITLE": "Confirmer la clôture manuelle",
      "MESSAGE": "Le dossier {boomerangId} sera clôturé manuellement au statut \"Remis au client\".",
      "WARNING": "Cette action est sensible et modifie l'historique du dossier."
    },
    "LABEL": {
      "BOOMERANG_ID": "N° Boomerang",
      "CLOSE_DATE": "Date de clôture",
      "COMMENT": "Commentaire (optionnel)"
    },
    "PLACEHOLDER": {
      "BOOMERANG_ID": "Ex : B123456",
      "COMMENT": "Raison interne de la clôture manuelle"
    },
    "SUBMIT": "Clôturer le dossier",
    "SUCCESS": "Le dossier {boomerangId} a été clôturé manuellement"
  },
  "REPAIR_FILE_DELETE_PAGE": {
    "CONFIRMATION_MODAL": {
      "MESSAGE": "Tous les dossiers de réparation du magasin {storeName} seront supprimés.",
      "TITLE": "Êtes-vous sûr de vouloir supprimer ces dossiers ?",
      "WARNING": "Cette action est irréversible."
    },
    "LABEL": {
      "COMPANY_NAME": "Nom de l'entreprise (partiel)",
      "LIMIT_DATE": "Date limite",
      "NETWORK": "Sélectionnez un réseau",
      "STORE": "Sélectionnez un magasin"
    },
    "PLACEHOLDER": {
      "COMPANY_NAME": "Ex : Entreprise Dupont",
      "NETWORK": "Sélectionnez un réseau",
      "STORE": "Sélectionnez un magasin"
    },
    "SUBMIT": "Supprimer les dossiers",
    "SUCCESS": "Les dossiers de réparation du magasin {storeName} ont été supprimés avec succès",
    "SUBTITLE": "Sélectionnez un magasin pour lequel supprimer les dossiers de réparation",
    "TITLE": "Supprimer des dossiers"
  },
  "REPAIR_FILE_DETAIL": {
    "INTERNAL_COMMAND_NUMBER": "N° ",
    "STORE": "Magasin : ",
    "CLIENT_COMPANY_NAME": "Entreprise : ",
    "MESSAGE": {
      "DELETE": {
        "SUCCESS": "Le dossier a été supprimé avec succès"
      },
      "STATUS_MACRO_UNKNOWN": "Statut du dossier est inconnu",
      "DRAFT": "Le dossier n'a pas encore atteint l'étape de création",
      "DELETED": "Le dossier a été supprimé",
      "NOT_FOUND": "Le dossier n'a pas été trouvé"
    },
    "MODAL": {
      "DELETE_REPAIR_FILE": {
        "TITLE": "Supprimer le dossier",
        "MESSAGE": "Voulez-vous vraiment supprimer le dossier?",
        "WARNING": "Cette action est irréversible."
      }
    },
    "HEADER_RENTAL": {
      "REPAIR": "Réparation",
      "RENTAL": "Location"
    }
  },
  "REPAIR_FILE_GLOBAL_INFO": {
    "STATUS_DISPLAY": {
      "IN_CREATION": "1.   En création",
      "TRANSPORT_GO": "2.   Enlèvement aller",
      "RECEPTION_AT_REPAIRER": "3.   Réception chez réparateur",
      "DIAGNOSTIC_MANUFACTURER_RECEIVED": "4.   Devis envoyé par le fabricant",
      "DIAGNOSTIC_MANUFACTURER_PROCESSED": "5.   Intégration devis fabricant",
      "ESTIMATE_SENT_TO_CUSTOMER": "6.   Devis envoyé au client",
      "ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER": "7.   Décision client envoyée au réparateur",
      "IN_REPARATION": "8.   En réparation",
      "SENT_BACK_BY_REPAIRER": "9.   Expédition par réparateur",
      "RECEIPT_AT_STORE": "10.   Réception par distributeur",
      "SENT_AVAILABLE_TO_CUSTOMER": "11.   Client informé dispo",
      "TAKEOVER_BY_CUSTOMER": "12.   Remise au client - Clôturé",
      "NETWORK_BILLING": "13.   Facturation",
      "FINISHED": "14.   Dossier Terminé"
    },
    "STATUS_ACTION": {
      "VALIDATE_RECEIPT": "Valider réception"
    },
    "REPAIR_FILE_INFO": {
      "TITLE": {
        "PRODUCT": "Produit",
        "SUMMARY": "Résumé",
        "PROGRESSION": "Progression",
        "SUPPORT": "Prise en charge",
        "PRICING": "Tarification détaillée",
        "PROSPECT_FLOW": "Demande de prise en charge préalable"
      },
      "PRODUCT": "Produit",
      "SERIAL_NUMBER": "Série",
      "DESCRIPTION": "Description",
      "CONTACT": "Contact",
      "LASTNAME": "Nom de l'interlocuteur",
      "EMAIL": "Email",
      "PHONE_NUMBER": "Téléphone",
      "WORKSITE_CODE": "Code spécifique",
      "CLIENT_CODE": "Code client",
      "PRICING": "Tarification client (HT)",
      "MODE": "Mode",
      "SUPPORT": "Prise en charge initialement demandée",
      "GESTION": "Lieu de réparation",
      "PRICING_STATUS": {
        "PACKAGE_VALIDATED": "Forfait validé par le client",
        "BOSCH_PACKAGE_VALIDATED": "Forfait validé par le client (Besoin de confirmer à BOSCH le devis à venir)",
        "ESTIMATE_TO_INTEGRATE": "Devis à intégrer",
        "WAITING_CUSTOMER_DECISION": "Attente décision clients sur options proposées",
        "ESTIMATE_VALIDATED": "Validation Devis par le client"
      },
      "ELEMENT": "Éléments concernés",
      "GUARANTEE": "Garantie initiale",
      "UNDER_GUARANTEE": "Sous garantie",
      "OUT_GUARANTEE": "Hors garantie",
      "TRANSPORT_COST": "Coût transport",
      "TRANSPORT_PRICE": "Prix transport",
      "MANAGEMENT_COST": "Coût gestion",
      "MANAGEMENT_PRICE": "Prix gestion",
      "REPAIR_COST": "Prix de réparation",
      "REPAIR_FUND": "Fond de réparation",
      "PACKAGE_CODE": "Code forfait fabricant",
      "PACKAGE_TOTAL_COST": "Coût total (HT)",
      "PACKAGE_SUPPORT_COST": "Prix de la prise en charge (HT)",
      "NETWORK_PACKAGE_CODE": "Code forfait distributeur",
      "ESTIMATE": "Coût devis réparation",
      "ESTIMATE_VALIDATE_BY_CUSTOMER": "Offre validée par client",
      "ESTIMATE_VALIDATE_TAKEOVER_BY_CUSTOMER": "Offre finale client",
      "ESTIMATE_VALIDATE_COST": "Coût facturé par réparateur (HT)",
      "ESTIMATE_VALIDATE_DETAIL_ESTIMATE_COST": "Coût facturé par réparateur (HT)",
      "ESTIMATE_VALIDATE_DETAIL_TRANSPORT_COST": "Coût transport (HT)",
      "ESTIMATE_VALIDATE_DETAIL_LABOR_COST": "Coût main-d'œuvre (HT)",
      "ESTIMATE_VALIDATE_DETAIL_REPAIR_COST": "Coût total de la réparation (HT)",
      "ESTIMATE_VALIDATE_TRANSPORT_COST": "Prix transport (inclus dans prise en charge) (HT)",
      "ADDITIONAL_REPAIR_COST": "Prix gestion",
      "CUSTOMER_END_COST": "Prix total client (HT)",
      "REPAIR_FILE_IN_PROGRESS": "Dossier en cours",
      "TAKEOVER_BY_CUSTOMER": "Remis au client",
      "NO_PRICE": "- €",
      "CLIENT_LABEL": "Client",
      "REPAIRER_LABEL": "Réparateur",
      "REPAIRER_COST_MAX": "Coût de réparation max (HT)",
      "COMMENT": "Commentaires :"
    },
    "ESTIMATE_OPTION_STATUS": {
      "PRODUCT_REPAIRED": "Réparation de la machine",
      "PRODUCT_REPLACED_STANDARD": "Remplacement produit standard",
      "PRODUCT_REPLACED_SUPERIOR": "Remplacement produit supérieur",
      "PRODUCT_CREDIT": "Gestion par avoir",
      "PRODUCT_RECYCLED": "Non-réparation : recyclage",
      "PRODUCT_RETURN_DISASSEMBLED": "Non-réparation : retour de la machine démontée",
      "PROSPECT_REPAIR_WITH_GUARANTEE": "Demande préalable : Réparation de la machine sous garantie",
      "PROSPECT_REPAIR_WITHOUT_GUARANTEE": "Demande préalable : Réparation de la machine hors garantie",
      "PROSPECT_CREDIT_OR_REFUND": "Demande préalable : Avoir",
      "PROSPECT_REPLACEMENT": "Demande préalable : Échange",
      "PROSPECT_REJECT": "Demande préalable : Pas de prise en charge",
      "PROSPECT_OTHER": "Demande préalable : Autre"
    },
    "HEADER": {
      "TITLE": "Récapitulatif demande de réparation",
      "DAYS": " jours",
      "DAY": " jour"
    },
    "BUTTON": {
      "NEW_ACTION": "Nouvelle action"
    },
    "ERROR": {
      "MANUAL_UPDATE_INVALID": "La mise à jour manuelle de ce status est impossible"
    }
  },
  "REPAIR_FILE_ATTACHMENT": {
    "BUTTON": {
      "ADD": "Ajouter",
      "DELETE": "Supprimer",
      "DOWNLOAD": "Télécharger",
      "SELECT_ALL": "Tout sélectionner",
      "SEND_BY_EMAIL": "Envoyer par email",
      "UNSELECT_ALL": "Tout désélectionner"
    },
    "CARD": {
      "CUSTOMER_SATISFACTION": "Satisfaction client",
      "TRANSPORTER_ORDER": "Étiquette expédition",
      "REPAIR_ORDER": "Ordre de réparation",
      "BILLING": "Facture client",
      "GUARANTEE": "Extension de garantie",
      "FORCE_GUARANTEE": "Garantie forcée",
      "REPAIRER_ESTIMATE": "Devis réparateur",
      "ASBESTOS": "Déclaration amiante",
      "AFTER_SALE_SERVICE": "Fiche SAV client",
      "DANGER_LABEL": "Étiquette produit dangereux",
      "INFO": "(à coller sur colis)",
      "ESTIMATE_PACKAGE": "Devis du forfait",
      "ADD_ATTACHMENT": "Ajouter une pièce jointe",
      "GUARANTEE_EXTENSION_BOOMERANG": "BL à faire signer + Certificat de garantie Boomerang",
      "REPAIR_FILE_PROSPECT_ORDER_WAITING": "Demande préalable",
      "DELIVERY_NOTE": "BL à faire signer",
      "TRANSPORTER_DOCUMENT_FOR_REPAIRER": "Document spécifique pour ce réparateur"
    },
    "LABEL": {
      "EMAIL_TITLE": "Objet de l'email",
      "EMAIL_CONTENT": "Contenu de l'email",
      "REPAIRER_EMAIL": "Email réparateur",
      "CUSTOMER_USER_EMAIL": "Email du client utilisateur",
      "EMAIL_RECIPIENT": "Destinataire",
      "EMAIL_CC": "Copie (CC)",
      "EMAIL_CC_PLACEHOLDER": "email1{'@'}domaine.com;email2{'@'}domaine.com"
    },
    "MODAL": {
      "ACCEPTED_FORMATS": "Formats acceptés : PDF, JPG, PNG, JPEG",
      "FILE": "Ajouter votre pièce jointe",
      "FILE_NAME": "Nom du fichier",
      "GENERIC_TITLE": "Ajouter une pièce jointe",
      "GENERIC_SUBTITLE": "Sélectionnez le mode d'ajout",
      "INPUT_LABEL_BY_PC": "Via votre ordinateur",
      "INPUT_LABEL_BY_QR_CODE": "Via votre téléphone ou pad",
      "PC_TITLE": "Ajouter une pièce jointe via ordinateur",
      "QR_CONFIRM": "J'ai ajouté le document",
      "QR_CODE_TITLE": "Ajouter une pièce jointe via QR Code",
      "QR_CODE_SUBTITLE": "Pour ajouter la pièce jointe, scannez le QRCode.",
      "QR_UPLOAD_MISSING": "Aucun document n'a encore été ajouté via QR code.",
      "SUBTITLE": "Ajoutez un fichier depuis cet ordinateur ou générez un QR code pour l'ajouter depuis un mobile.",
      "UPLOAD_VIA_MOBILE": "Ajouter via QR code"
    },
    "PERMISSION": {
      "VIEW_ATTACHMENT_REPAIR_FILE_DENIED": "Vous n'avez pas les droits requis pour visualiser les pièces jointes du dossier",
      "PRINT_ATTACHMENT_REPAIR_FILE_DENIED": "Vous n'avez pas les droits requis pour télécharger les pièces jointes du dossier"
    },
    "PROSPECT_PICTURE_NAME_LABEL": "Photo-",
    "PROSPECT_DOCUMENT_NAME_LABEL": "Document-",
    "SELECTED_DOCUMENT": {
      "GREETING": "Bonjour,\n\n",
      "INTRODUCTION_1": "Suite à votre demande, trouvez ci-joint les documents complémentaires à votre dossier B8G-",
      "INTRODUCTION_2": " concernant le produit ",
      "REMINDER": "Dans le cadre d'un transport pensez à bien associer TOUS ces éléments avec votre produit afin que le dossier soit transmis de la meilleure manière à vos Transporteur, Réparateur ou Fabricant.\n\n",
      "SIGNATURE": "L'équipe BOOMERANG",
      "SINCERELY": "Cordialement,\n\n"
    },
    "SUCCESS_EMAIL": "Documents envoyés par email avec succès",
    "SELECTED_COUNT": "{count} sélectionnée(s)",
    "TITLE": "Pièces jointes",
    "PLACEHOLDER": {
      "INPUT_LABEL_BY_QR_CODE": "Scanner le QR code avec un téléphone ou une tablette",
      "INPUT_LABEL_BY_PC": "Ajouter une pièce jointe depuis l’ordinateur",
      "FILE_NAME": "Ex : Nom du fichier",
      "EMAIL_TITLE": "Ex : contact{'@'}exemple.fr",
      "EMAIL_CONTENT": "Ex : contact{'@'}exemple.fr",
      "EMAIL_RECIPIENT": "Ex : contact{'@'}exemple.fr"
    }
  },
  "ATTACHMENT_MODAL": {
    "QR_CODE_MODAL": {
      "TITLE": "Ajout de la pièce jointe par QR Code",
      "MESSAGE": "Pour ajouter la pièce jointe, scannez le QRCode.",
      "VALIDATION_BUTTON": "Confirmer l'ajout de la pièce jointe"
    },
    "QR_CODE_PAGE": {
      "ACCEPTED_FORMATS": "Formats acceptés : PDF, JPG, PNG, JPEG",
      "DROPZONE_TITLE": "Déposez le document",
      "HINT": "Le document sera rattaché au dossier après confirmation sur l'ordinateur.",
      "TITLE": "Ajout de la pièce jointe",
      "MESSAGE": "Pour mettre à jour le dossier vous devez ajouter une pièce jointe.",
      "REMOVE_FILE": "Supprimer le document",
      "SELECT_TITLE": "Sélectionner votre pièce jointe :",
      "SUBTITLE": "Ajoutez le document depuis votre mobile.",
      "TAKE_PHOTO": "Prendre une photo",
      "TITLE_SENT": "Merci, votre pièce jointe est bien ajoutée au dossier",
      "MESSAGE_SENT": "Vous pouvez à présent poursuivre sur la plateforme",
      "TITLE_ERROR_TOKEN_VALIDITY": "L'accès à cette page est périmé ou invalide.",
      "MESSAGE_ERROR_TOKEN_VALIDITY": "Vous pouvez demander un nouvel accès depuis la plateforme BOOMERANG"
    }
  },
  "REPAIR_FILE_DELIVERY_CLIENT_DRAWER": {
    "UPDATE_TITLE": "Mise à jour du dossier",
    "CLOSE_TITLE": "Clôture du dossier",
    "SUB_TITLE": {
      "GUARANTEE_INFORMATION": "Information pour prolongation de garantie 6 mois",
      "BILLING_NUMBER": "Numéro Commande Fournisseur",
      "DELIVERY_INFORMATION": "Informations de remise client",
      "BILLING_CLIENT_COST": "Montant facturé au client (HT)",
      "DELIVERY_DATE": "Date de remise client",
      "REPAIR_CHANGE_COST": "Prise en charge",
      "TRANSPORT": "Transport",
      "MANAGEMENT": "Gestion",
      "REF_ERP": "Référence ERP"
    },
    "DETAIL": {
      "DELIVERY_DATE_1": "La date du jour est enregistrée automatiquement.",
      "DELIVERY_DATE_2": "Si vous souhaitez la modifier, sélectionnez une date."
    },
    "PRODUCT_END_STATUS": {
      "PRODUCT_REPAIRED": "Réparation de la machine",
      "PRODUCT_REPLACED_STANDARD": "Remplacement produit standard",
      "PRODUCT_REPLACED_SUPERIOR": "Remplacement produit supérieur",
      "PRODUCT_CREDIT": "Gestion par avoir",
      "PRODUCT_RECYCLED": "Non-réparation : recyclage",
      "PRODUCT_RETURN_DISASSEMBLED": "Non-réparation : retour de la machine démontée",
      "DEFAULT": "Dossier sans remise client",
      "PROSPECT_REPAIR_WITH_GUARANTEE": "Demande préalable : Réparation de la machine sous garantie",
      "PROSPECT_REPAIR_WITHOUT_GUARANTEE": "Demande préalable : Réparation de la machine hors garantie",
      "PROSPECT_CREDIT_OR_REFUND": "Demande préalable : Avoir",
      "PROSPECT_REPLACEMENT": "Demande préalable : Échange",
      "PROSPECT_REJECT": "Demande préalable : Pas de prise en charge",
      "PROSPECT_OTHER": "Demande préalable : Autre"
    },
    "SELECT": {
      "END_STATUS": "Sélectionnez le statut final du produit",
      "PRODUCT_BOOMERANG_NAME": "Identifiant du produit",
      "SELECT_PRODUCT": "Sélectionnez un produit",
      "PRODUCT_END_COST": "Coût total facturé par le réparateur (HT)",
      "SERIAL_NUMBER": "Numéro de série",
      "EURO": "€",
      "TOTAL": "Total: ",
      "TOTAL_HT": "Total HT"
    },
    "PLACEHOLDER": {
      "END_STATUS": "Sélectionnez le statut final du produit",
      "PRODUCT": "Sélectionnez le produit",
      "SEARCH": "999 999 999 999",
      "PRODUCT_END_COST": "Ex : 49,90",
      "BILLING_NUMBER": "Ex : Numéro Commande Fournisseur",
      "REPAIR_CHANGE_COST": "Ex : 49,90",
      "TRANSPORT": "Ex : 12,50",
      "MANAGEMENT": "Ex : 8,00"
    },
    "BUTTON": {
      "SERIAL_NUMBER": "Trouver le numéro de série"
    },
    "MESSAGE": {
      "PRODUCT_BOOMERANG_ID_NOT_FOUND": "Votre dossier n’est pas disponible pour le moment.",
      "PROLONGATION_GUARANTEE_FOUND": "Le numéro de série de ce produit possède déjà une prolongation de garantie.",
      "GENERIC_SERIAL_NUMBER": "Ce numéro de série est générique et le produit ne bénéficiera pas de garantie automatique."
    }
  },
  "INFORMATION_REPAIR_FILE": {
    "CLIPBOARD_COPY": "Adresse de contact magasin copiée dans le presse-papiers",
    "REPAIRER_CLIPBOARD_COPY": "Adresse de contact réparateur copiée dans le presse-papiers",
    "CLIPBOARD_COPY_ERROR": "Erreur lors de la copie dans le presse-papiers",
    "CONTENT": "Prise en charge",
    "REPAIR_CENTER": {
      "ADDRESS": "Adresse",
      "EMAIL": "Adresse de contact",
      "ERP_REPAIRER_NUMBER": "Numéro compte réparateur",
      "NAME": "Nom",
      "PHONE": "Numéro de téléphone",
      "REPAIRER_NUMBER": "Numéro de dossier réparateur",
      "TITLE": "Réparateur"
    },
    "STORE": {
      "ADDRESS": "Adresse",
      "EMAIL": "Adresse de contact",
      "NAME": "Nom",
      "PHONE": "Numéro de téléphone",
      "TITLE": "Magasin"
    },
    "TITLE": "Informations",
    "TRANSPORTER_MODALITY": {
      "TRANSPORTER": "Transporteur",
      "WORKSHOP": "Atelier",
      "STORE": "Magasin",
      "EXCLUDING_SUPPORT": "Hors process"
    },
    "REPAIR_LOCATION": {
      "EXTERNAL_REPAIRER": "Réparateur Externe",
      "STORE_WORKSHOP": "Atelier Magasin",
      "CUSTOMER_WORKSHOP": "Atelier Client"
    }
  },
  "COMMENTARY_REPAIR_FILE": {
    "TITLE": "Commentaires",
    "INFO_ALERT": "L'équipe Boomerang n'est pas alertée de vos commentaires. Afin de nous contacter, appuyer sur le Chat (bulle verte en bas à droite).",
    "BUTTON": {
      "SEND": "Envoyer"
    },
    "PLACEHOLDER": {
      "COMMENTARY": "Ajouter un commentaire"
    },
    "VISIBILITY": {
      "KEY_ACCOUNT": "Partager avec le client utilisateur",
      "STORE": "Partager avec le magasin"
    },
    "INVISIBLE_TO": "Invisible par {targets}",
    "VISIBILITY_TARGET": {
      "STORE": "Équipe Magasin",
      "KEY_ACCOUNT": "Client Utilisateur"
    },
    "TYPE": {
      "STORE": "Équipe Magasin",
      "KEY_ACCOUNT": "Client Utilisateur",
      "ADMIN": "Équipe BOOMERANG",
      "EXTERNAL": "Externe",
      "REPAIRER": "Réparateur"
    }
  },
  "TRANSPORTER_REPAIR_FILE": {
    "TITLE": "Adresses A/R",
    "GO_TO": "Aller",
    "GO_DEPARTURE_ADDRESS": "ALLER - ADRESSE DE DEPART",
    "GO_DESTINATION_ADDRESS": "ALLER - ADRESSE DESTINATAIRE",
    "RETURN_TO": "Retour",
    "RETURN_REPAIRER_ADDRESS": "RETOUR - ADRESSE RETOUR",
    "TRANSPORTER_GO": "Transport aller",
    "ADDRESS_NAME": "Nom adresse",
    "ADDRESS": "Adresse",
    "CITY": "Ville",
    "TRANSPORT_TYPE": "Type de transport",
    "TRANSPORTER": "Transporteur",
    "FINALIZATION_DATE": "Date finalisation dossier",
    "COLLECT_STATUS": "Demande de ramasse",
    "EXPEDITION_DATE": "Date expédition",
    "TRACKING_NUMBER": "Numéro de tracking",
    "PACKAGE_WEIGHT": "Poids du colis",
    "PALLET": "Transport avec palette",
    "TRANSPORTER_LOGIN": "Login du contrat transporteur",
    "TYPE": {
      "IMMEDIATE_TRANSPORTER": "Transporteur immédiat",
      "CUSTOMER_SERVICE_TRANSPORTER": "Transporteur du service client",
      "WITHOUT_TRANSPORTER": "Sans transporteur"
    },
    "TRANSPORTER_NAME": {
      "CHRONOPOST": "Chronopost"
    }
  },
  "UPDATE_STATUS_FORM_MODAL": {
    "TITLE": "Changer le statut",
    "MESSAGE": "Mettez à jour le statut du dossier et sélectionnez la date si différente de la\ndate du jour et validez",
    "PLACEHOLDER": "Sélectionner un statut disponible",
    "PICKUP_PLACE": "Lieu où récupérer le produit"
  },
  "UPDATE_STATUS_CONFIRMATION_MODAL": {
    "TITLE": "Changer le statut",
    "MESSAGE": "Voulez-vous vraiment mettre à jour le statut du dossier? Cette action est irréversible.",
    "FORCE_ESTIMATE_STATUS_MESSAGE_1": "Attention! À la validation de ce statut, vous ne pourrez pas ajouter de devis dans Boomerang.",
    "FORCE_ESTIMATE_STATUS_MESSAGE_2_1": "Pour ajouter un devis, cliquer sur",
    "FORCE_ESTIMATE_STATUS_MESSAGE_2_2": "Nouvelle action",
    "FORCE_ESTIMATE_STATUS_MESSAGE_2_3": "puis",
    "FORCE_ESTIMATE_STATUS_MESSAGE_2_4": "Intégrer le devis au dossier",
    "SUB_MESSAGE": "La date de mise à jour est enregistrée automatiquement. Si vous souhaitez la modifier, sélectionnez une date.",
    "PASS_MESSAGE": "Ajouter les photos via les pièces jointes",
    "RECEIPT_AT_STORE_TITLE": "Informez votre client que son produit a été retourné",
    "PHONE_NOTIFICATION": {
      "TITLE": "Par téléphone",
      "CALL": "Appel",
      "SMS": "SMS"
    },
    "TAKEOVER_TYPE": {
      "TITLE": "Par email",
      "PICK_UP": "Produit dispo en magasin",
      "SEND_BY_STORE": "Le produit va être livré au client"
    },
    "TRANSPORTER_GO": {
      "TRANSPORTER_TYPE": "Sélectionner un transporteur",
      "TRACKING_NUMBER": "Numéro de suivi",
      "TRANSPORTER_TYPE_NAME": {
        "CHRONOPOST": "Chronopost"
      }
    }
  },
  "REPAIR_FILE_DETAIL_ACTION_DRAWER": {
    "TITLE": "Nouvelle action",
    "SUB_TITLE": {
      "CUSTOMER_SUPPORT": "Prise en charge"
    },
    "LAST_RELAUNCH": "Dernière relance : ",
    "CUSTOMER_ESTIMATE_REVISION": "Reprendre le dossier",
    "REPAIRER_ESTIMATE": "Devis réparateur",
    "ADD_ESTIMATE_TO_FILE": "Intégrer le devis du réparateur au dossier",
    "NOTIFY_THE_REPAIRER": "Reprendre le devis du réparateur",
    "CLOSE_CASE": "Clôture",
    "RETRIEVE_EQUIPMENT_CUSTOMER": "Clôturer le dossier",
    "BUTTON": {
      "CONFIRM_COST": "Confirmer coût/prix (sans info. auprès de votre client)",
      "ADD_RENTAL": "Demande location",
      "REMINDER_REPAIRER": "Relance réparateur (Email)"
    },
    "TOAST": {
      "REMINDER_REPAIRER": "La relance auprès du réparateur a été effectuée avec succès"
    }
  },
  "ESTIMATE_REPAIRER": {
    "TITLE": "Devis réparateur",
    "TITLE_CHOICE": "Choix du client",
    "REPAIRER_NUMBER": "Numéro de devis indiqué par votre réparateur",
    "PLACEHOLDER": {
      "REPAIRER_NUMBER": "N°1234"
    },
    "HINT": {
      "REPAIRER_NUMBER": "Pour la bonne prise en charge de votre dossier, merci d’indiquer uniquement le N° de devis fourni par le réparateur.\nDans le cas de BOSCH, il s’agit impérativement du N° d’Ordre (exemple : 2506230xxx ou 0306000xxx)."
    }
  },
  "ESTIMATE_REPAIRER_OFFER": {
    "SUB_TITLE": "Offre du réparateur",
    "TITLE_FORM": "Veuillez indiquer les coûts du fabricant",
    "TRANSPORT_COST": "Coût réparateur dont transport",
    "LABOR_COST": "Coût réparateur dont transport & main-d'œuvre",
    "MARGIN": "Marge",
    "MODIFICATION_MARGIN": "Modifier marge",
    "MODIFICATION_PRICE": "Modifier prix",
    "SAVE_MARGIN": "Sauvegarder marge",
    "SAVE_PRICE": "Sauvegarder prix",
    "DETAIL_CLIENT": "Détail pour le client",
    "CLIENT_PRICE": "Prix client",
    "CLIENT_PRICE_HT": "Prix client (HT)",
    "REPAIRER_COST_SHORT": "Coût rép.",
    "NEW_OFFER": "Nouvelle offre",
    "OFFER_TYPE": "Type d'offre",
    "REPAIR_COST_HT": "Coût réparation (HT)",
    "TRANSPORT_HT": "Transport (HT)",
    "LABOR_HT": "Main d'œuvre (HT)",
    "INFO_CLIENT": "N'oubliez pas d'inclure une option de non-réparation pour le client",
    "PLACEHOLDER": {
      "OFFER_TYPE": "Sélectionner un type d'offre",
      "COMMENT": "Détail pour client",
      "ESTIMATE_COST": "Ex : 49,90",
      "LABOR_COST": "Ex : 49,90",
      "TRANSPORT_COST": "Ex : 49,90",
      "END_STATUS": "N°1234"
    },
    "BUTTON": {
      "ADD_FORM": "Ajouter une offre du réparateur",
      "VALIDATE_OFFER": "Valider l'offre"
    }
  },
  "ESTIMATE_REPAIRER_DETAIL": {
    "SUB_TITLE": {
      "SUMMARY": "Montant à proposer au client (HT)",
      "INFORM_CLIENT": "Informer le client"
    },
    "CUSTOMER_EMAIL_SAVE": "L'email du client a été sauvegardé",
    "CALL_CLIENT": "J’appelle le client et l’informe des tarifs",
    "SEND_ESTIMATE": "Envoyer un devis avec ces options",
    "BUTTON": {
      "SEND_EMAIL": "Envoyer les options par email",
      "RESPONSE_CLIENT": "Le client me répond tout de suite",
      "CANCEL": "Reprendre le devis plus tard"
    },
    "PLACEHOLDER": {
      "COMMENT": "Commentaire",
      "SEND_ESTIMATE": "Ajouter un commentaire pour l’envoi au client"
    },
    "MODAL": {
      "SEND_CLIENT_EMAIL": "Les options ont bien été envoyées par mail au client"
    }
  },
  "ESTIMATE_REPAIRER_CLIENT_CHOICE": {
    "SUB_TITLE": "Offre du réparateur",
    "SAVE_MARGIN": "Sauvegarder marge",
    "SAVE_PRICE": "Sauvegarder prix",
    "MODIFICATION_MARGIN": "Modifier marge",
    "MODIFICATION_PRICE": "Modifier prix",
    "MARGIN": "Marge",
    "TRANSPORT_COST": "Coût rép. dont transport",
    "LABOR_COST": "Coût réparateur dont transport & main-d'œuvre",
    "SEND_ESTIMATE_AGAIN": "Renvoyer le devis par email",
    "BUTTON": {
      "SEND_EMAIL": "Renvoyer les options du devis par email"
    },
    "PLACEHOLDER": {
      "SEND_ESTIMATE_AGAIN": "Ex : client{'@'}exemple.fr"
    }
  },
  "ESTIMATE_REPAIRER_CLIENT_CHOICE_VALIDATION": {
    "TITLE": "Informer le réparateur et le client",
    "SUB_TITLE": {
      "CONTACT_REPAIRER": "1. Confirmer au réparateur le coût de la réparation",
      "CONTACT_CLIENT": "2. Confirmer au client la validation"
    },
    "LABEL": {
      "REPAIRER_PRICE": "Coût réparation",
      "REPAIRER_PHONE": "Téléphone réparateur",
      "REPAIRER_EMAIL": "Email réparateur",
      "CUSTOMER_PHONE": "Téléphone client",
      "CUSTOMER_EMAIL": "Email client"
    },
    "BUTTON": {
      "SAVE": "Confirmer par mail automatiquement",
      "CANCEL": "Reprendre le devis plus tard"
    },
    "VALIDATION": "Les options ont bien été envoyées par mail au client et au réparateur"
  },
  "NOTIFICATION_PAGE": {
    "TITLE": "Création de la notification",
    "FORM": {
      "TITLE": "Titre",
      "SUBTITLE": "Sous-titre",
      "CONTENT": "Contenu de la notification",
      "REDIRECT": "Voulez-vous ajouter un lien de redirection ?",
      "REDIRECT_MESSAGE": "Titre de la redirection",
      "REDIRECT_URL": "Lien de la redirection",
      "REDIRECT_INFO": "Si la redirection est externe à la plateforme, mettre le lien complet. (exemple: https://www.google.com).\nSi le lien est interne à la plateforme, il ne faut pas mettre le domaine. (exemple: pour une redirection vers le détail dossier https://portail.boomerang-exploration.com/repair-files/B8GQ2BIW1XN mettre uniquement /repair-files/B8GQ2BIW1XN)"
    },
    "MESSAGE": {
      "SUCCESS": "La notification a été créée avec succès"
    },
    "PLACEHOLDER": {
      "TITLE": "Saisir un titre clair",
      "SUBTITLE": "Saisir un sous-titre clair",
      "CONTENT": "Rédiger le contenu à afficher",
      "REDIRECT_MESSAGE": "Saisir un titre clair",
      "REDIRECT_URL": "Ex : https://www.exemple.fr"
    }
  },
  "TEMPORARY_MESSAGE_PAGE": {
    "FORM": {
      "END_DATE": "Date de fin",
      "FOOTER": "Footer",
      "MAIN_CONTENT": "Contenu principal",
      "TITLE": "Titre",
      "START_DATE": "Date de début",
      "SUB_CONTENT": "Contenu secondaire",
      "SUBTITLE": "Sous-titre"
    },
    "TITLE": "Créer un message temporaire",
    "TOAST": {
      "CREATION_SUCCESS": "Le message temporaire a été crée avec succès",
      "UPDATE_SUCCESS": "Le message temporaire a été modifié avec succès"
    },
    "UPDATE_TITLE": "Modifier le message temporaire",
    "PLACEHOLDER": {
      "TITLE": "Saisir un titre clair",
      "MAIN_CONTENT": "Rédiger le contenu à afficher",
      "SUBTITLE": "Saisir un sous-titre clair",
      "SUB_CONTENT": "Rédiger le contenu à afficher",
      "FOOTER": "Rédiger le message de bas de page"
    }
  },
  "EXPRESSIST_TRANSPORTER": {
    "LIST_PAGE": {
      "TABLE": {
        "NAME": "Nom du transporteur"
      },
      "MODAL": {
        "TITLE": "Suppression d’un expressiste",
        "MESSAGE": "Voulez-vous vraiment supprimer {transporter}?",
        "WARNING": "Cette action est irréversible."
      },
      "MESSAGE": {
        "SUCCESS": "L'expressiste a été supprimé avec succès"
      },
      "BUTTON": {
        "NEW_EXPRESSIST": "Ajouter un expressiste"
      }
    },
    "FORM": {
      "TRANSPORTER_TITLE": "Configuration du transporteur",
      "TRANSPORTER_NAME": "Nom du transporteur",
      "TYPE": "Type du transporteur",
      "WEIGHT": "Poids max (kg)",
      "POWER": "Puissance max (wh)",
      "HEIGHT": "Hauteur max (mm)",
      "WIDTH": "Largeur max (mm)",
      "CONNEXION_TITLE": "Connexion Boomerang",
      "CONNEXION_IDENTIFIER": "Identifiant",
      "CONNEXION_PASSWORD": "Mot de passe",
      "CONNEXION_SERVICE": "Service",
      "LOGO": "Logo du transporteur",
      "LOGO_INPUT": "Ajouter un logo",
      "PREVIEW": "Aperçu"
    },
    "CONNEXION_TYPE": {
      "STORE": "Magasin",
      "OPERATING_CENTER": "Centre d'exploitation",
      "BOOMERANG": "Boomerang",
      "TEST": "Test"
    },
    "MESSAGE": {
      "ERROR_TYPE_IS_MANDATORY": "Le type de transporteur est obligatoire pour ajouter la connexion boomerang"
    },
    "BUTTON": {
      "ADD_CONNEXION_FORM": "Ajouter une connexion Boomerang",
      "REMOVE_CONNEXION_FORM": "Ne plus ajouter une connexion Boomerang"
    },
    "CREATE_PAGE": {
      "TITLE": {
        "HEADER": "Ajouter un transporteur expressiste",
        "SUBTITLE": "Formulaire d'ajout d'un transporteur expressiste"
      },
      "BUTTON": {
        "ADD_EXPRESSIST": "Valider l'ajout du transporteur"
      },
      "MESSAGE": {
        "SUCCESS": "L'expressiste a été créé avec succès"
      }
    },
    "UPDATE_PAGE": {
      "TITLE": {
        "HEADER": "Édition d'un transporteur expressiste",
        "SUBTITLE": "Formulaire d'édition d'un transporteur expressiste"
      },
      "MESSAGE": {
        "SUCCESS": "L'expressiste a été mit à jour avec succès"
      },
      "BUTTON": {
        "UPDATE_EXPRESSIST": "Valider l'édition du transporteur"
      }
    },
    "DETAIL_PAGE": {
      "TITLE": {
        "HEADER": "Détail d'un transporteur",
        "SUBTITLE": "Transporteur - {transporter_name}",
        "GENERAL_INFORMATION": "Informations générales"
      },
      "LABEL": {
        "NAME": "Nom",
        "TYPE": "Type du transporteur",
        "WEIGHT": "Poids max (kg)",
        "POWER": "Puissance max (wh)",
        "HEIGHT": "Hauteur max (mm)",
        "WIDTH": "Largeur max (mm)"
      }
    },
    "CONNEXION_LIST_COMPONENT": {
      "BUTTON": {
        "NEW_LINK": "Ajouter une connexion"
      },
      "SUBTITLE": "Liste des connexions du transporteur {transporter_name}",
      "TITLE": {
        "TRANSPORTER_CONNEXION": "Liste des connexions"
      },
      "TABLE": {
        "NAME": "Connexion",
        "SERVICE": "Service(s)",
        "LINK_COUNT": "Nb liaisons"
      },
      "MODAL": {
        "TITLE": "Suppression de la connexion d'un expressiste",
        "MESSAGE": "Voulez-vous vraiment supprimer la connexion {connexion}?",
        "WARNING": "Cette action est irréversible."
      },
      "MESSAGE": {
        "SUCCESS": "La connexion à l'expressiste a été supprimé avec succès"
      }
    },
    "CONNEXION_CREATION_PAGE": {
      "TITLE": {
        "HEADER": "Créer une connexion d'un transporteur expressiste",
        "SUBTITLE": "Formulaire de création d'une connexion d'un transporteur expressiste"
      },
      "BUTTON": {
        "UPDATE_CONNEXION": "Valider la création de la connexion"
      },
      "FORM": {
        "CONNEXION_TITLE": "Connexion",
        "CONNEXION_NAME": "Nom de la connexion",
        "GUARANTEE_SCOPE": "Portée garantie TNT",
        "WITHOUT_GUARANTEE_SCOPE": "Processus hors garantie",
        "LINK_TITLE": "Liaison",
        "REPAIR_CENTER_MANUAL_SCOPE_LABEL": "Configurer manuellement les centres de réparation",
        "REPAIR_CENTER_ALLOWED_LABEL": "Centres de réparation autorisés",
        "LINK_PRIORITY_LABEL": "Utiliser cette liaison en priorité"
      },
      "MESSAGE": {
        "SUCCESS": "La connexion à l'expressiste a été crée avec succès"
      }
    },
    "CONNEXION_EDIT_PAGE": {
      "TITLE": {
        "HEADER": "Éditer une connexion d'un transporteur expressiste",
        "SUBTITLE": "Formulaire d'édition d'une connexion d'un transporteur expressiste"
      },
      "BUTTON": {
        "UPDATE_CONNEXION": "Valider l'édition de la connexion"
      },
      "FORM": {
        "CONNEXION_TITLE": "Connexion",
        "CONNEXION_NAME": "Nom de la connexion",
        "GUARANTEE_SCOPE": "Portée garantie TNT",
        "WITHOUT_GUARANTEE_SCOPE": "Processus hors garantie",
        "LINK_TITLE": "Liaison",
        "REPAIR_CENTER_MANUAL_SCOPE_LABEL": "Configurer manuellement les centres de réparation",
        "REPAIR_CENTER_ALLOWED_LABEL": "Centres de réparation autorisés",
        "LINK_PRIORITY_LABEL": "Utiliser cette liaison en priorité"
      },
      "MESSAGE": {
        "SUCCESS": "La connexion à l'expressiste a été modifié avec succès"
      }
    },
    "CONNEXION_DETAIL_PAGE": {
      "TITLE": {
        "HEADER": "Détail d'une connexion",
        "SUBTITLE": "Transporteur - {transporter_name} / Connexion - {connexion_name}",
        "TRANSPORTER_GENERAL_INFORMATION": "Informations Transporteur",
        "CONNEXION_GENERAL_INFORMATION": "Informations Connexion",
        "LINK_GENERAL_INFORMATION": "Informations Liaison"
      },
      "LABEL": {
        "NAME": "Connexion",
        "IDENTIFIER": "Identifiant",
        "PASSWORD": "Mot de passe",
        "SERVICE": "Service(s)",
        "REPAIR_CENTER_SCOPE_MODE": "Mode centres de réparation",
        "REPAIR_CENTER_SCOPE_MODE_AUTO": "Automatique",
        "REPAIR_CENTER_SCOPE_MODE_MANUAL": "Manuel",
        "GUARANTEE_SCOPE": "Portée garantie TNT",
        "WITHOUT_GUARANTEE_SCOPE": "Processus hors garantie"
      }
    },
    "LINK_LIST_COMPONENT": {
      "TITLE": {
        "LINK": "Liaison(s) connexion - magasin"
      },
      "SUBTITLE": "Liste des liaisons de la connexion {connexion_name}",
      "BUTTON": {
        "NEW_LINK": "Ajouter une liaison"
      },
      "TABLE": {
        "STORE_NAME": "Nom du magasin"
      },
      "MESSAGE": {
        "DELETE_SUCCESS": "La liaison connexion / magasin a été supprimé avec succès"
      },
      "MODAL": {
        "TITLE": "Suppression d’une liaison connexion / magasin",
        "MESSAGE": "Voulez-vous vraiment supprimer la liaison avec {link_store_name}?",
        "WARNING": "Cette action est irréversible."
      }
    },
    "GUARANTEE_SCOPE": {
      "ALL": "Tous",
      "GUARANTEE_ONLY": "Garantie uniquement",
      "WITHOUT_GUARANTEE_ONLY": "Hors garantie uniquement"
    },
    "WITHOUT_GUARANTEE_SCOPE": {
      "ALL": "Tous",
      "PACKAGE_CONDITION": "Condition du Forfait"
    },
    "LINK_CREATE_PAGE": {
      "TITLE": {
        "HEADER": "Ajouter une liaison à une connexion d'un transporteur expressiste",
        "SUBTITLE": "Formulaire d'ajout de liaison à une connexion"
      },
      "FORM": {
        "LABEL_NAME": "Nom de la liaison",
        "LABEL_NETWORK": "Réseau",
        "LABEL_STORE": "Magasin",
        "LABEL_KEY_ACCOUNT_NETWORK": "Réseau",
        "LABEL_OPERATING_CENTER": "Centre d'exploitation"
      },
      "PLACEHOLDER": {
        "STORE": "Sélectionnez le magasin",
        "NETWORK": "Sélectionnez le réseau",
        "KEY_ACCOUNT_NETWORK": "Sélectionnez le réseau grand compte",
        "OPERATING_CENTER": "Sélectionnez le centre d'exploitation"
      },
      "BUTTON": {
        "ADD_LINK": "Valider l'ajout de la liaison"
      }
    },
    "LINK_DETAIL_PAGE": {
      "LABEL": {
        "NETWORK": "Réseau",
        "KEY_ACCOUNT_NETWORK": "Réseau grand compte",
        "STORE": "Magasin",
        "OPERATING_CENTER": "Centre d'exploitation",
        "PRIORITY": "Utilisation de cette liaison en priorité"
      }
    },
    "PLACEHOLDER": {
      "TRANSPORTER_NAME": "Ex : Nom du transporteur",
      "TYPE": "Sélectionner un type de transporteur",
      "WEIGHT": "Ex : 30",
      "POWER": "Ex : 500",
      "HEIGHT": "Ex : 400",
      "WIDTH": "Ex : 300",
      "CONNEXION_SERVICE": "Sélectionner un service de connexion",
      "CONNEXION_IDENTIFIER": "Ex : ID.TRANSPORT",
      "CONNEXION_PASSWORD": "Saisir le mot de passe de connexion",
      "CONNEXION_NAME": "Ex : Nom de la connexion",
      "GUARANTEE_SCOPE": "Sélectionner une portée de garantie TNT",
      "WITHOUT_GUARANTEE_SCOPE": "Sélectionner un processus hors garantie",
      "REPAIR_CENTER_ALLOWED": "Sélectionner un ou plusieurs centres de réparation autorisés"
    }
  },
  "STORE_TRANSPORTER_LINK": {
    "TABLE": {
      "LABEL_TRANSPORTER_NAME": "Nom du Transporteur",
      "LABEL_CONNEXION_SERVICE": "Service de la Connexion",
      "LABEL_CONNEXION_TYPE": "Type de connexion",
      "LABEL_LINK_PRIORITY": "Prioritaire"
    },
    "LABEL_STORE": "Magasin",
    "PLACEHOLDER": {
      "CONNEXION_TYPE": "Sélectionner un type de connexion"
    }
  },
  "GUARANTEE_EXTENSION_BOOMERANG_MODAL": {
    "TITLE": "Extension de garantie de réparation",
    "BODY_1": "Le produit de votre client est sous garantie jusqu'au",
    "BODY_2": "Cette date est visible sur le certificat d'extension de garantie rattaché au dossier que vous pouvez imprimer ci-dessous.",
    "SEND_BY_EMAIL_MESSAGE": "Partager le certificat par email",
    "PROOF_TITLE": "Certificat d'extension de garantie",
    "SUCCESS_SENT": "Le certificat a bien été envoyé à l'adresse email"
  },
  "RENTAL_MODULE_PAGE": {
    "TITLE": "Location",
    "SUBTITLE": {
      "HEADER_PRODUCT_LIST": "Liste des produits de location"
    },
    "TAB": {
      "PRODUCT_LIST_TAB_TITLE": "Liste des Produits",
      "IMPORT_EXPORT_TAB_TITLE": "Import / Export"
    }
  },
  "RENTAL_MODULE_LIST_PRODUCTS_PAGE": {
    "TITLE": "Bienvenue sur BOOMERANG Location",
    "SELECT_ALL": "Tout",
    "BRAND": "Marque",
    "CATEGORY_GROUP": "Catégories",
    "AVAILABILITY_STATUS_GROUP": "Disponibilité",
    "AVAILABILITY_STATUS": {
      "AVAILABLE": "Disponible",
      "IN_COMING": "À venir",
      "UNAVAILABLE": "Indisponible"
    },
    "SELECT": {
      "MANUFACTURER": "Quelle est la marque du produit ?",
      "PLACEHOLDER": "Sélectionner votre marque"
    },
    "AVAILABILITY_ERROR": "Vous ne pouvez pas sélectionner un produit non disponible"
  },
  "RENTAL_MODULE_PRODUCT_DETAIL_PAGE": {
    "DEPOSIT": "Caution",
    "CONSUMABLE_TEXT": "Pensez à proposer ces consommables",
    "SUMMARY_TEXT": "Demander un contrat de location",
    "HT_PRICE": "Sous-total",
    "DELIVERY_TOTAL": "Livraison à partir de:",
    "FREE_DELIVERY": "GRATUIT",
    "HT_TOTAL": "Total HT",
    "CREATE_RENT_BUTTON": "Créer un contrat de location"
  },
  "RENTAL_MODULE_CREATE_FILE_PAGE": {
    "NEXT_STEP_CARD": {
      "TITLE": "Prochaines étapes pour valider la demande de location",
      "P1": "1. Renseigner l’ensemble des informations sur le formulaire de droite et envoyer la demande de location",
      "P2": "2. Sous 1h le client reçoit son contrat par email via WeSign et la demande de caution par email et téléphone via Swikly (si caution par gérée par le magasin)",
      "P3": "3. Envoi de la machine par transporteur à l’adresse et date de livraison souhaitée*, une fois le contrat signé et la caution validée",
      "P3_DOT": "*les demandes gérées avant 11h sont livrés à J+1 et les demandes gérées après 11h sont livrés à J+2",
      "P4": "4. Réception et utilisation de la machine le temps de la réparation",
      "P5": "5. Une fois le produit réparé, le client est informé par le magasin. Le client a 48h pour retourner la machine en magasin",
      "SP2": "Surcoût contractuel",
      "SP2_1": "passé 48h 29 € seront facturés par jour supplémentaire",
      "SP2_2": "si la machine n’est pas retournée dans l’état initial un forfait de nettoyage de 29€ pourrait être appliqué",
      "P6": "6. Envoi de la machine par le magasin à Boomerang",
      "P7": "7. Vérification de la machine et déblocage de la caution par Boomerang"
    },
    "FORM": {
      "TITLE": "Formulaire contrat de location",
      "COMPANY_NAME_LABEL": "Nom d'entreprise",
      "CLIENT_FULLNAME_LABEL": "Nom du signataire du contrat",
      "CLIENT_EMAIL_LABEL": "E-mail du signataire du contrat",
      "CLIENT_PHONE_NUMBER_LABEL": "Téléphone du signataire",
      "COMPANY_ADDRESS_NAME_LABEL": "Nom de l'adresse de l'entreprise",
      "COMPANY_ADDRESS_NUMBER_LABEL": "Numéro de l'adresse de l'entreprise",
      "COMPANY_ADDRESS_STREET_LABEL": "Rue de l'adresse de l'entreprise",
      "COMPANY_ADDRESS_ZIP_CODE_LABEL": "Code postal de l'adresse de l'entreprise",
      "COMPANY_ADDRESS_CITY_LABEL": "Ville de l'adresse de l'entreprise",
      "COMPANY_ADDRESS_COUNTRY_LABEL": "Pays de l'adresse de l'entreprise",
      "BILLING_ADDRESS_STATUS_LABEL": "Adresse de livraison similaire à l’adresse de facturation",
      "BILLING_ADDRESS_NAME_LABEL": "Nom de l'adresse de facturation",
      "BILLING_ADDRESS_NUMBER_LABEL": "Numéro de l'adresse de facturation",
      "BILLING_ADDRESS_STREET_LABEL": "Rue de l'adresse de facturation",
      "BILLING_ADDRESS_ZIP_CODE_LABEL": "Code postal de l'adresse de facturation",
      "BILLING_ADDRESS_CITY_LABEL": "Ville de l'adresse de facturation",
      "BILLING_ADDRESS_COUNTRY_LABEL": "Pays de l'adresse de facturation",
      "DESIRED_DELIVERY_DATE_LABEL": "Date de livraison souhaitée: ",
      "DEPOSIT_LABEL": "Comment s'organise le dépôt de caution: ",
      "DEPOSIT_VALUE_1_LABEL": "Caution gérée par le distributeur sur le compte du client",
      "DEPOSIT_VALUE_2_LABEL": "Caution en ligne via Boomerang et son partenaire Swikly (max 4.50€ de dossier)",
      "COMMENT_LABEL": "Commentaire",
      "COMMENT_PLACEHOLDER": "Commentaire spécifiques (Ex: Le client ne sera pas présent à l'atelier)",
      "CONTRACT_LABEL": "Consulter les conditions générales de location courte durée",
      "CARD_LABEL": "Conditions générales de location",
      "VALIDATION": "Envoyer la demande de location"
    },
    "PLACEHOLDER": {
      "COMPANY_NAME": "Ex : Entreprise Dupont",
      "CLIENT_FULLNAME": "Ex : Marie Dupont",
      "CLIENT_EMAIL": "Ex : contact{'@'}exemple.fr",
      "CLIENT_PHONE_NUMBER": "Ex : 01 23 45 67 89",
      "COMPANY_ADDRESS_NAME": "Ex : Siège social",
      "COMPANY_ADDRESS_NUMBER": "Ex : 12",
      "COMPANY_ADDRESS_STREET": "Ex : Rue de la Paix",
      "COMPANY_ADDRESS_ZIP_CODE": "Ex : 75001",
      "COMPANY_ADDRESS_CITY": "Ex : Paris",
      "COMPANY_ADDRESS_COUNTRY": "Ex : France",
      "BILLING_ADDRESS_NAME": "Ex : Siège social",
      "BILLING_ADDRESS_NUMBER": "Ex : 12",
      "BILLING_ADDRESS_STREET": "Ex : Rue de la Paix",
      "BILLING_ADDRESS_ZIP_CODE": "Ex : 75001",
      "BILLING_ADDRESS_CITY": "Ex : Paris",
      "BILLING_ADDRESS_COUNTRY": "Ex : France"
    }
  },
  "RENTAL_FILE_DETAIL": {
    "BOOMERANG_ID": "N° ",
    "STORE": "Magasin : ",
    "CLIENT_COMPANY_NAME": "Entreprise : ",
    "CLIENT_NAME": "Client : ",
    "NOT_FOUND": "Le dossier de location n'a pas pu être trouvé",
    "STATUS_UNKNOWN": "Statut du dossier de location inconnu",
    "KPI": {
      "ADDITIONAL_DAYS": "Jours additionnels"
    },
    "STATUS": {
      "CREATED": "Création du dossier",
      "CONTRACT_SENT": "Envoi contrat",
      "PACKET_PREPARATION": "Préparation Colis",
      "TRANSPORT_GO": "Transport aller",
      "CLIENT_RECEIPT": "Réception client",
      "CLIENT_INFORMED": "Client informé dispo",
      "STORE_RECEIPT": "Réception location en magasin",
      "TRANSPORT_BACK": "Transport Retour",
      "BOOMERANG_RECEIPT": "Réception Boomerang",
      "BILLING": "Facturation hors cadre",
      "CLOSED": "Clôture"
    }
  },
  "COMMENTARY_RENTAL_FILE": {
    "TITLE": "Commentaires",
    "INFO_ALERT": "L'équipe Boomerang n'est pas alertée de vos commentaires. Afin de nous contacter, appuyer sur le Chat (bulle verte en bas à droite).",
    "BUTTON": {
      "SEND": "Envoyer"
    },
    "PLACEHOLDER": {
      "COMMENTARY": "Ajouter un commentaire"
    }
  },
  "DAY_SUPP_COUNT_DATE_RENTAL_FILE": {
    "TITLE_1": "Nombre de jours additionnels",
    "TITLE_2": "(À partir de J+2 du retour SAV)",
    "SUBTITLE": "À partir de J+2 du retour SAV",
    "DAY": "Jour",
    "DAYS": "Jours"
  },
  "RENTAL_FILE_ATTACHMENT": {
    "TITLE": "Pièces jointes",
    "CARD": {
      "CGV": "CGV",
      "ADD_ATTACHMENT": "Ajouter une pièce jointe"
    },
    "BUTTON": {
      "ADD": "Ajouter",
      "SELECT_ALL": "Tout sélectionner",
      "UNSELECT_ALL": "Tout désélectionner",
      "DOWNLOAD": "Télécharger"
    },
    "SELECTED_COUNT": "{count} sélectionné(s)",
    "MODAL": {
      "ACCEPTED_FORMATS": "Formats acceptés : PDF, JPG, PNG, JPEG",
      "FILE_NAME": "Nom du fichier",
      "FILE": "Ajouter votre pièce jointe"
    },
    "PERMISSION": {
      "VIEW_ATTACHMENT_DENIED": "Vous n'avez pas les droits pour voir les pièces jointes",
      "PRINT_ATTACHMENT_DENIED": "Vous n'avez pas les droits pour télécharger cette pièce jointe"
    }
  },
  "RENTAL_FILE_GLOBAL_INFO": {
    "STATUS_DISPLAY": {
      "CREATED": "1. Création du dossier",
      "CONTRACT_SENT": "2. Envoi contrat",
      "PACKET_PREPARATION": "3. Préparation Colis",
      "TRANSPORT_GO": "4. Transport aller",
      "CLIENT_RECEIPT": "5. Réception client",
      "CLIENT_INFORMED": "6. Client informé dispo",
      "STORE_RECEIPT": "7. Réception location en magasin",
      "TRANSPORT_BACK": "8. Transport Retour",
      "BOOMERANG_RECEIPT": "9. Réception Boomerang",
      "BILLING": "10. Facturation hors cadre",
      "CLOSED": "11. Clôture"
    },
    "HEADER": {
      "TITLE": "Récapitulatif demande de location",
      "DAYS": " jours",
      "DAY": " jour"
    },
    "RENTAL_FILE_INFO": {
      "TITLE": {
        "PRODUCT": "Produit",
        "SUMMARY": "Résumé",
        "PRICING": "Tarification détaillée"
      },
      "PRODUCT": "Produit",
      "SERIAL_NUMBER": "Série",
      "DESCRIPTION": "Description",
      "CONTACT": "Contact",
      "LASTNAME": "Nom du signataire",
      "EMAIL": "Email",
      "PHONE_NUMBER": "Téléphone",
      "CLIENT_RENTAL_COST": "Prix client location",
      "CLIENT_RENTAL_COST_PACKAGE_NAME": "Forfait client location",
      "CLIENT_ADDITIONAL_DAY_COST": "Prix client / jour additionnel",
      "CLIENT_ADDITIONAL_DAY_PACKAGE_NAME": "Forfait client / jour additionnel",
      "DEPOSIT": "Caution",
      "DEPOSIT_TYPE": "Dépôt de caution"
    },
    "DEPOSIT_TYPE": {
      "STORE": "Magasin",
      "SWIKLY": "Swikly"
    }
  },
  "RENTAL_PRODUCT_MANAGEMENT_LIST": {
    "DELETE_FILTER": "Effacer les filtres",
    "PLACEHOLDER": {
      "MANUFACTURER": "Sélectionnez la/les marque(s)",
      "CATEGORY": "Sélectionnez la/les gamme(s)",
      "AVAILABILITY_STATUS": "Sélectionner un ou plusieurs statuts"
    },
    "TABLE": {
      "PICTURE": "Photo",
      "NAME": "Nom",
      "CATEGORY_NAME": "Gamme",
      "BOOMERANG_ID": "N° Boomerang",
      "PACKAGE_CLIENT_COST": "Prix",
      "AVAILABILITY_STATUS": "Inventaire"
    },
    "AVAILABILITY_STATUS": {
      "AVAILABLE": "Disponible",
      "IN_COMING": "À venir",
      "UNAVAILABLE": "Indisponible",
      "HIDDEN": "Invisible"
    },
    "UPDATE_SUCCESS": "Statut mis à jour avec succès"
  },
  "TRANSPORTER_RENTAL_FILE": {
    "TITLE": "Transport",
    "GO_TO": "Aller",
    "TRANSPORTER_GO": "Transport aller",
    "ADDRESS_NAME": "Nom adresse",
    "ADDRESS": "Adresse",
    "ADDRESS_COMPLEMENT_1": "Complément 1",
    "ADDRESS_COMPLEMENT_2": "Complément 2",
    "CITY": "Ville",
    "COUNTRY": "Pays",
    "DESIRED_RECEPTION_DATE": "Date de livraison souhaitée",
    "TRACKING_NUMBER": "Numéro de suivi",
    "TRANSPORTER_TYPE": "Transporteur",
    "TRANSPORT_SEND_DATE": "Date d'envoi"
  },
  "RENTAL_UPDATE_STATUS_STORE_RECEIPT_MODAL": {
    "TITLE": "Changer le statut",
    "MESSAGE_1": "Pour mettre à jour le dossier vous devez ajouter une photo du produit.",
    "MESSAGE_2": "Pour ajouter une photo, scannez le QRCode et ajouter une photo du produit au dossier.",
    "ERROR": {
      "INVALID_RENTAL_FILE_QR_CODE_TOKEN_NOT_USED_ERROR_KEY": "Aucune photo du produit n'a été ajoutée au dossier. Merci d'ajouter au moins une photo pour passer à l'étape suivante."
    }
  },
  "RENTAL_FILE_ADD_PICTURE": {
    "ACCEPTED_FORMATS": "Formats acceptés : JPG, JPEG, PNG",
    "ADD_PHOTO": "Ajouter une photo",
    "DROPZONE_TITLE": "Déposez vos photos",
    "HINT": "Ajoutez une ou plusieurs photos nettes du produit.",
    "TITLE": "Ajout des photos du Produit",
    "MESSAGE": "Veuillez ajouter une ou plusieurs photos du produit",
    "REMOVE_FILE": "Supprimer la photo",
    "SELECT_TITLE": "Sélectionner vos photos :",
    "TAKE_PHOTO": "Prendre une photo",
    "TITLE_SENT": "Merci, vos photos sont bien ajoutées au dossier",
    "MESSAGE_SENT": "Vous pouvez à présent poursuivre sur la plateforme",
    "TITLE_ERROR_TOKEN_VALIDITY": "L'accès à cette page est périmé ou invalide.",
    "MESSAGE_ERROR_TOKEN_VALIDITY": "Vous pouvez demander un nouvel accès depuis la plateforme BOOMERANG"
  },
  "RENTAL_WARNING_MODAL": {
    "TITLE": "N'oubliez pas de récupérer le produit en location",
    "MESSAGE": "Attention! Un dossier de location est lié au dossier de réparation. Avant de clôturer le dossier pensez à récupérer la machine en location et clôturer le dossier."
  },
  "ITECH_PAGE": {
    "TITLE": "Itech action manuelle",
    "SUBTITLE": "Récupération et extraction des données Itech",
    "RETRIEVE_FILE_TITLE": "Forcer la récupération des fichiers Itech",
    "RETRIEVE_FILE_SUBTITLE": "Rapatrier les fichiers entrants depuis le dépôt",
    "RETRIEVE_FILE_DESCRIPTION": "Lance une récupération immédiate des fichiers Itech vers l'espace interne.",
    "RETRIEVE_FILE_LAST_EXECUTION": "Dernière récupération",
    "RETRIEVE_FILE_BUTTON": "Forcer la récupération",
    "RETRIEVE_FILE_SUCCESS": "Récupération des fichiers effectués avec succès",
    "PARSE_FILE_TITLE": "Forcer l'extraction des données des fichiers Itech",
    "PARSE_FILE_SUBTITLE": "Traiter les fichiers en attente pour synchroniser les clients",
    "PARSE_FILE_DESCRIPTION": "Lance l'extraction des fichiers récupérés et met à jour la base clients Itech.",
    "PARSE_FILE_LAST_EXECUTION": "Dernière extraction",
    "PARSE_FILE_BUTTON": "Forcer l'extraction",
    "PARSE_FILE_SUCCESS": "Extraction des fichiers effectués avec succès",
    "STATS": {
      "RETRIEVED_TODAY": "Fichiers récupérés aujourd'hui",
      "RETRIEVED_YESTERDAY": "Fichiers récupérés hier",
      "PARSED_TODAY": "Fichiers extraits aujourd'hui",
      "PARSED_YESTERDAY": "Fichiers extraits hier"
    }
  },
  "COMMENT_REMOVE_MODAL": {
    "TITLE": "Confirmer la suppression du commentaire",
    "MESSAGE": "La suppression du commentaire est irréversible, vous ne pourrez pas revenir en arrière",
    "SUCCESS_MESSAGE": "Commentaire supprimé avec succès"
  },
  "ATTACHMENT_REMOVE_MODAL": {
    "TITLE": "Confirmer la suppression de la pièce jointe",
    "MESSAGE": "La suppression de la pièce jointe est irréversible, vous ne pourrez pas revenir en arrière",
    "SUCCESS_MESSAGE": "Pièce jointe supprimée avec succès"
  },
  "RECYCLING_MODULE_PAGE": {
    "TITLE": "Recycleurs",
    "SUBTITLE": {
      "HEADER_RECYCLER_LIST": "Liste des recycleurs",
      "HEADER_RECONDITIONER_LIST": "Liste des reconditionneurs",
      "HEADER_BAC_LIST": "Suivi des bacs de recyclage"
    },
    "TAB": {
      "RECYCLER_LIST_TAB_TITLE": "Recycleurs",
      "RECONDITIONER_LIST_TAB_TITLE": "Reconditionneurs",
      "IMPORT_EXPORT_TAB_TITLE": "Import / Export",
      "BAC_LIST_TAB_TITLE": "Bacs"
    },
    "BUTTON": {
      "NEW_RECYCLER": "Nouveau recycleur",
      "NEW_RECONDITIONER": "Nouveau reconditionneur",
      "RECYCLING_FOLDER_REPORT": "Télécharger les dossiers"
    }
  },
  "RECYCLER_PAGE": {
    "TABLE": {
      "ID": "ID",
      "NAME": "Nom",
      "RECYCLER_CENTER_COUNT": "Nombre de centres"
    },
    "MODAL": {
      "TITLE": "Suppression d’un recycleur",
      "MESSAGE": "Attention, la suppression d'un recycleur entraînera la suppression de tous ses centres de recyclage ainsi que l'ensemble des liaisons les concernant avec les magasins et/ou BAC. Voulez-vous vraiment supprimer {recycler}?",
      "WARNING": "Cette action est irréversible."
    },
    "MESSAGE": {
      "SUCCESS_DELETED": "Le recycleur a été supprimé avec succès"
    }
  },
  "CREATE_RECYCLER_PAGE": {
    "TITLE": {
      "HEADER": "Ajouter un recycleur",
      "SUBTITLE": "Formulaire d'ajout d'un recycleur"
    },
    "FORM": {
      "RECYCLER_INFO": "Informations du recycleur",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'ajout d'un recycleur"
    },
    "MESSAGE": {
      "SUCCESS": "Le recycleur a été ajouté avec succès",
      "ERROR": "Impossible d'ajouter le recycleur"
    },
    "PLACEHOLDER": {
      "ID": "Ex : B123456",
      "NAME": "Ex : Paprec"
    }
  },
  "DETAIL_RECYCLER_PAGE": {
    "SUBTITLE": {
      "HEADER_RECYCLER_CENTER_LIST": "Liste des centres de recyclage rattachés à {recyclerName}"
    },
    "TITLE": {
      "HEADER": "Détail d'un recycleur",
      "SUB_HEADER": "Recycleur",
      "RECYCLER_CENTER_LIST": "Centres de recyclage"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "ID": "ID",
      "NAME": "Nom"
    },
    "TABLE": {
      "BOOMERANG_ID": "ID",
      "NAME": "Nom",
      "CITY": "Ville",
      "EMAIL_CONTACT": "Email contact"
    },
    "MODAL": {
      "TITLE": "Suppression d’un centre de recyclage",
      "MESSAGE": "Attention la suppression d'un centre de recyclage entrainera également la suppression de ses liaisons avec un magasin. Voulez-vous vraiment supprimer {recyclerCenter}?",
      "WARNING": "Cette action est irréversible."
    },
    "BUTTON": {
      "NEW_REPAIR_CENTER": "Ajouter un centre de recyclage"
    },
    "MESSAGE": {
      "SUCCESS_DELETED": "Le centre de recyclage a été supprimé avec succès"
    }
  },
  "EDIT_RECYCLER_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'un recycleur",
      "SUBTITLE": "Formulaire d'édition d'un recycleur"
    },
    "FORM": {
      "RECYCLER_INFO": "Informations du recycleur",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'édition du recycleur"
    },
    "MESSAGE": {
      "SUCCESS": "Le recycleur a été modifié avec succès",
      "ERROR": "Impossible de modifier le recycleur"
    },
    "PLACEHOLDER": {
      "NAME": "Ex : Paprec"
    }
  },
  "CREATE_RECYCLER_CENTER_PAGE": {
    "TITLE": {
      "HEADER": "Ajouter un centre de recyclage",
      "SUBTITLE": "Formulaire d'ajout d'un centre de recyclage"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "CONTACT": "Contact",
      "BAC_DETAIL": "Détail BAC"
    },
    "FORM": {
      "LABEL_RECYCLER": "Recycleur",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom",
      "LABEL_ADDRESS_NUMBER": "Numéro d'adresse postale",
      "LABEL_ADDRESS_STREET": "Rue",
      "LABEL_ADDRESS_COMPLEMENT": "Complément d'adresse",
      "LABEL_ADDRESS_ZIP_CODE": "Code postal",
      "LABEL_ADDRESS_CITY": "Ville",
      "LABEL_ADDRESS_COUNTRY": "Pays",
      "LABEL_CONTACT_EMAIL": "Email de contact",
      "LABEL_COLLECT_EMAIL": "Email enlèvement",
      "LABEL_PHONE_NUMBER": "Téléphone",
      "LABEL_BAC_COMMENT": "Commentaire",
      "LABEL_BAC_SELECT": "Sélection du bac"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'ajout d'un centre de recyclage"
    },
    "MESSAGE": {
      "SUCCESS": "Le centre de recyclage a été ajouté avec succès",
      "ERROR": "Impossible d'ajouter le centre de recyclage"
    },
    "PLACEHOLDER": {
      "ID": "Ex : B123456",
      "NAME": "Ex : Paprec",
      "ADDRESS_CITY": "Ex : Paris",
      "ADDRESS_NUMBER": "Ex : 12",
      "ADDRESS_STREET": "Ex : Rue de la Paix",
      "ADDRESS_COMPLEMENT": "Ex : 12 rue de la Paix",
      "ADDRESS_ZIP_CODE": "Ex : 75001",
      "ADDRESS_COUNTRY": "Ex : France",
      "CONTACT_EMAIL": "Ex : contact{'@'}exemple.fr",
      "COLLECT_EMAIL": "Ex : contact{'@'}exemple.fr",
      "PHONE_NUMBER": "Ex : 01 23 45 67 89",
      "BAC_SELECT": "Sélectionner un bac",
      "BAC_COMMENT": "Ajouter un commentaire utile"
    }
  },
  "EDIT_RECYCLER_CENTER_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'un centre de recyclage",
      "SUBTITLE": "Formulaire d'édition d'un centre de recyclage"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "CONTACT": "Contact",
      "BAC_DETAIL": "Détail BAC"
    },
    "FORM": {
      "LABEL_RECYCLER": "Recycleur",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom",
      "LABEL_ADDRESS_NUMBER": "Numéro d'adresse postale",
      "LABEL_ADDRESS_STREET": "Rue",
      "LABEL_ADDRESS_COMPLEMENT": "Complément d'adresse",
      "LABEL_ADDRESS_ZIP_CODE": "Code postal",
      "LABEL_ADDRESS_CITY": "Ville",
      "LABEL_ADDRESS_COUNTRY": "Pays",
      "LABEL_CONTACT_EMAIL": "Email de contact",
      "LABEL_COLLECT_EMAIL": "Email enlèvement",
      "LABEL_PHONE_NUMBER": "Téléphone",
      "LABEL_BAC_COMMENT": "Commentaire",
      "LABEL_BAC_SELECT": "Sélection du bac"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'édition du centre de recyclage"
    },
    "MESSAGE": {
      "SUCCESS": "Le centre de recyclage a été modifié avec succès",
      "ERROR": "Impossible de modifier le centre de recyclage"
    },
    "PLACEHOLDER": {
      "NAME": "Ex : Paprec",
      "ADDRESS_NUMBER": "Ex : 12",
      "ADDRESS_STREET": "Ex : Rue de la Paix",
      "ADDRESS_CITY": "Ex : Paris",
      "BAC_SELECT": "Sélectionner un bac",
      "ADDRESS_COMPLEMENT": "Ex : 12 rue de la Paix",
      "ADDRESS_ZIP_CODE": "Ex : 75001",
      "ADDRESS_COUNTRY": "Ex : France",
      "CONTACT_EMAIL": "Ex : contact{'@'}exemple.fr",
      "COLLECT_EMAIL": "Ex : contact{'@'}exemple.fr",
      "PHONE_NUMBER": "Ex : 01 23 45 67 89",
      "BAC_COMMENT": "Ajouter un commentaire utile"
    }
  },
  "DETAIL_RECYCLER_CENTER_PAGE": {
    "SUBTITLE": {
      "HEADER_RECYCLER_CENTER_LINK": "Liste des liaisons centre de recyclage/magasin rattachées à {recyclerCenterName}"
    },
    "TITLE": {
      "HEADER": "Détail d'un centre de recyclage",
      "SUB_HEADER": "Centre de recyclage",
      "RECYCLER_CENTER_LINK": "Liaison centre de recyclage/magasin"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "ID": "ID",
      "NAME": "Nom",
      "RECYCLER": "Recycleur",
      "ADDRESS": "Adresse",
      "CONTACT": "Contact",
      "CONTACT_EMAIL": "Email de contact",
      "COLLECT_EMAIL": "Email d'enlèvement",
      "PHONE_NUMBER": "Téléphone",
      "BAC": "Détail du BAC",
      "BAC_ID": "ID",
      "BAC_NAME": "Nom",
      "BAC_THRESHOLD": "Seuil de remplissage",
      "BAC_COMMENT": "Commentaire"
    },
    "BUTTON": {
      "NEW_LINK_TO_STORE": "Ajouter une liaison"
    },
    "TABLE": {
      "BOOMERANG_ID": "ID",
      "NAME": "Nom",
      "STORE_COUNT": "Nombre de magasin"
    },
    "MODAL": {
      "TITLE": "Supprimer la liaison",
      "MESSAGE": "Voulez-vous vraiment supprimer la liaison {recyclerCenterLink}?",
      "WARNING": "Cette action est irréversible."
    },
    "MESSAGE": {
      "SUCCESS_DELETED": "La liaison a été supprimée avec succès"
    }
  },
  "CREATE_RECYCLER_CENTER_LINK_PAGE": {
    "TITLE": {
      "HEADER": "Liaison centre de recyclage/magasins",
      "SUB_HEADER": "Centre de recyclage",
      "STORE_LINKED": "Magasins liés"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "ID": "ID",
      "NAME": "Nom",
      "RECYCLER": "Recycleur",
      "ADDRESS": "Adresse",
      "CONTACT": "Contact",
      "CONTACT_EMAIL": "Email de contact",
      "COLLECT_EMAIL": "Email d'enlèvement",
      "PHONE_NUMBER": "Téléphone",
      "LINK_RECYCLER_CENTER_STORE": "Liaison centre de recyclage/magasins",
      "BAC": "Détail du BAC",
      "BAC_ID": "ID",
      "BAC_NAME": "Nom",
      "BAC_THRESHOLD": "Seuil de remplissage",
      "BAC_COMMENT": "Commentaire"
    },
    "FORM": {
      "LABEL_NETWORK": "Réseau",
      "LABEL_STORE": "Magasin",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom",
      "OTHERS": "autres",
      "OTHER": "autre",
      "LABEL_REGION_CODE": "Zone"
    },
    "PLACEHOLDER": {
      "NETWORK": "Sélectionner le réseau",
      "REGION_CODE": "Sélectionner un code région",
      "STORE": "Sélectionner le magasin",
      "ID": "Ex : B123456",
      "NAME": "Ex : Paprec"
    },
    "BUTTON": {
      "VALIDATE": "Valider la liaison"
    },
    "MESSAGE": {
      "SUCCESS": "Liaison ajoutée avec succès."
    }
  },
  "EDIT_RECYCLER_CENTER_LINK_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'une liaison centre de recyclage/magasin",
      "SUB_HEADER": "Formulaire d'une liaison centre de recyclage/magasin"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "ID": "ID",
      "NAME": "Nom",
      "RECYCLER": "Recycleur",
      "ADDRESS": "Adresse",
      "CONTACT": "Contact",
      "CONTACT_EMAIL": "Email de contact",
      "COLLECT_EMAIL": "Email d'enlèvement",
      "PHONE_NUMBER": "Téléphone",
      "LINK_RECYCLER_CENTER_STORE": "Liaison centre de recyclage/magasins",
      "BAC": "Détail du BAC",
      "BAC_ID": "ID",
      "BAC_NAME": "Nom",
      "BAC_THRESHOLD": "Seuil de remplissage",
      "BAC_COMMENT": "Commentaire"
    },
    "FORM": {
      "LABEL_NETWORK": "Réseau",
      "LABEL_STORE": "Magasin",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom",
      "OTHERS": "autres",
      "OTHER": "autre",
      "LABEL_REGION_CODE": "Zone"
    },
    "PLACEHOLDER": {
      "NETWORK": "Sélectionner le réseau",
      "REGION_CODE": "Sélectionner un code région",
      "STORE": "Sélectionner le magasin",
      "NAME": "Ex : Paprec"
    },
    "BUTTON": {
      "VALIDATE": "Modifier la liaison"
    },
    "MESSAGE": {
      "SUCCESS": "Liaison modifiée avec succès."
    }
  },
  "DETAIL_RECYCLER_CENTER_LINK_PAGE": {
    "SUBTITLE": {
      "HEADER_STORE": "Liste des magasins liés à {recyclerCenterLinkName}"
    },
    "TITLE": {
      "HEADER": "Détail d'une liaison centre de recyclage/magasin",
      "SUB_HEADER": "Centre de recyclage/magasin"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "ID": "ID",
      "NAME": "Nom",
      "RECYCLER_CENTER": "Centre de recyclage",
      "RECYCLER": "Recycleur",
      "ADDRESS": "Adresse",
      "NETWORK": "Réseau"
    },
    "STORE": {
      "TITLE": {
        "STORE_LINKED": "Magasins liés"
      },
      "TABLE": {
        "BOOMERANG_ID": "ID",
        "NETWORK": "Réseau",
        "GROUP": "Groupement",
        "STORE_NAME": "Nom",
        "CONTACT_EMAIL": "Email contact",
        "PHONE_NUMBER": "Téléphone",
        "FOLDER_STATS": "Nombre de dossier",
        "ZONE": "Zone"
      },
      "MODAL": {
        "TITLE": "Supprimer la liaison avec un magasin",
        "MESSAGE": "Voulez-vous vraiment supprimer la liaison avec le magasin {store}?",
        "WARNING": "Cette action est irréversible."
      },
      "MESSAGE": {
        "SUCCESS_DELETED": "La liaison a été supprimée avec succès"
      }
    }
  },
  "RECONDITIONER_PAGE": {
    "TABLE": {
      "ID": "ID",
      "NAME": "Nom",
      "RECONDITIONER_CENTER_COUNT": "Nombre de centres"
    },
    "MODAL": {
      "TITLE": "Suppression d’un reconditionneurs",
      "MESSAGE": "Attention, la suppression d'un reconditionneur entraînera la suppression de tous ses centres de reconditionnement ainsi que l'ensemble des liaisons les concernant avec les magasins et/ou BAC. Voulez-vous vraiment supprimer {reconditioner}?",
      "WARNING": "Cette action est irréversible."
    },
    "MESSAGE": {
      "SUCCESS_DELETED": "Le reconditionneur a été supprimé avec succès"
    }
  },
  "CREATE_RECONDITIONER_PAGE": {
    "TITLE": {
      "HEADER": "Ajouter un reconditionneur",
      "SUBTITLE": "Formulaire d'ajout d'un reconditionneur"
    },
    "FORM": {
      "RECONDITIONER_INFO": "Informations générales",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'ajout d'un reconditionneur"
    },
    "MESSAGE": {
      "SUCCESS": "Le reconditionneur a été ajouté avec succès",
      "ERROR": "Impossible d'ajouter le reconditionneur"
    },
    "PLACEHOLDER": {
      "ID": "Ex : B123456",
      "NAME": "Ex : Atelier Reconditionnement"
    }
  },
  "DETAIL_RECONDITIONER_PAGE": {
    "SUBTITLE": {
      "HEADER_RECONDITIONER_CENTER_LIST": "Liste des centres reconditionneurs rattachés à {reconditionerName}"
    },
    "TITLE": {
      "HEADER": "Détail d'un reconditionneur",
      "SUB_HEADER": "Reconditionneur",
      "RECONDITIONER_CENTER_LIST": "Centres reconditionneurs"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "ID": "ID",
      "NAME": "Nom"
    },
    "TABLE": {
      "BOOMERANG_ID": "ID",
      "NAME": "Nom",
      "CITY": "Ville",
      "EMAIL_CONTACT": "Email contact"
    },
    "MODAL": {
      "TITLE": "Suppression d’un centre reconditionneur",
      "MESSAGE": "Attention la suppression d'un centre reconditionneur entrainera également la suppression de ses liaisons avec un magasin. Voulez-vous vraiment supprimer {reconditionerCenter}?",
      "WARNING": "Cette action est irréversible."
    },
    "BUTTON": {
      "NEW_REPAIR_CENTER": "Ajouter un centre reconditionneur"
    },
    "MESSAGE": {
      "SUCCESS_DELETED": "Le centre reconditionneur a été supprimé avec succès"
    }
  },
  "EDIT_RECONDITIONER_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'un reconditionneur",
      "SUBTITLE": "Formulaire d'édition d'un reconditionneur"
    },
    "FORM": {
      "RECONDITIONER_INFO": "Informations générales",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'édition du reconditionneur"
    },
    "MESSAGE": {
      "SUCCESS": "Le reconditionneur a été modifié avec succès",
      "ERROR": "Impossible de modifier le reconditionneur"
    },
    "PLACEHOLDER": {
      "NAME": "Ex : Atelier Reconditionnement"
    }
  },
  "CREATE_RECONDITIONER_CENTER_PAGE": {
    "TITLE": {
      "HEADER": "Ajouter un centre reconditionneur",
      "SUBTITLE": "Formulaire d'ajout d'un centre reconditionneur"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "CONTACT": "Contact",
      "BAC_DETAIL": "Détail BAC"
    },
    "FORM": {
      "LABEL_RECONDITIONER": "Reconditionneur",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom",
      "LABEL_ADDRESS_NUMBER": "Numéro d'adresse postale",
      "LABEL_ADDRESS_STREET": "Rue",
      "LABEL_ADDRESS_COMPLEMENT": "Complément d'adresse",
      "LABEL_ADDRESS_ZIP_CODE": "Code postal",
      "LABEL_ADDRESS_CITY": "Ville",
      "LABEL_ADDRESS_COUNTRY": "Pays",
      "LABEL_CONTACT_EMAIL": "Email de contact",
      "LABEL_COLLECT_EMAIL": "Email enlèvement",
      "LABEL_PHONE_NUMBER": "Téléphone",
      "LABEL_BAC_COMMENT": "Commentaire",
      "LABEL_BAC_SELECT": "Sélection du bac"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'ajout d'un centre reconditionneur"
    },
    "MESSAGE": {
      "SUCCESS": "Le centre reconditionneur a été ajouté avec succès",
      "ERROR": "Impossible d'ajouter le centre reconditionneur"
    },
    "PLACEHOLDER": {
      "ID": "Ex : B123456",
      "NAME": "Ex : Atelier Reconditionnement",
      "ADDRESS_NUMBER": "Ex : 12",
      "ADDRESS_STREET": "Ex : Rue de la Paix",
      "ADDRESS_COMPLEMENT": "Ex : 12 rue de la Paix",
      "ADDRESS_ZIP_CODE": "Ex : 75001",
      "ADDRESS_CITY": "Ex : Paris",
      "ADDRESS_COUNTRY": "Ex : France",
      "CONTACT_EMAIL": "Ex : contact{'@'}exemple.fr",
      "COLLECT_EMAIL": "Ex : contact{'@'}exemple.fr",
      "PHONE_NUMBER": "Ex : 01 23 45 67 89",
      "BAC_SELECT": "Sélectionner un bac",
      "BAC_COMMENT": "Ajouter un commentaire utile"
    }
  },
  "EDIT_RECONDITIONER_CENTER_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'un centre reconditionneur",
      "SUBTITLE": "Formulaire d'édition d'un centre reconditionneur"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "CONTACT": "Contact",
      "BAC_DETAIL": "Détail BAC"
    },
    "FORM": {
      "LABEL_RECONDITIONER": "Reconditionneur",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom",
      "LABEL_ADDRESS_NUMBER": "Numéro d'adresse postale",
      "LABEL_ADDRESS_STREET": "Rue",
      "LABEL_ADDRESS_COMPLEMENT": "Complément d'adresse",
      "LABEL_ADDRESS_ZIP_CODE": "Code postal",
      "LABEL_ADDRESS_CITY": "Ville",
      "LABEL_ADDRESS_COUNTRY": "Pays",
      "LABEL_CONTACT_EMAIL": "Email de contact",
      "LABEL_COLLECT_EMAIL": "Email enlèvement",
      "LABEL_PHONE_NUMBER": "Téléphone",
      "LABEL_BAC_COMMENT": "Commentaire",
      "LABEL_BAC_SELECT": "Sélection du bac"
    },
    "BUTTON": {
      "VALIDATE": "Valider l'édition du centre reconditionneur"
    },
    "MESSAGE": {
      "SUCCESS": "Le centre reconditionneur a été modifié avec succès",
      "ERROR": "Impossible de modifier le centre reconditionneur"
    },
    "PLACEHOLDER": {
      "NAME": "Ex : Atelier Reconditionnement",
      "ADDRESS_NUMBER": "Ex : 12",
      "ADDRESS_STREET": "Ex : Rue de la Paix",
      "ADDRESS_COMPLEMENT": "Ex : 12 rue de la Paix",
      "ADDRESS_ZIP_CODE": "Ex : 75001",
      "ADDRESS_CITY": "Ex : Paris",
      "ADDRESS_COUNTRY": "Ex : France",
      "CONTACT_EMAIL": "Ex : contact{'@'}exemple.fr",
      "COLLECT_EMAIL": "Ex : contact{'@'}exemple.fr",
      "PHONE_NUMBER": "Ex : 01 23 45 67 89",
      "BAC_SELECT": "Sélectionner un bac",
      "BAC_COMMENT": "Ajouter un commentaire utile"
    }
  },
  "DETAIL_RECONDITIONER_CENTER_PAGE": {
    "SUBTITLE": {
      "HEADER_RECONDITIONER_CENTER_LINK": "Liste des liaisons centre reconditionneur/magasin rattachées à {reconditionerCenterName}"
    },
    "TITLE": {
      "HEADER": "Détail d'un centre reconditionneur",
      "SUB_HEADER": "Centre reconditionneur",
      "RECONDITIONER_CENTER_LINK": "Liaison centre reconditionneur/magasin"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "ID": "ID",
      "NAME": "Nom",
      "RECONDITIONER": "Reconditionneur",
      "ADDRESS": "Adresse",
      "CONTACT": "Contact",
      "CONTACT_EMAIL": "Email de contact",
      "COLLECT_EMAIL": "Email d'enlèvement",
      "PHONE_NUMBER": "Téléphone",
      "BAC": "Détail du BAC",
      "BAC_ID": "ID",
      "BAC_NAME": "Nom",
      "BAC_THRESHOLD": "Seuil de remplissage",
      "BAC_COMMENT": "Commentaire"
    },
    "BUTTON": {
      "NEW_LINK_TO_STORE": "Ajouter une liaison"
    },
    "TABLE": {
      "BOOMERANG_ID": "ID",
      "NAME": "Nom",
      "STORE_COUNT": "Nombre de magasin"
    },
    "MODAL": {
      "TITLE": "Supprimer la liaison",
      "MESSAGE": "Voulez-vous vraiment supprimer la liaison {reconditionerCenterLink}?",
      "WARNING": "Cette action est irréversible."
    },
    "MESSAGE": {
      "SUCCESS_DELETED": "La liaison a été supprimée avec succès"
    }
  },
  "CREATE_RECONDITIONER_CENTER_LINK_PAGE": {
    "TITLE": {
      "HEADER": "Liaison centre reconditionneur/magasins",
      "SUB_HEADER": "Centre reconditionneur",
      "STORE_LINKED": "Magasins liés"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "ID": "ID",
      "NAME": "Nom",
      "RECONDITIONER": "Reconditionneur",
      "ADDRESS": "Adresse",
      "CONTACT": "Contact",
      "CONTACT_EMAIL": "Email de contact",
      "COLLECT_EMAIL": "Email d'enlèvement",
      "PHONE_NUMBER": "Téléphone",
      "LINK_RECONDITIONER_CENTER_STORE": "Liaison centre reconditionneur/magasins",
      "BAC": "Détail du BAC",
      "BAC_ID": "ID",
      "BAC_NAME": "Nom",
      "BAC_THRESHOLD": "Seuil de remplissage",
      "BAC_COMMENT": "Commentaire"
    },
    "FORM": {
      "LABEL_NETWORK": "Réseau",
      "LABEL_STORE": "Magasin",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom",
      "OTHERS": "autres",
      "OTHER": "autre",
      "LABEL_REGION_CODE": "Zone"
    },
    "PLACEHOLDER": {
      "NETWORK": "Sélectionner le réseau",
      "REGION_CODE": "Sélectionner un code région",
      "STORE": "Sélectionner le magasin",
      "ID": "Ex : B123456",
      "NAME": "Ex : Atelier Reconditionnement"
    },
    "BUTTON": {
      "VALIDATE": "Valider la liaison"
    },
    "MESSAGE": {
      "SUCCESS": "Liaison ajoutée avec succès."
    }
  },
  "EDIT_RECONDITIONER_CENTER_LINK_PAGE": {
    "TITLE": {
      "HEADER": "Édition d'une liaison centre reconditionneur/magasin",
      "SUB_HEADER": "Formulaire d'une liaison centre reconditionneur/magasin"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "ID": "ID",
      "NAME": "Nom",
      "RECONDITIONER": "Reconditionneur",
      "ADDRESS": "Adresse",
      "CONTACT": "Contact",
      "CONTACT_EMAIL": "Email de contact",
      "COLLECT_EMAIL": "Email d'enlèvement",
      "PHONE_NUMBER": "Téléphone",
      "LINK_RECONDITIONER_CENTER_STORE": "Liaison centre reconditionneur/magasins",
      "BAC": "Détail du BAC",
      "BAC_ID": "ID",
      "BAC_NAME": "Nom",
      "BAC_THRESHOLD": "Seuil de remplissage",
      "BAC_COMMENT": "Commentaire"
    },
    "FORM": {
      "LABEL_NETWORK": "Réseau",
      "LABEL_STORE": "Magasin",
      "LABEL_ID": "ID",
      "LABEL_NAME": "Nom",
      "OTHERS": "autres",
      "OTHER": "autre",
      "LABEL_REGION_CODE": "Zone"
    },
    "PLACEHOLDER": {
      "NETWORK": "Sélectionner le réseau",
      "REGION_CODE": "Sélectionner un code région",
      "STORE": "Sélectionner le magasin",
      "NAME": "Ex : Atelier Reconditionnement"
    },
    "BUTTON": {
      "VALIDATE": "Modifier la liaison"
    },
    "MESSAGE": {
      "SUCCESS": "Liaison modifiée avec succès."
    }
  },
  "DETAIL_RECONDITIONER_CENTER_LINK_PAGE": {
    "SUBTITLE": {
      "HEADER_STORE": "Liste des magasins liés à {reconditionerCenterLinkName}"
    },
    "TITLE": {
      "HEADER": "Détail d'une liaison centre reconditionneur/magasin",
      "SUB_HEADER": "Centre reconditionneur/magasin"
    },
    "LABEL": {
      "GENERAL_INFO": "Information générales",
      "ID": "ID",
      "NAME": "Nom",
      "RECONDITIONER_CENTER": "Centre reconditionneur",
      "RECONDITIONER": "Reconditionneur",
      "ADDRESS": "Adresse",
      "NETWORK": "Réseau"
    },
    "STORE": {
      "TITLE": {
        "STORE_LINKED": "Magasins liés"
      },
      "TABLE": {
        "BOOMERANG_ID": "ID",
        "NETWORK": "Réseau",
        "GROUP": "Groupement",
        "STORE_NAME": "Nom",
        "CONTACT_EMAIL": "Email contact",
        "PHONE_NUMBER": "Téléphone",
        "FOLDER_STATS": "Nombre de dossier",
        "ZONE": "Zone"
      },
      "MODAL": {
        "TITLE": "Supprimer la liaison avec un magasin",
        "MESSAGE": "Voulez-vous vraiment supprimer la liaison avec le magasin {store}?",
        "WARNING": "Cette action est irréversible."
      },
      "MESSAGE": {
        "SUCCESS_DELETED": "La liaison a été supprimée avec succès"
      }
    }
  },
  "RECYCLING_BAC_PAGE": {
    "TABLE": {
      "ID": "ID",
      "DESIGNATION": "Désignation"
    },
    "MODAL": {
      "TITLE": "Suppression d’un Bac",
      "MESSAGE": "Voulez-vous vraiment supprimer {bac}?",
      "WARNING": "Cette action est irréversible."
    },
    "MESSAGE": {
      "SUCCESS_DELETED": "Le bac a été supprimé avec succès"
    }
  },
  "REPAIR_FILE_STEP_FINALIZATION": {
    "TITLE": "Dernières étapes du dossier {internal_command_number}",
    "SUB_TITLE": {
      "SHARE": "1. Partager les informations du dossier avec :",
      "TRACKING_NUMBER": "2. Mémoriser/identifier des éléments liés au transport (Nº dossier/tracking)",
      "PRINT": "3. Imprimer les éléments pour le réparateur"
    },
    "CHECKBOX": {
      "CLIENT_SHARE": "Avec le client :",
      "PREPARER_SHARE": "Avec le préparateur logistique :",
      "COMMERCIAL_SHARE": "Avec équipe commerciale :"
    },
    "PLACEHOLDER": {
      "REPAIRER_SUPPORT_NUMBER": "N° de dossier du réparateur"
    },
    "BUTTON": {
      "REPAIRER_PRINT_1": "Documents pour Réparateur",
      "REPAIRER_PRINT_2": " (ODR/Étiquette Transports)",
      "VALIDATION": "Déclencher le suivi du dossier",
      "BACK": "Terminer plus tard"
    },
    "TOOLTIP": {
      "DOCUMENTS": "Action 1 : Imprimer le pdf \"Documents pour réparateur\" et mettez TOUS les éléments dans le colis.\nSANS FACTURE dans le colis, le produit ne pourra pas être considéré sous GARANTIE",
      "VALIDATION": "Action 2 : Cliquez sur “Déclencher le suivi du dossier” pour activer le suivi transport et finaliser la demande."
    }
  },
  "OTHER_PAGES": {
    "CHRONOPOST": {
      "TITLE": "Chronopost action manuelle",
      "CHECK_FILE_TITLE": "Forcer la vérification du tracking Chronopost",
      "CHECK_FILE_BUTTON": "Forcer la vérification",
      "CHECK_FILE_SUCCESS": "Lancement de la vérification des fichiers effectué"
    }
  },
  "REPAIR_FILE_UPDATE_STATUS_PAGE": {
    "TITLE": "Mise à jour des statuts des dossiers de réparation",
    "IMPORT": {
      "LABEL": "Importer le fichier de statut à modifier",
      "TEXT": "Choisir un fichier à importer"
    },
    "MODEL": {
      "LABEL": "Modèle",
      "TEXT": "Afin d'importer les données vous devez respecter le modèle disponible sur la plateforme",
      "DOWNLOAD": "Télécharger un modèle"
    }
  },
  "REGION_CODE_LIST_PAGE": {
    "ACTIONS": {
      "ACTIVE": "Désactiver la région",
      "CREATE": "Nouvelle région",
      "INACTIVE": "Activer la région",
      "UPDATE": "Mettre à jour la région"
    },
    "HEADERS": {
      "ACTIONS": "Actions",
      "COUNTRY_NAME": "Nom du pays",
      "COUNTRY_CODE": "Code pays",
      "REGION_NAME": "Nom de la région",
      "REGION_CODE": "Code région",
      "STATUS": "Statut"
    },
    "STATUS_MODAL": {
      "MESSAGE": {
        "ACTIVE": "Voulez-vous désactiver {region} ?",
        "INACTIVE": "Voulez-vous activer {region} ?"
      },
      "TOASTS": {
        "SUCCESS": {
          "ACTIVE": "{region} désactivée avec succès",
          "INACTIVE": "{region} activée avec succès"
        }
      },
      "TITLE": {
        "ACTIVE": "Désactiver la région",
        "INACTIVE": "Activer la région"
      },
      "WARNING": "Avant de désactiver une région, assurez-vous qu'elle n'est plus associée à aucune entité. Si la région est encore utilisée, une erreur se produira et l'opération échouera."
    },
    "TITLE": "Liste des régions"
  },
  "REGION_CODE_CREATE_PAGE": {
    "ACTIONS": {
      "SUBMIT": "Valider l'ajout de la région"
    },
    "FORM": {
      "REGION_INFO": "Informations de la région"
    },
    "HEADERS": {
      "SUBTITLE": "Formulaire d'ajout d'une région",
      "TITLE": "Nouvelle région"
    },
    "LABELS": {
      "COUNTRY_NAME": "Pays (le code pays sera crée automatiquement)",
      "REGION_CODE": "Code la région",
      "REGION_NAME": "Région"
    },
    "PLACEHOLDERS": {
      "COUNTRY_NAME": "Ex: FRANCE",
      "REGION_CODE": "Ex: 69",
      "REGION_NAME": "Ex: RHÔNE"
    },
    "TOASTS": {
      "SUCCESS": "Région ajoutée avec succès"
    }
  },
  "REGION_CODE_UPDATE_PAGE": {
    "ACTIONS": {
      "SUBMIT": "Valider la modification de la région"
    },
    "FORM": {
      "REGION_INFO": "Informations de la région"
    },
    "HEADERS": {
      "SUBTITLE": "Formulaire de modification d'une région",
      "TITLE": "Édition d'une région"
    },
    "LABELS": {
      "COUNTRY_NAME": "Pays (le code pays sera crée automatiquement)",
      "REGION_CODE": "Code la région",
      "REGION_NAME": "Région"
    },
    "PLACEHOLDERS": {
      "COUNTRY_NAME": "Ex: FRANCE",
      "REGION_CODE": "Ex: 69",
      "REGION_NAME": "Ex: RHÔNE"
    },
    "TOASTS": {
      "SUCCESS": "Région modifiée avec succès"
    }
  },
  "KEY_ACCOUNT_PRODUCT_PAGE": {
    "TITLE": "Gestion du parc produit",
    "SUBTITLE": "Liste de tout les parcs produits grands comptes",
    "TAB": {
      "PRODUCTS": "Produits",
      "REQUESTS": "Demandes de création"
    },
    "FILTER": {
      "PURCHASE_DATE_START": "Date d'achat à partir du",
      "PURCHASE_DATE_END": "Date d'achat jusqu'au",
      "MANUFACTURING_DATE_START": "Date de fabrication à partir du",
      "MANUFACTURING_DATE_END": "Date de fabrication jusqu'au"
    },
    "PLACEHOLDER": {
      "KEY_ACCOUNT_NETWORK": "Sélectionner le réseau grand compte",
      "OPERATING_CENTER": "Sélectionner le centre d'exploitation",
      "ALLOCATION_CODE": "Code d'imputation"
    },
    "TABLE": {
      "PHOTO": "Photo",
      "ALLOCATION_CODE": "Code d'imputation",
      "COMPANY_NAME": "Entreprise",
      "TEAM_NAME": "Équipe",
      "PURCHASE_DATE": "Date d'achat",
      "USAGE_START_DATE": "Date de début d'utilisation",
      "PRODUCT_NAME": "Nom du produit",
      "GROUP_NAME": "Groupement",
      "OPERATING_CENTER": "Nom du centre",
      "SERIAL_NUMBER": "Nº de série",
      "USAGE_DURATION": "Durée d'usage",
      "USAGE_DURATION_DAY": "{value} jour",
      "USAGE_DURATION_DAYS": "{value} jours",
      "USAGE_DURATION_MONTH": "{value} mois",
      "USAGE_DURATION_MONTHS": "{value} mois",
      "USAGE_DURATION_YEAR": "{value} an",
      "USAGE_DURATION_YEARS": "{value} ans"
    },
    "BUTTON": {
      "CREATE": "Créer un produit"
    },
    "MESSAGE": {
      "UPDATE_SUCCESS": "Le produit a été modifié avec succès",
      "EXPORT_SUCCESS": "L'export du parc produit a été effectué et sera envoyé par mail"
    }
  },
  "KEY_ACCOUNT_PRODUCT_REQUEST_DRAFT_PAGE": {
    "TITLE": "Demandes de création",
    "SUBTITLE": "Demandes de création de parcs produits grands comptes à traiter",
    "REFERENCE": "REQ-{id}",
    "PLACEHOLDER": {
      "STATUS": "Sélectionner le statut"
    },
    "TABLE": {
      "ID": "Demande",
      "KEY_ACCOUNT_NETWORK": "Réseau grand compte",
      "OPERATING_CENTER": "Centre d'exploitation",
      "REQUESTER": "Demandeur",
      "NAMEPLATE_COUNT": "Plaques",
      "STATUS": "Statut",
      "CREATED_AT": "Date de demande"
    }
  },
  "KEY_ACCOUNT_PRODUCT_REQUEST_DRAFT_REVIEW_PAGE": {
    "TITLE": "Traiter la demande {reference}",
    "SUBTITLE": "{operatingCenter} • Demandé par {requester} le {date}",
    "PLATE_TITLE": "Plaque {current} / {total}",
    "THUMBNAIL_LABEL": "Plaque {current} sur {total} : {status}",
    "PRODUCT_TITLE": "Produit {current} / {total}",
    "STATUS": {
      "TODO": "Informations à saisir",
      "COMPLETED": "Terminé localement",
      "EXCLUDED": "Plaque exclue"
    },
    "BUTTON": {
      "VIEW_INVOICE": "Voir la facture d'achat",
      "DENY": "Refuser",
      "RETRY": "Réessayer",
      "AWAIT_INFORMATION": "Demander des informations",
      "SAVE_AWAITING_INFORMATION": "Mettre en attente",
      "VALIDATE_AND_NEXT": "Valider & suivant",
      "SUBMIT": "Soumettre",
      "EXCLUDE_NAMEPLATE": "Exclure cette plaque",
      "RESTORE_NAMEPLATE": "Réintégrer cette plaque"
    },
    "INVOICE_OVERLAY": {
      "TITLE": "Facture d'achat",
      "UNSUPPORTED": "Aperçu indisponible pour ce type de fichier"
    },
    "FOOTER": {
      "PLATE_PROGRESS": "Plaque {current} / {total}",
      "COMPLETED": "{count} sur {total} terminés"
    },
    "DENY_MODAL": {
      "TITLE": "Refuser la demande",
      "REASON": "Motif du refus",
      "SEND_EMAIL": "Envoyer un email au demandeur"
    },
    "AWAIT_INFORMATION_MODAL": {
      "TITLE": "Mettre la demande en attente",
      "DETAIL": "Informations complémentaires demandées",
      "SEND_EMAIL": "Envoyer un email au demandeur"
    },
    "MESSAGE": {
      "DENIED": "La demande a été refusée avec succès",
      "LOAD_ERROR": "Impossible de charger la demande.",
      "AWAITING_INFORMATION": "La demande a été mise en attente avec succès",
      "APPROVED": "La demande a été approuvée avec succès",
      "EXCLUDED_NAMEPLATE": "Cette plaque est exclue de la validation.",
      "ALL_NAMEPLATES_EXCLUDED": "Au moins une plaque doit être conservée pour soumettre la demande."
    }
  },
  "KEY_ACCOUNT_PRODUCT_CREATE_PAGE": {
    "TITLE": "Créer un parc produit",
    "SUBTITLE": "Ajouter un produit au parc grand compte",
    "SECTION": {
      "PRODUCT_SCOPE": "Périmètre produit",
      "USAGE": "Informations d'usage"
    },
    "FORM": {
      "KEY_ACCOUNT_NETWORK": "Réseau grand compte",
      "OPERATING_CENTER": "Centre d'exploitation",
      "DISTRIBUTOR_NETWORK": "Réseau distributeur",
      "STORE": "Magasin",
      "MANUFACTURER": "Fabricant",
      "CATEGORY": "Catégorie",
      "SUB_CATEGORY": "Sous-catégorie",
      "PRODUCT": "Produit",
      "ALLOCATION_CODE": "Code d'imputation",
      "COMPANY_NAME": "Entreprise",
      "TEAM_NAME": "Équipe",
      "PURCHASE_DATE": "Date d'achat",
      "USAGE_START_DATE": "Date de début d'utilisation",
      "MANUFACTURING_DATE": "Date de fabrication",
      "SERIAL_NUMBER": "Nº de série",
      "NAMEPLATE_ATTACHMENT": "Plaque signalétique",
      "PURCHASE_INVOICE_ATTACHMENT": "Facture d'achat",
      "ATTACHMENT_PREVIEW": "Aperçu"
    },
    "PLACEHOLDER": {
      "KEY_ACCOUNT_NETWORK": "Sélectionner le réseau grand compte",
      "OPERATING_CENTER": "Sélectionner le centre d'exploitation",
      "DISTRIBUTOR_NETWORK": "Sélectionner le réseau distributeur",
      "STORE": "Sélectionner le magasin",
      "MANUFACTURER": "Sélectionner le fabricant",
      "CATEGORY": "Sélectionner la catégorie",
      "SUB_CATEGORY": "Sélectionner la sous-catégorie",
      "PRODUCT": "Sélectionner le produit",
      "ALLOCATION_CODE": "Ex : IMP-001",
      "COMPANY_NAME": "Ex : Boomerang",
      "TEAM_NAME": "Ex : Maintenance",
      "PURCHASE_DATE": "JJ/MM/AAAA",
      "USAGE_START_DATE": "JJ/MM/AAAA",
      "MANUFACTURING_DATE": "JJ/MM/AAAA",
      "SERIAL_NUMBER": "Ex : SN123456789",
      "NAMEPLATE_ATTACHMENT_INPUT": "Ajouter la plaque signalétique",
      "PURCHASE_INVOICE_ATTACHMENT_INPUT": "Ajouter la facture d'achat"
    },
    "BUTTON": {
      "SUBMIT": "Valider l'ajout d'un produit"
    },
    "MESSAGE": {
      "SUCCESS": "Le produit a été créé avec succès"
    },
    "ERROR": {
      "NO_SERIAL_NUMBER_FORMAT": "Aucun format de numéro de série n'a été trouvé pour ce produit."
    }
  },
  "KEY_ACCOUNT_PRODUCT_DETAIL_PAGE": {
    "TITLE": "Détail du parc produit",
    "SUBTITLE": "{productName} - {boomerangId}",
    "SECTION": {
      "PRODUCT_SCOPE": "Périmètre produit",
      "USAGE": "Informations d'usage",
      "ATTACHMENTS": "Pièces jointes"
    },
    "LABEL": {
      "BOOMERANG_ID": "Identifiant parc",
      "CUSTOMER_INVOICE_ID": "Identifiant facture client",
      "KEY_ACCOUNT_NETWORK": "Réseau grand compte",
      "OPERATING_CENTER": "Centre d'exploitation",
      "DISTRIBUTOR_NETWORK": "Réseau distributeur",
      "STORE": "Magasin",
      "MANUFACTURER": "Fabricant",
      "CATEGORY": "Catégorie",
      "SUB_CATEGORY": "Sous-catégorie",
      "PRODUCT": "Produit",
      "ALLOCATION_CODE": "Code d'imputation",
      "COMPANY_NAME": "Entreprise",
      "TEAM_NAME": "Équipe",
      "PURCHASE_DATE": "Date d'achat",
      "USAGE_START_DATE": "Date de début d'utilisation",
      "MANUFACTURING_DATE": "Date de fabrication",
      "SERIAL_NUMBER": "Nº de série",
      "USAGE_DURATION": "Durée d'usage"
    },
    "BUTTON": {
      "NAMEPLATE_ATTACHMENT": "Ouvrir la plaque signalétique",
      "PURCHASE_INVOICE_ATTACHMENT": "Ouvrir la facture d'achat",
      "ADD_PURCHASE_INVOICE": "Ajouter la facture d'achat"
    },
    "MESSAGE": {
      "PURCHASE_INVOICE_UPDATED": "Facture d'achat ajoutée."
    },
    "PURCHASE_INVOICE_MODAL": {
      "TITLE": "Ajouter la facture d'achat",
      "SUBTITLE": "Un seul fichier - PDF ou image",
      "DROPZONE_TITLE": "Cliquez ou déposez votre facture",
      "ACCEPTED_FORMATS": "PDF, JPG, PNG, WEBP",
      "TAKE_PHOTO": "Prendre une photo",
      "VALIDATE": "Ajouter la facture"
    }
  },
  "KEY_ACCOUNT_PRODUCT_UPDATE_PAGE": {
    "TITLE": "Modifier un parc produit",
    "SUBTITLE": "Modifier les informations d'usage et les pièces jointes",
    "SECTION": {
      "PRODUCT_SCOPE": "Périmètre produit",
      "USAGE": "Informations d'usage"
    },
    "FORM": {
      "KEY_ACCOUNT_NETWORK": "Réseau grand compte",
      "OPERATING_CENTER": "Centre d'exploitation",
      "DISTRIBUTOR_NETWORK": "Réseau distributeur",
      "STORE": "Magasin",
      "MANUFACTURER": "Fabricant",
      "CATEGORY": "Catégorie",
      "SUB_CATEGORY": "Sous-catégorie",
      "PRODUCT": "Produit",
      "ALLOCATION_CODE": "Code d'imputation",
      "COMPANY_NAME": "Entreprise",
      "TEAM_NAME": "Équipe",
      "PURCHASE_DATE": "Date d'achat",
      "USAGE_START_DATE": "Date de début d'utilisation",
      "MANUFACTURING_DATE": "Date de fabrication",
      "SERIAL_NUMBER": "Nº de série",
      "NAMEPLATE_ATTACHMENT": "Plaque signalétique",
      "PURCHASE_INVOICE_ATTACHMENT": "Facture d'achat",
      "ATTACHMENT_PREVIEW": "Aperçu"
    },
    "PLACEHOLDER": {
      "OPERATING_CENTER": "Sélectionner le centre d'exploitation",
      "ALLOCATION_CODE": "Ex : IMP-001",
      "COMPANY_NAME": "Ex : Boomerang",
      "TEAM_NAME": "Ex : Maintenance",
      "PURCHASE_DATE": "JJ/MM/AAAA",
      "USAGE_START_DATE": "JJ/MM/AAAA",
      "MANUFACTURING_DATE": "JJ/MM/AAAA",
      "SERIAL_NUMBER": "Ex : SN123456789",
      "NAMEPLATE_ATTACHMENT_INPUT": "Remplacer la plaque signalétique",
      "PURCHASE_INVOICE_ATTACHMENT_INPUT": "Remplacer la facture d'achat"
    },
    "BUTTON": {
      "SUBMIT": "Valider la modification",
      "CURRENT_PURCHASE_INVOICE": "Ouvrir la facture actuelle"
    },
    "MESSAGE": {
      "SUCCESS": "Le produit a été modifié avec succès"
    }
  },
  "REPAIRER_RELAUNCH_RESPONSE": {
    "STATUS_CHOICES": {
      "NOT_RECEIVED": "Nous n'avons pas reçu ce produit",
      "PENDING_DIAGNOSIS": "Le produit est en cours de diagnostique",
      "AWAITING_APPROVAL": "Nous avons envoyé un devis au magasin et sommes dans l'attente de la décision",
      "AWAITING_PARTS": "Nous avons commandé les pièces et sommes en attente de leur réception",
      "RETURNED_FROM_WORKSHOP": "Le produit a été réparé et est parti de notre atelier",
      "REPLACED": "Un produit d'échange a été commandé et va vous être livré",
      "OTHER": "Autres / ou commentaire libre"
    },
    "FORM": {
      "DATE_LABEL": "Ce dossier est à ce statut depuis le : ",
      "COMMENT_LABEL": "Avez-vous un commentaire à indiquer au magasin ?",
      "ATTACHMENT_LABEL": "Souhaitez-vous associer un devis ?",
      "SUBMIT_BUTTON": "Informer le magasin",
      "SEND_COPY_CHECKBOX": "Si cette case est cochée, ces informations seront envoyées sur votre email"
    },
    "SUCCESS": {
      "TITLE": "Merci pour votre retour !",
      "MESSAGE": "Vos informations ont bien été transmises au magasin."
    },
    "ERROR": {
      "TITLE": "Lien expiré ou invalide",
      "MESSAGE": "Ce lien n'est plus valide. Veuillez contacter le support si vous avez besoin d'assistance."
    },
    "PLACEHOLDER": {
      "COMMENT": "Ajouter un commentaire utile"
    }
  }
}
